export const translations = {
  Swedish: {
    menu_home: "Hem",
    menu_search: "Sök",
    menu_inbox: "Min Inkorg",
    menu_saved: "Sparat",
    menu_watches: "Mina Bevakningar",
    menu_logout: "Logga ut",
    
    home_welcome: "God morgon",
    home_new_user_title: "Välkommen! Låt oss sätta upp din första bevakning.",
    home_user_title: "Här är din forskningsöversikt idag.",
    home_robot_title: "Så här fungerar det",
    home_robot_desc: "Sätt upp bevakningar på dina favoritämnen, så läser och sammanfattar vår AI den senaste forskningen åt dig varje natt.",
    home_step1_title: "1. Skapa bevakning",
    home_step1_desc: "Skriv in ett ämne, en författare eller en specifik tidskrift du vill följa.",
    home_step2_title: "2. AI sammanfattar",
    home_step2_desc: "Varje natt letar assistenten efter nya artiklar och skriver korta sammanfattningar.",
    home_step3_title: "3. Läs i inkorgen",
    home_step3_desc: "Spara de artiklar du vill läsa senare och kasta resten med ett klick.",
    home_btn_create: "Skapa din första bevakning",
    home_stat_inbox: "Inkorg",
    home_stat_articles: "Olästa artiklar",
    home_stat_unread: "Olästa",
    home_action_read: "Gå till inkorgen",
    home_stat_assistants: "Assistenter",
    home_stat_active: "Aktiva",
    home_action_manage: "Hantera bevakningar",
    home_stat_library: "Bibliotek",
    home_stat_saved: "Sparade",
    home_action_open: "Öppna biblioteket",
    home_quick_title: "Nytt forskningsämne?",
    home_quick_desc: "Sätt upp en ny AI-bevakning på under en minut.",
    home_btn_new: "Ny bevakning",

    topics_title: "Ge din assistent ett uppdrag",
    topics_subtitle: "Skriv in vad du letar efter. Vi bevakar thousands av tidskrifter.",
    topics_ai_title: "Låt AI hitta de bästa sökorden",
    topics_ai_desc: "Beskriv vad du är intresserad av med egna ord (på svenska eller engelska), så översätter vi det till vetenskapliga söktermer.",
    topics_ai_placeholder: "T.ex: Jag vill veta hur mikrosömn påverkar inlärning hos barn...",
    topics_ai_thinking: "Tänker...",
    topics_ai_suggest: "Föreslå",
    topics_search_label: "Sökning",
    topics_search_placeholder: "T.ex. 'CRISPR' eller 'AI AND healthcare'",
    topics_add_btn: "Lägg till",
    topics_quick_picks: "Snabba val",
    topics_filter_title: "Avgränsa sökningen",
    topics_filter_open: "Öppna",
    topics_author_label: "Sök specifik författare",
    topics_author_placeholder: "T.ex. 'Stephen Hawking'",
    topics_search_btn: "Sök",
    topics_change_btn: "Ändra",
    topics_journal_label: "Sök specifik tidskrift",
    topics_journal_placeholder: "T.ex. 'Nature' eller 'Lancet'",
    topics_date_label: "Tidsperiod (Testkörning)",
    topics_date_from: "Från",
    topics_date_to: "Till",
    topics_apply_filter: "Använd filter",
    topics_test_btn: "Testkör",
    topics_save_btn: "Aktivera Assistent",
    topics_ai_error: "Kunde inte generera sökord just nu. Försök igen.",
    
    topic_ai: "Artificiell Intelligens",
    topic_climate: "Klimatförändringar",
    topic_oncology: "Onkologi",
    topic_pedagogy: "Pedagogik",
    topic_quantum: "Kvantfysik",

    inbox_mark_read: "Markera läst",
    inbox_delete: "Radera",
    inbox_new: "Nytt",
    inbox_delete_permanent: "Radera permanent",
    inbox_mark_as_read: "Markera som läst",
    inbox_unknown_author: "Okänd författare",
    inbox_unknown_journal: "Okänd tidskrift",
    inbox_published: "Publicerad",
    inbox_ai_summary: "AI Sammanfattning",
    inbox_read_original: "Läs originalet",
    inbox_archive: "Arkivera",
    inbox_title: "Min Inkorg",
    inbox_subtitle: "Här är din dagliga sammanställning från den automatiska bevakningen.",
    inbox_refresh: "Uppdatera",
    inbox_empty_title: "Inga nya uppdrag just nu!",
    inbox_empty_desc: "Din forskningsassistent har levererat allt för idag. Ta en kaffe och reflekterar över dina fynd.",
    inbox_btn_new: "+ Starta en ny bevakning",
    inbox_unread_singular: "oläst artikel",
    inbox_unread_plural: "olästa artiklar",

    watches_empty_title: "Inga aktiva assistenter",
    watches_empty_desc: "Du har inte gett din AI några uppdrag ännu.",
    watches_title: "Mina Bevakningar",
    watches_subtitle: "Här är dina aktiva AI-assistenter som söker nätet åt dig varje natt.",
    watches_delete: "Radera assistent",
    watches_status_active: "Aktiv",
    watches_btn_edit: "Redigera & Testkör",

    saved_title: "Sparade Artiklar",
    saved_subtitle: "Dina handplockade guldklimpar från AI Workbench.",
    saved_refresh: "Uppdatera",
    saved_empty: "Du har inte sparat några artiklar än.",
    saved_delete: "Ta bort",
    saved_unknown_author: "Okänd författare",
    saved_unknown_journal: "Okänd tidskrift",
    saved_ai_summary: "AI Sammanfattning",
    saved_read_original: "Läs originalet",

    topics_country_label: "Geografi / Land",
    topics_country_all: "Alla länder (Globalt)",

    summaries_fetching: "Hämtar och analyserar data...",
    summaries_ai_analysis: "AI Analys",
    summaries_processing: "Skapar sammanfattning...",

    topics_country_placeholder: "Välj land för att lägga till...",
    topics_region_nordic: "Norden",
    topics_region_weurope: "Västeuropa",
    topics_region_seurope: "Sydeuropa",
    topics_region_namerica: "Nordamerika",
    topics_region_asia: "Asien",
    
    topics_difficulty_label: "Nivå på sammanfattning",
    topics_diff_public: "Allmänhet",
    topics_diff_student: "Entusiast",
    topics_diff_expert: "Expert",

    // --- STRÄNGAR FÖR AFFÄRSREGLER OCH DÖRRVAKT ---
    usage_limit_reached: "Du har nått din gräns på {max} testkörningar för din nivå ({tier}).",
    usage_error: "Kunde inte verifiera kontostatus.",
    save_watch_trial_blocked: "Som Trial-användare kan du inte spara bevakningar. Uppgradera till Basic eller Premium!",
    save_watch_limit_reached: "Taket är nått! Din nivå ({tier}) tillåter max {max} bevakningar.",
    save_watch_journal_limit_reached: "Taket för tidskrifter är nått! Din nivå ({tier}) tillåter bara {max} bevakning med specifik tidskrift.",
    save_watch_fetch_error: "Ett fel uppstod vid kontroll av konto.",
    save_watch_error: "Kunde inte spara.",
    save_watch_success: "Bevakning sparad!",
    error_select_criteria: "Välj en författare, tidskrift, ämne eller land först.",
    error_limit_reached_generic: "Du har nått din sökgräns. Uppgradera för att göra fler sökningar.",
    error_no_abstracts: "Inga artiklar med sammanfattning (abstract) hittades.",
    error_generic: "Ett oväntat fel inträffade.",
    error_save_article_failed: "Kunde inte spara artikeln.",
    inbox_group_other: "Övrigt",
    error_auth_required: "Autentiseringsfel: Du måste vara inloggad för att generera en sammanfattning.",
    watch_title_countries: "Länder: ",
    watch_title_fallback: "Namnlös bevakning",
    watch_author_prefix: "Författare: ",
    watch_search_default: "Sökning",
    summary_no_text: "Ingen sammanfattning tillgänglig.",
    saved_unknown_title: "Okänd titel",
    saved_from_inbox_topic: "Sparad från Inkorg",
    error_archive_failed: "Kunde inte arkivera artikeln: ",
    card_blurred_placeholder: "Denna studie undersöker de underliggande mekanismerna och dess effekt...",
    card_quota_title: "Månadspotten är slut",
    card_quota_desc_desktop: "Du har använt alla {maxLimit} AI-summeringar för den här månaden. Uppgradera för att fortsätta få djupa analyser direkt i inkorgen.",
    card_quota_desc_mobile: "Du har använt alla {maxLimit} summeringar. Uppgradera för att fortsätta.",
    card_quota_btn: "Visa prenumerationer",
    home_onboarding_heading: "Missa aldrig ett genombrott igen.",
    home_onboarding_desc: "Vi bevakar tusentals publikationer världen över. Berätta vad du är intresserad av så levererar vår AI anpassade, sammanfattade insikter till din Science Monitor-inkorg varje morgon.",
    home_onboarding_step1_title: "Definiera ditt fokus",
    home_onboarding_step1_desc: "Skapa en assistent genom att ange sökord, författare eller ämnen du vill bevaka.",
    home_onboarding_step2_title: "AI börjar arbeta",
    home_onboarding_step2_desc: "Medan du sover söker vår AI i globala databaser, hittar exakta matchningar och sammanfattar de viktigaste resultaten.",
    home_onboarding_step3_title: "Starta dagen på rätt sätt",
    home_onboarding_step3_desc: "Öppna inkorgen med morgonkaffet. Svep åt höger för att markera som läst och åt vänster för att radera.",
    home_onboarding_btn_create: "Skapa din första AI-assistent",
    inbox_total: "totalt",
    login_subtitle: "Logga in för att hantera dina forskningsbevakningar och se dina personliga AI-analyser.",
    login_google: "Fortsätt med Google",
    login_apple: "Fortsätt med Apple",
    login_terms_prefix: "Genom att fortsätta godkänner du våra ",
    login_terms_link: "Användarvillkor",
    login_terms_and: " och vår ",
    login_privacy_link: "Integritetspolicy",
    portal_login_required: "Du måste vara inloggad för att hantera din prenumeration.",
    portal_error: "Serverfel ({status})",
    portal_customer_not_found: "Ingen Stripe-kund hittades för detta konto.",
    portal_no_url: "Ingen URL returnerades från Stripe.",
    portal_opening: "Öppnar...",
    portal_btn_manage: "Hantera prenumeration",
    offline_title: "Ingen internetanslutning",
    offline_description: "Appen behöver en aktiv internetanslutning för att hämta den senaste forskningen. Kontrollera nätverksinställningarna.",
    offline_waiting: "Väntar på nätverk...",
    paywall_checkout_error: "Kunde inte starta betalningen. Försök igen.",
    paywall_checkout_unexpected_error: "Ett oväntat fel uppstod vid betalningen.",
    paywall_back: "Tillbaka",
    paywall_quota_reached_badge: "Månadskvoten är nådd",
    paywall_tier_basic: "Science Monitor Basic",
    paywall_unlock_title: "Lås upp full tillgång",
    paywall_quota_desc: "Du har använt alla 775 AI-genererade forskningssammanfattningar som ingår i din plan den här månaden. Kvoten återställs automatiskt den första dagen nästa månad.",
    paywall_trial_desc: "Din provperiod eller dina inkluderade sökningar har tagit slut. Prenumerera för att låsa upp automatisk vetenskaplig bevakning och omfattande AI-sammanfattningar.",
    paywall_standard_plan: "Standardplan",
    paywall_monthly_sub: "Månadsprenumeration",
    paywall_price_amount: "25 SEK",
    paywall_price_suffix: "/ månad (inkl. moms)",
    paywall_feature_summaries: "Upp till 775 automatiska AI-sammanfattningar per månad (upp till 5 per natt och bevakning)",
    paywall_feature_watches: "Skapa upp till 5 anpassade forskningsbevakningar",
    paywall_feature_saved: "Obegränsad permanent åtkomst till ditt bibliotek med sparade artiklar",
    paywall_feature_cancel: "Avsluta när som helst via kontoinställningarna",
    paywall_opening_checkout: "Öppnar betalning...",
    paywall_btn_manage: "Hantera prenumeration",
    paywall_btn_subscribe: "Prenumerera nu – 25 SEK / månad",
    paywall_back_home: "Tillbaka till startsidan",
    paywall_renewal_notice: "Prenumerationen förnyas automatiskt varje månad tills den avslutas.",
    paywall_agree_notice: "Genom att prenumerera godkänner du våra ",
    paywall_terms_link: "Användarvillkor",
    paywall_and: " och ",
    paywall_privacy_link: "Integritetspolicy",
    common_back: "Tillbaka",
    privacy_title: "Integritetspolicy (Privacy Policy)",
    privacy_updated: "Senast uppdaterad: 22 september 2026",
    summaries_header: "AI Workbench",
    summaries_btn_saved: "Sparad",
    summaries_btn_save: "Spara",
    country_se: "Sverige",
    country_no: "Norge",
    country_dk: "Danmark",
    country_fi: "Finland",
    country_gb: "Storbritannien",
    country_de: "Tyskland",
    country_fr: "Frankrike",
    country_nl: "Nederländerna",
    country_be: "Belgien",
    country_ch: "Schweiz",
    country_at: "Österrike",
    country_ie: "Irland",
    country_es: "Spanien",
    country_it: "Italien",
    country_pt: "Portugal",
    country_us: "USA",
    country_ca: "Kanada",
    country_in: "Indien",
    country_cn: "Kina",
    country_jp: "Japan",
    country_option_se: "Sverige (Sweden)",
    country_option_no: "Norge (Norway)",
    country_option_dk: "Danmark (Denmark)",
    country_option_fi: "Finland",
    country_option_gb: "Storbritannien (UK)",
    country_option_de: "Tyskland (Germany)",
    country_option_fr: "Frankrike (France)",
    country_option_nl: "Nederländerna (Netherlands)",
    country_option_be: "Belgien (Belgium)",
    country_option_ch: "Schweiz (Switzerland)",
    country_option_at: "Österrike (Austria)",
    country_option_ie: "Irland (Ireland)",
    country_option_es: "Spanien (Spain)",
    country_option_it: "Italien (Italy)",
    country_option_pt: "Portugal",
    country_option_us: "USA",
    country_option_ca: "Kanada (Canada)",
    country_option_in: "Indien (India)",
    country_option_cn: "Kina (China)",
    country_option_jp: "Japan",
    terms_title: "Användarvillkor (Terms of Service)",
    terms_updated: "Senast uppdaterad: 22 september 2026",
    openalex_no_institution: "Ingen institution angiven",
    openalex_no_publisher: "Ingen utgivare angiven",
    checkout_login_required: "Du måste vara inloggad för att starta en prenumeration.",
    checkout_failed: "Kunde inte starta betalningen.",
   
paywall_title: "Lås upp full tillgång",
paywall_description: "Din provperiod eller dina inkluderade testkörningar har tagit slut. Prenumerera för att fortsätta ta emot automatiska forskningssammanfattningar utan begränsningar.",
paywall_purchase_error: "Köpet kunde inte genomföras. Var god försök igen.",
paywall_loading: "Laddar prenumerationsalternativ...",
paywall_popular_badge: "Populärast",
paywall_plan_name: "Månadsprenumeration",
paywall_month_suffix: "mån",
paywall_cancel_anytime: "Säg upp när som helst via dina kontoinställningar.",
paywall_no_packages: "Inga prenumerationspaket tillgängliga för tillfället.",
paywall_processing: "Bearbetar...",
paywall_subscribe_button: "Prenumerera nu",
paywall_renewal_terms: "Prenumerationen förnyas automatiskt om den inte sägs upp minst 24 timmar innan den aktuella perioden löper ut.",
  
// --- Institution & Avdelning ---
  topics_institution_label: 'Lärosäte / Universitet / Sjukhus',
  topics_institution_placeholder: 'T.ex. Uppsala University eller Karolinska Institutet...',
  topics_dept_label: 'Specifik institution / avdelning (valfritt)',
  topics_dept_placeholder: 'T.ex. Molekylär medicin, Immunologi eller Kemi...',
  topics_dept_hint: 'Begränsar sökningen till artiklar där författarens affiliering innehåller denna avdelning.',
offline_pill_label: 'Offlineläge:',
offline_pill_desc: 'Visar sparade artiklar och inkorg.',
offline_reconnected: 'Ansluten igen — synkroniserar...',
inbox_group_test_runs: '🧪 Manuella testsökningar',
inbox_paused_title: 'Dina bevakningar är pausade (20/20 sammanfattningar)',
  topics_paused_desc: 'Du har nått gränsen för provperioden. Uppgradera till Basic för att fortsätta skapa nya bevakningar och köra provsökningar.',
  inbox_paused_btn: 'Återaktivera med Basic (25 kr/mån)',
 
  // Onboarding & LoginView
  login_badge_verified: 'Öppen och verifierad vetenskap',
  login_tagline: 'Demokratiserad forskning på ditt språk',
  login_hero_badge: 'Forskningsöversikt på 30 sekunder',
  login_hero_headline: 'Världens forskning. Begriplig varje morgon.',
  login_hero_title1: 'Världens forskning.',
  login_hero_title2: 'Begriplig varje morgon.',
  login_hero_desc: 'Vi scannar öppna vetenskapliga arkiv och sammanfattar nya rön på ren svenska – anpassat efter din nivå och dina intressen.',
  login_hero_cta: 'Få sammanfattningar som denna varje morgon',
  login_trust_free_trial: 'Gratis att prova',
  login_trust_no_card: 'Inget betalkort krävs',
  login_trust_14_days: '14 dagars fri provperiod',
  login_card_ai_summary: 'AI-Sammanfattning',
  login_card_read_original: 'Läs originalstudie på Nature',
  login_card_peer_reviewed: 'Fackgranskad forskning',
  login_summary_heading_summary: 'Sammanfattning',
  login_summary_heading_context: 'Större sammanhang',
  login_summary_heading_results: 'Nyckelresultat',
  login_explore_label: 'Populära fält:',
  login_topic_quantum: 'Kvantfysik',
  login_topic_literature: 'Litteraturvetenskap',
  login_topic_immunology: 'Immunologi',
  login_topic_astrobiology: 'Astrobiologi',
  login_topic_marine_bio: 'Marinbiologi',
  login_topic_climate: 'Klimatforskning',
  login_feature_lang_title: 'Ditt hemspråk direkt',
  login_feature_lang_desc: 'Internationella forskningsartiklar översätts och syntetiseras automatiskt till naturlig och begriplig text på det språk du föredrar att läsa på.',
  login_feature_curious_title: 'För den vetgirige',
  login_feature_curious_desc: 'Välj nivån "Allmänhet" och slipp akademiska termer. Få kärnan och varför upptäckten spelar roll för världen på 30 sekunder.',
  login_feature_pro_title: 'För specialisten',
  login_feature_pro_desc: 'Bevaka specifika författare, lärosäten eller länder med teknisk täthet och orörda statistiska parametrar.',
  login_card_title: 'Börja utforska gratis',
  login_card_subtitle: 'Sätt upp din första bevakning på under 1 minut. Ingen bindningstid, inget kreditkort.',
  login_apple_tip: '💡 Tips: Välj "Dela e-postadress" för att ta emot morgonuppdateringar via e-post.',
  login_trial_point1: '14 dagars kostnadsfri provperiod ingår',
  login_trial_point2: 'Upp till 20 sammanfattningar i provperioden',
  login_trial_point3: 'Morgonmejl bara när nya artiklar hittas',
  login_footer_copy: 'Science Monitor. Verifierad forskning tillgänglig för alla.',
  login_footer_terms: 'Villkor',
  login_footer_privacy: 'Integritet',

  about_title: 'Om Science Monitor',
  about_subtitle: 'Democratizing peer-reviewed science for curious minds and specialists alike.',
  about_mission_title: 'Our Mission',
  about_mission_desc: 'Every day, thousands of groundbreaking scientific discoveries are published across global repositories. Yet, most of this knowledge remains locked behind dense academic jargon, language barriers, and fragmented databases. Science Monitor was created to bridge this gap — making authentic, peer-reviewed science accessible, structured, and readable for everyone.',
  about_founder_title: 'Behind Science Monitor',
  about_founder_desc: 'Science Monitor was founded by Fredrik Mokvist, PhD in Chemistry with extensive leadership experience in the pharmaceutical and Life Science sectors. Having navigated both rigorous academic lab environments and commercial clinical landscapes, the platform was born out of a firsthand realization: the world produces invaluable scientific progress every single day, but the tools to follow, understand, and synthesize that research have not kept pace — until now.',
  about_how_title: 'How It Works',
  about_how_desc: 'We monitor open scientific registries across millions of publications daily. When new research matches your defined interests — whether it is quantum mechanics, literature, or targeted clinical therapies — our processing pipeline synthesizes the findings into clean, readable briefings tailored to your chosen complexity level.',
  about_principles_title: 'Core Principles',
  about_p1_title: 'Evidence & Integrity',
  about_p1_desc: 'We exclusively process peer-reviewed academic works. No rumors, no clickbait — only verifiable science with direct links to primary sources.',
  about_p2_title: 'Language Independence',
  about_p2_desc: 'Science is published internationally, but knowledge should be accessible in your native language without awkward manual translation.',
  about_p3_title: 'Privacy by Design',
  about_p3_desc: 'We do not sell personal data, track users across the web, or monetize through advertisements. The platform exists solely to deliver insight.',
  about_contact_title: 'Get in Touch',
  about_contact_desc: 'Have feedback, questions, or ideas for collaboration? Reach out at',
},
  
  English: {
    menu_home: "Home",
    menu_search: "Search",
    menu_inbox: "My Inbox",
    menu_saved: "Saved",
    menu_watches: "My Watches",
    menu_logout: "Log out",
    
    home_welcome: "Good morning",
    home_new_user_title: "Welcome! Let's set up your first watch.",
    home_user_title: "Here is your research overview today.",
    home_robot_title: "How it works",
    home_robot_desc: "Set up watches for your favorite topics, and our AI will read and summarize the latest research for you every night.",
    home_step1_title: "1. Create a watch",
    home_step1_desc: "Enter a topic, an author, or a specific journal you want to follow.",
    home_step2_title: "2. AI summarizes",
    home_step2_desc: "Every night, the assistant looks for new articles and writes short summaries.",
    home_step3_title: "3. Read in your inbox",
    home_step3_desc: "Save the articles you want to read later and discard the rest with one click.",
    home_btn_create: "Create your first watch",
    home_stat_inbox: "Inbox",
    home_stat_articles: "Unread articles",
    home_stat_unread: "Unread",
    home_action_read: "Go to inbox",
    home_stat_assistants: "Assistants",
    home_stat_active: "Active",
    home_action_manage: "Manage watches",
    home_stat_library: "Library",
    home_stat_saved: "Saved",
    home_action_open: "Open library",
    home_quick_title: "New research topic?",
    home_quick_desc: "Set up a new AI watch in under a minute.",
    home_btn_new: "New watch",

    topics_title: "Give your assistant a mission",
    topics_subtitle: "Enter what you are looking for. We monitor thousands of journals.",
    topics_ai_title: "Let AI find the best keywords",
    topics_ai_desc: "Describe what you're interested in using your own words, and we'll translate it into scientific search terms.",
    topics_ai_placeholder: "E.g. I want to know how microsleep affects learning in children...",
    topics_ai_thinking: "Thinking...",
    topics_ai_suggest: "Suggest",
    topics_search_label: "Search",
    topics_search_placeholder: "E.g. 'CRISPR' or 'AI AND healthcare'",
    topics_add_btn: "Add",
    topics_quick_picks: "Quick picks",
    topics_filter_title: "Refine search",
    topics_filter_open: "Open",
    topics_author_label: "Search specific author",
    topics_author_placeholder: "E.g. 'Stephen Hawking'",
    topics_search_btn: "Search",
    topics_change_btn: "Change",
    topics_journal_label: "Search specific journal",
    topics_journal_placeholder: "E.g. 'Nature' or 'Lancet'",
    topics_date_label: "Time period (Test run)",
    topics_date_from: "From",
    topics_date_to: "To",
    topics_apply_filter: "Apply filter",
    topics_test_btn: "Test Run",
    topics_save_btn: "Activate Assistant",
    topics_ai_error: "Could not generate keywords right now. Please try again.",
    
    topic_ai: "Artificial Intelligence",
    topic_climate: "Climate Change",
    topic_oncology: "Oncology",
    topic_pedagogy: "Pedagogy",
    topic_quantum: "Quantum Physics",

    inbox_mark_read: "Mark read",
    inbox_delete: "Delete",
    inbox_new: "New",
    inbox_delete_permanent: "Delete permanently",
    inbox_mark_as_read: "Mark as read",
    inbox_unknown_author: "Unknown author",
    inbox_unknown_journal: "Unknown journal",
    inbox_published: "Published",
    inbox_ai_summary: "AI Summary",
    inbox_read_original: "Read original",
    inbox_archive: "Archive",
    inbox_title: "My Inbox",
    inbox_subtitle: "Here is your daily summary from the automated watch.",
    inbox_refresh: "Refresh",
    inbox_empty_title: "No new updates right now!",
    inbox_empty_desc: "Your research assistant has delivered everything for today. Grab a coffee and reflect on your findings.",
    inbox_btn_new: "+ Start a new watch",
    inbox_unread_singular: "unread article",
    inbox_unread_plural: "unread articles",

    watches_empty_title: "No active assistants",
    watches_empty_desc: "You haven't given your AI any missions yet.",
    watches_title: "My Watches",
    watches_subtitle: "Here are your active AI assistants searching the web for you every night.",
    watches_delete: "Delete assistant",
    watches_status_active: "Active",
    watches_btn_edit: "Edit & Test run",

    saved_title: "Saved Articles",
    saved_subtitle: "Your handpicked nuggets from the AI Workbench.",
    saved_refresh: "Refresh",
    saved_empty: "You haven't saved any articles yet.",
    saved_delete: "Remove",
    saved_unknown_author: "Unknown author",
    saved_unknown_journal: "Unknown journal",
    saved_ai_summary: "AI Summary",
    saved_read_original: "Read original",

    topics_country_label: "Geography / Country",
    topics_country_all: "All countries (Global)",

    summaries_fetching: "Fetching and analyzing data...",
    summaries_ai_analysis: "AI Analysis",
    summaries_processing: "Generating summary...",

    topics_country_placeholder: "Select country to add...",
    topics_region_nordic: "Nordic",
    topics_region_weurope: "Western Europe",
    topics_region_seurope: "Southern Europe",
    topics_region_namerica: "North America",
    topics_region_asia: "Asia",
    
    topics_difficulty_label: "AI Summary Level",
    topics_diff_public: "Public",
    topics_diff_student: "Enthusiast",
    topics_diff_expert: "Expert",

    // --- STRINGS FOR BUSINESS RULES AND MONITOR ---
    usage_limit_reached: "You have reached your limit of {max} test runs for your tier ({tier}).",
    usage_error: "Could not verify account status.",
    save_watch_trial_blocked: "As a Trial user, you cannot save watches. Upgrade to Basic or Premium!",
    save_watch_limit_reached: "Limit reached! Your tier ({tier}) allows a maximum of {max} watches.",
    save_watch_journal_limit_reached: "Journal limit reached! Your tier ({tier}) allows only {max} watch with a specific journal.",
    save_watch_fetch_error: "An error occurred while checking account status.",
    save_watch_error: "Could not save.",
    save_watch_success: "Watch saved!",
    error_select_criteria: "Please select an author, journal, topic, or country first.",
    error_limit_reached_generic: "You have reached your search limit. Please upgrade to make more searches.",
    error_no_abstracts: "No articles with an abstract were found.",
    error_generic: "An unexpected error occurred.",
    error_save_article_failed: "Could not save the article.",
    inbox_group_other: "Other",
    error_auth_required: "Authentication error: You must be logged in to generate a summary.",
    watch_title_countries: "Countries: ",
    watch_title_fallback: "Unnamed watch",
    watch_author_prefix: "Author: ",
    watch_search_default: "Search",
    summary_no_text: "No text available.",
    saved_unknown_title: "Unknown title",
    saved_from_inbox_topic: "Saved from Inbox",
    error_archive_failed: "Could not archive the article: ",
    card_blurred_placeholder: "This study investigates the underlying mechanisms and their effects...",
    card_quota_title: "Monthly quota reached",
    card_quota_desc_desktop: "You have used all {maxLimit} AI summaries for this month. Upgrade to continue receiving in-depth analyses directly in your inbox.",
    card_quota_desc_mobile: "You have used all {maxLimit} summaries. Upgrade to continue.",
    card_quota_btn: "View subscriptions",
    home_onboarding_heading: "Never miss a breakthrough again.",
    home_onboarding_desc: "We monitor thousands of publications globally. You just tell us what you care about, and our AI will deliver tailored, summarized insights right to your Science Monitor inbox every morning.",
    home_onboarding_step1_title: "Define your focus",
    home_onboarding_step1_desc: "Create an 'Assistant' by entering the keywords, authors, or topics you want to monitor.",
    home_onboarding_step2_title: "AI goes to work",
    home_onboarding_step2_desc: "While you sleep, our AI scans global databases, finding exact matches and summarizing the core findings.",
    home_onboarding_step3_title: "Start your day smart",
    home_onboarding_step3_desc: "Open your Inbox with your morning coffee. Swipe right to mark as read, swipe left to delete.",
    home_onboarding_btn_create: "Create your first AI Assistant",
    inbox_total: "total",
    login_subtitle: "Log in to manage your research watches and view your personal AI analyses.",
    login_google: "Continue with Google",
    login_apple: "Continue with Apple",
    login_terms_prefix: "By continuing, you agree to our ",
    login_terms_link: "Terms of Service",
    login_terms_and: " and our ",
    login_privacy_link: "Privacy Policy",
    portal_login_required: "You must be logged in to manage your subscription.",
    portal_error: "Server error ({status})",
    portal_customer_not_found: "No Stripe customer was found for this account.",
    portal_no_url: "No URL was returned from Stripe.",
    portal_opening: "Opening...",
    portal_btn_manage: "Manage subscription",
    offline_title: "No Internet Connection",
    offline_description: "The app requires an active internet connection to fetch the latest research. Please check your network settings.",
    offline_waiting: "Waiting for network...",
    paywall_checkout_error: "Could not initialize checkout. Please try again.",
    paywall_checkout_unexpected_error: "An unexpected error occurred during checkout.",
    paywall_back: "Back",
    paywall_quota_reached_badge: "Monthly Quota Reached",
    paywall_tier_basic: "Science Monitor Basic",
    paywall_unlock_title: "Unlock Full Access",
    paywall_quota_desc: "You have used all 775 AI-generated research summaries included in your plan for this month. Your quota will automatically reset on the 1st of next month.",
    paywall_trial_desc: "Your trial period or included searches have ended. Subscribe to unlock automated scientific monitoring and comprehensive AI research summaries.",
    paywall_standard_plan: "Standard Plan",
    paywall_monthly_sub: "Monthly Subscription",
    paywall_price_amount: "25 SEK",
    paywall_price_suffix: "/ month (incl. VAT)",
    paywall_feature_summaries: "Up to 775 automated AI summaries per month (up to 5/night per watch)",
    paywall_feature_watches: "Create up to 5 customized scientific watches",
    paywall_feature_saved: "Unlimited permanent access to your Saved Articles library",
    paywall_feature_cancel: "Cancel anytime via account settings",
    paywall_opening_checkout: "Opening Checkout...",
    paywall_btn_manage: "Manage Subscription",
    paywall_btn_subscribe: "Subscribe Now – 25 SEK / month",
    paywall_back_home: "Back to Home",
    paywall_renewal_notice: "The subscription automatically renews each month until cancelled.",
    paywall_agree_notice: "By subscribing, you agree to our ",
    paywall_terms_link: "Terms of Service",
    paywall_and: " and ",
    paywall_privacy_link: "Privacy Policy",
    common_back: "Back",
    privacy_title: "Privacy Policy",
    privacy_updated: "Last updated: September 22, 2026",
    summaries_header: "AI Workbench",
    summaries_btn_saved: "Saved",
    summaries_btn_save: "Save",
    country_se: "Sweden",
    country_no: "Norway",
    country_dk: "Denmark",
    country_fi: "Finland",
    country_gb: "United Kingdom",
    country_de: "Germany",
    country_fr: "France",
    country_nl: "Netherlands",
    country_be: "Belgium",
    country_ch: "Switzerland",
    country_at: "Austria",
    country_ie: "Ireland",
    country_es: "Spain",
    country_it: "Italy",
    country_pt: "Portugal",
    country_us: "USA",
    country_ca: "Canada",
    country_in: "India",
    country_cn: "China",
    country_jp: "Japan",
    country_option_se: "Sweden",
    country_option_no: "Norway",
    country_option_dk: "Denmark",
    country_option_fi: "Finland",
    country_option_gb: "United Kingdom",
    country_option_de: "Germany",
    country_option_fr: "France",
    country_option_nl: "Netherlands",
    country_option_be: "Belgium",
    country_option_ch: "Switzerland",
    country_option_at: "Austria",
    country_option_ie: "Ireland",
    country_option_es: "Spain",
    country_option_it: "Italy",
    country_option_pt: "Portugal",
    country_option_us: "USA",
    country_option_ca: "Canada",
    country_option_in: "India",
    country_option_cn: "China",
    country_option_jp: "Japan",
    terms_title: "Terms of Service",
    terms_updated: "Last updated: September 22, 2026",
    openalex_no_institution: "No institution specified",
    openalex_no_publisher: "No publisher specified",
    checkout_login_required: "You must be logged in to start a subscription.",
    checkout_failed: "Could not start checkout.",
    
    paywall_title: "Unlock Full Access",
paywall_description: "Your trial period or included searches have run out. Subscribe to continue receiving automatic research summaries without limits.",
paywall_purchase_error: "The purchase could not be completed. Please try again.",
paywall_loading: "Loading subscription options...",
paywall_popular_badge: "Most Popular",
paywall_plan_name: "Monthly Subscription",
paywall_month_suffix: "mo",
paywall_cancel_anytime: "Cancel anytime in your account settings.",
paywall_no_packages: "No subscription packages available at the moment.",
paywall_processing: "Processing...",
paywall_subscribe_button: "Subscribe Now",
paywall_renewal_terms: "The subscription automatically renews unless canceled at least 24 hours before the current period ends.",
 
// --- Institution & Department ---
  topics_institution_label: 'University / Hospital / Institution',
  topics_institution_placeholder: 'E.g. Uppsala University or Karolinska Institutet...',
  topics_dept_label: 'Specific Department / Faculty (optional)',
  topics_dept_placeholder: 'E.g. Molecular Medicine, Immunology or Chemistry...',
  topics_dept_hint: 'Restricts search to publications where the author affiliation matches this department.', 
offline_pill_label: 'Offline Mode:',
offline_pill_desc: 'Showing cached articles & inbox.',
offline_reconnected: 'Reconnected — syncing...',

inbox_group_test_runs: '🧪 Manual Test Runs',
inbox_paused_title: 'Your watches are paused (20/20 summaries)',
  topics_paused_desc: 'You have reached the trial limit. Upgrade to Basic to create new watches and run test searches.',
  inbox_paused_btn: 'Reactivate with Basic (25 SEK/mo)',
// Onboarding & LoginView
  login_badge_verified: 'Open & verified science',
  login_tagline: 'Democratizing science in your language',
  login_hero_badge: 'Research overview in 30 seconds',
  login_hero_headline: "The world's research. Understandable every morning.",
  login_hero_title1: "The world's research.",
  login_hero_title2: 'Understandable every morning.',
  login_hero_desc: 'We scan open scientific archives and summarize new findings in plain English – tailored to your level and your interests.',
  login_hero_cta: 'Get summaries like this every morning',
  login_trust_free_trial: 'Free to try',
  login_trust_no_card: 'No payment card required',
  login_trust_14_days: '14-day free trial',
  login_card_ai_summary: 'AI Summary',
  login_card_read_original: 'Read original study on Nature',
  login_card_peer_reviewed: 'Peer-reviewed research',
  login_summary_heading_summary: 'Summary',
  login_summary_heading_context: 'Broader context',
  login_summary_heading_results: 'Key results',
  login_explore_label: 'Explore fields:',
  login_topic_quantum: 'Quantum Physics',
  login_topic_literature: 'Literature',
  login_topic_immunology: 'Immunology',
  login_topic_astrobiology: 'Astrobiology',
  login_topic_marine_bio: 'Marine Biology',
  login_topic_climate: 'Climate Science',
  login_feature_lang_title: 'Your native tongue',
  login_feature_lang_desc: 'Scientific papers are synthesized directly into natural summaries in your preferred language without manual translation.',
  login_feature_curious_title: 'For Curious Minds',
  login_feature_curious_desc: 'Select "General Public" level to bypass heavy jargon. Grasp core findings, context, and real-world significance in 30 seconds.',
  login_feature_pro_title: 'For Professionals',
  login_feature_pro_desc: 'Track specific authors, institutions, or countries with rigorous technical density and intact statistical parameters.',
  login_card_title: 'Start exploring for free',
  login_card_subtitle: 'Set up your first research watch in under a minute. No credit card required.',
  login_apple_tip: '💡 Tip: Choose "Share My Email" if you wish to receive daily updates via email.',
  login_trial_point1: '14-day free trial included automatically',
  login_trial_point2: 'Up to 20 synthesized summaries during trial',
  login_trial_point3: 'Morning email updates only when new research is found',
  login_footer_copy: 'Science Monitor. Peer-reviewed science for everyone.',
  login_footer_terms: 'Terms',
  login_footer_privacy: 'Privacy',

about_title: 'About Science Monitor',
  about_subtitle: 'Democratizing peer-reviewed science for curious minds and specialists alike.',
  about_mission_title: 'Our Mission',
  about_mission_desc: 'Every day, thousands of groundbreaking scientific discoveries are published across global repositories. Yet, most of this knowledge remains locked behind dense academic jargon, language barriers, and fragmented databases. Science Monitor was created to bridge this gap — making authentic, peer-reviewed science accessible, structured, and readable for everyone.',
  about_founder_title: 'Behind Science Monitor',
  about_founder_desc: 'Science Monitor was founded by Fredrik Mokvist, PhD in Chemistry with extensive leadership experience in the pharmaceutical and Life Science sectors. Having navigated both rigorous academic lab environments and commercial clinical landscapes, the platform was born out of a firsthand realization: the world produces invaluable scientific progress every single day, but the tools to follow, understand, and synthesize that research have not kept pace — until now.',
  about_how_title: 'How It Works',
  about_how_desc: 'We monitor open scientific registries across millions of publications daily. When new research matches your defined interests — whether it is quantum mechanics, literature, or targeted clinical therapies — our processing pipeline synthesizes the findings into clean, readable briefings tailored to your chosen complexity level.',
  about_principles_title: 'Core Principles',
  about_p1_title: 'Evidence & Integrity',
  about_p1_desc: 'We exclusively process peer-reviewed academic works. No rumors, no clickbait — only verifiable science with direct links to primary sources.',
  about_p2_title: 'Language Independence',
  about_p2_desc: 'Science is published internationally, but knowledge should be accessible in your native language without awkward manual translation.',
  about_p3_title: 'Privacy by Design',
  about_p3_desc: 'We do not sell personal data, track users across the web, or monetize through advertisements. The platform exists solely to deliver insight.',
  about_contact_title: 'Get in Touch',
  about_contact_desc: 'Have feedback, questions, or ideas for collaboration? Reach out at',},
  
  Norwegian: {
    menu_home: "Hjem",
    menu_search: "Søk",
    menu_inbox: "Min innboks",
    menu_saved: "Lagret",
    menu_watches: "Mine overvåkinger",
    menu_logout: "Logg ut",
    home_welcome: "God morgen",
    home_new_user_title: "Velkommen! La oss sette opp din første overvåking.",
    home_user_title: "Her er din forskningsoversikt i dag.",
    home_robot_title: "Slik fungerer det",
    home_robot_desc: "Sett opp overvåking på dine favorittemner, så leser og oppsummerer vår AI den nyeste forskningen for deg hver natt.",
    home_step1_title: "1. Lag overvåking",
    home_step1_desc: "Skriv inn et emne, en forfatter eller et spesifikt tidsskrift du vil følge.",
    home_step2_title: "2. AI oppsummerer",
    home_step2_desc: "Hver natt leter assistenten etter nye artikler og skriver korte oppsummeringer.",
    home_step3_title: "3. Les i innboksen",
    home_step3_desc: "Lagre artiklene du vil lese senere og kast resten med ett klikk.",
    home_btn_create: "Lag din første overvåking",
    home_stat_inbox: "Innboks",
    home_stat_articles: "Uleste artikler",
    home_stat_unread: "Uleste",
    home_action_read: "Gå til innboks",
    home_stat_assistants: "Assistenter",
    home_stat_active: "Aktive",
    home_action_manage: "Administrer overvåkinger",
    home_stat_library: "Bibliotek",
    home_stat_saved: "Lagrede",
    home_action_open: "Åpne biblioteket",
    home_quick_title: "Nytt forskningsemne?",
    home_quick_desc: "Sett opp en ny AI-overvåking på under ett minutt.",
    home_btn_new: "Ny overvåking",
    topics_title: "Gi assistenten din et oppdrag",
    topics_subtitle: "Skriv inn hva du leter etter. Vi overvåker tusenvis av tidsskrifter.",
    topics_ai_title: "La AI finne de beste søkeordene",
    topics_ai_desc: "Beskriv hva du er interessert i med egne ord, så oversetter vi det til vitenskapelige søketermer.",
    topics_ai_placeholder: "F.eks: Jeg vil vite hvordan mikrosøvn påvirker læring hos barn...",
    topics_ai_thinking: "Tenker...",
    topics_ai_suggest: "Foreslå",
    topics_search_label: "Søk",
    topics_search_placeholder: "F.eks. 'CRISPR' eller 'AI AND healthcare'",
    topics_add_btn: "Legg til",
    topics_quick_picks: "Hurtigvalg",
    topics_filter_title: "Avgrens søket",
    topics_filter_open: "Åpne",
    topics_author_label: "Søk spesifikk forfatter",
    topics_author_placeholder: "F.eks. 'Stephen Hawking'",
    topics_search_btn: "Søk",
    topics_change_btn: "Endre",
    topics_journal_label: "Søk spesifikk tidsskrift",
    topics_journal_placeholder: "F.eks. 'Nature' eller 'Lancet'",
    topics_date_label: "Tidsperiode (Testkjøring)",
    topics_date_from: "Fra",
    topics_date_to: "Til",
    topics_apply_filter: "Bruk filter",
    topics_test_btn: "Testkjør",
    topics_save_btn: "Aktiver Assistent",
    topics_ai_error: "Kunne ikke generere søkeord akkurat nå. Prøv igjen.",
    topic_ai: "Kunstig intelligens",
    topic_climate: "Klimaendringer",
    topic_oncology: "Onkologi",
    topic_pedagogy: "Pedagogikk",
    topic_quantum: "Kvantefysikk",
    inbox_mark_read: "Marker lest",
    inbox_delete: "Slett",
    inbox_new: "Nytt",
    inbox_delete_permanent: "Slett permanent",
    inbox_mark_as_read: "Marker som lest",
    inbox_unknown_author: "Ukjent forfatter",
    inbox_unknown_journal: "Ukjent tidsskrift",
    inbox_published: "Publisert",
    inbox_ai_summary: "AI-oppsummering",
    inbox_read_original: "Les original",
    inbox_archive: "Arkiver",
    inbox_title: "Min Innboks",
    inbox_subtitle: "Her er din daglige oppsummering fra automatisk overvåking.",
    inbox_refresh: "Oppdater",
    inbox_empty_title: "Ingen nye oppdateringer!",
    inbox_empty_desc: "Forskningsassistenten din har levert alt for i dag. Ta en kaffe og reflekter over funnene dine.",
    inbox_btn_new: "+ Start en ny overvåking",
    inbox_unread_singular: "ulest artikel",
    inbox_unread_plural: "uleste artikler",
    watches_empty_title: "Ingen aktive assistenter",
    watches_empty_desc: "Du har ikke gitt din AI noen oppdrag ennå.",
    watches_title: "Mine Overvåkinger",
    watches_subtitle: "Her er dine aktive AI-assistenter som søker på nettet for deg hver natt.",
    watches_delete: "Slett assistent",
    watches_status_active: "Aktiv",
    watches_btn_edit: "Rediger & Testkjør",
    saved_title: "Lagrede Artikler",
    saved_subtitle: "Dine håndplukkede gullklumper fra AI-assistenten.",
    saved_refresh: "Oppdater",
    saved_empty: "Du har ikke lagret noen artikler ennå.",
    saved_delete: "Fjern",
    saved_unknown_author: "Ukjent forfatter",
    saved_unknown_journal: "Ukjent tidsskrift",
    saved_ai_summary: "AI-oppsummering",
    saved_read_original: "Les original",
    topics_country_label: "Geografi / Land",
    topics_country_all: "Alle land (Globalt)",
    summaries_fetching: "Henter og analyserer data...",
    summaries_ai_analysis: "AI Analyse",
    summaries_processing: "Lager oppsummering...",
    topics_country_placeholder: "Velg land for å legge til...",
    topics_region_nordic: "Norden",
    topics_region_weurope: "Vest-Europa",
    topics_region_seurope: "Sør-Europa",
    topics_region_namerica: "Nord-Amerika",
    topics_region_asia: "Asien",
    topics_difficulty_label: "Nivå på oppsummering",
    topics_diff_public: "Allmennheten",
    topics_diff_student: "Entusiast",
    topics_diff_expert: "Ekspert",
    usage_limit_reached: "Du har nådd grensen din på {max} testkjøringer for ditt nivå ({tier}).",
    usage_error: "Kunne ikke verifisere kontostatus.",
    save_watch_trial_blocked: "Som Trial-bruker kan du ikke lagre overvåkinger. Oppgrader til Basic eller Premium!",
    save_watch_limit_reached: "Taket er nådd! Ditt nivå ({tier}) tillater maks {max} overvåkinger.",
    save_watch_journal_limit_reached: "Taket for tidsskrifter er nådd! Ditt nivå ({tier}) tillater bare {max} overvåking med spesifikt tidsskrift.",
    save_watch_fetch_error: "Det oppstod en feil under kontroll av kontostatus.",
    save_watch_error: "Kunne ikke lagre.",
    save_watch_success: "Overvåking lagret!",
    error_select_criteria: "Vennligst velg forfatter, tidsskrift, emne eller land først.",
    error_limit_reached_generic: "Du har nådd sökegrensen din. Vennligst oppgrader for flere søk.",
    error_no_abstracts: "Ingen artikler med sammendrag ble funnet.",
    error_generic: "En uventet feil oppstod.",
    error_save_article_failed: "Kunne ikke lagre artikkelen."
  },
  Danish: {
    menu_home: "Hjem",
    menu_search: "Søg",
    menu_inbox: "Min indbakke",
    menu_saved: "Gemt",
    menu_watches: "Mine overvågninger",
    menu_logout: "Log ud",
    home_welcome: "Godmorgen",
    home_new_user_title: "Velkommen! Lad os opsætte din første overvågning.",
    home_user_title: "Her er dit forskningsoverblik i dag.",
    home_robot_title: "Sådan fungerer det",
    home_robot_desc: "Opsæt overvågninger på dine yndlingsemner, så læser og opsummerer vores AI den nyeste forskningen for dig hver nat.",
    home_step1_title: "1. Opret overvågning",
    home_step1_desc: "Indtast et emne, en forfatter eller et specifikt tidsskrift, du vil følge.",
    home_step2_title: "2. AI opsummerer",
    home_step2_desc: "Hver natt leder assistenten efter nye artikler og skriver korte resuméer.",
    home_step3_title: "3. Læs i indbakken",
    home_step3_desc: "Gem de artikler, du vil læse senere, og kasser resten med ét klik.",
    home_btn_create: "Opret din første overvågning",
    home_stat_inbox: "Indbakke",
    home_stat_articles: "Ulæste artikler",
    home_stat_unread: "Ulæste",
    home_action_read: "Gå til indbakke",
    home_stat_assistants: "Assistenter",
    home_stat_active: "Aktive",
    home_action_manage: "Administrer overvågninger",
    home_stat_library: "Bibliotek",
    home_stat_saved: "Gemte",
    home_action_open: "Åbn biblioteket",
    home_quick_title: "Nyt forskningsemne?",
    home_quick_desc: "Opsæt en ny AI-overvågning på under et minut.",
    home_btn_new: "Ny overvågning",
    topics_title: "Giv din assistent en opgave",
    topics_subtitle: "Indtast, hvad du leder efter. Vi overvåker tusindvis af tidsskrifter.",
    topics_ai_title: "Lad AI finde de bedste søgeord",
    topics_ai_desc: "Beskriv, hvad du er interesseret i med egne ord, så oversætter vi det to videnskabelige søgetermer.",
    topics_ai_placeholder: "Fl.eks: Jeg vil vide, hvordan mikrosøvn påvirker indlæring hos børner...",
    topics_ai_thinking: "Tænker...",
    topics_ai_suggest: "Foreslå",
    topics_search_label: "Søgning",
    topics_search_placeholder: "F.eks. 'CRISPR' eller 'AI AND healthcare'",
    topics_add_btn: "Tilføj",
    topics_quick_picks: "Hurtige valg",
    topics_filter_title: "Begræns søgningen",
    topics_filter_open: "Åbn",
    topics_author_label: "Søg specifik forfatter",
    topics_author_placeholder: "F.eks. 'Stephen Hawking'",
    topics_search_btn: "Søg",
    topics_change_btn: "Skift",
    topics_journal_label: "Søg specifikt tidsskrift",
    topics_journal_placeholder: "F.eks. 'Nature' eller 'Lancet'",
    topics_date_label: "Tidsperiode (Testkørsel)",
    topics_date_from: "Fra",
    topics_date_to: "Til",
    topics_apply_filter: "Anvend filter",
    topics_test_btn: "Testkør",
    topics_save_btn: "Aktiver Assistent",
    topics_ai_error: "Kunne ikke generere søgeord lige nu. Prøv igen.",
    topic_ai: "Kunstig intelligens",
    topic_climate: "Klimaforandringer",
    topic_oncology: "Onkologi",
    topic_pedagogy: "Pædagogik",
    topic_quantum: "Kvantefysikk",
    inbox_mark_read: "Marker læst",
    inbox_delete: "Slet",
    inbox_new: "Nyt",
    inbox_delete_permanent: "Slet permanent",
    inbox_mark_as_read: "Marker som læst",
    inbox_unknown_author: "Ukendt forfatter",
    inbox_unknown_journal: "Ukendt tidsskrift",
    inbox_published: "Udgivet",
    inbox_ai_summary: "AI-resumé",
    inbox_read_original: "Læs original",
    inbox_archive: "Arkiver",
    inbox_title: "Min Indbakke",
    inbox_subtitle: "Her er din daglige opsummering fra den automatiske overvågning.",
    inbox_refresh: "Opdater",
    inbox_empty_title: "Ingen nye opdateringer!",
    inbox_empty_desc: "Din forskningsassistent har levereret alt for i dag. Tag en kop kaffe og reflekter over dine fund.",
    inbox_btn_new: "+ Start en ny overvågning",
    inbox_unread_singular: "ulæst artikel",
    inbox_unread_plural: "ulæste artikler",
    watches_empty_title: "Ingen aktive assistenter",
    watches_empty_desc: "Du har ikke givet din AI nogen opgaver endnu.",
    watches_title: "Mine Overvågninger",
    watches_subtitle: "Her er dine aktive AI-assistenter, der søger na nettet for for dig hver nat.",
    watches_delete: "Slet assistent",
    watches_status_active: "Aktiv",
    watches_btn_edit: "Rediger & Testkør",
    saved_title: "Gemte Artikler",
    saved_subtitle: "Dine håndplukkede guldkorn fra AI-assistenten.",
    saved_refresh: "Opdater",
    saved_empty: "Du har ikke gemt nogen artikler endnu.",
    saved_delete: "Fjern",
    saved_unknown_author: "Ukendt forfatter",
    saved_unknown_journal: "Ukendt tidsskrift",
    saved_ai_summary: "AI-resumé",
    saved_read_original: "Læs original",
    topics_country_label: "Geografi / Land",
    topics_country_all: "Alle lande (Globalt)",
    summaries_fetching: "Henter og analyserer data...",
    summaries_ai_analysis: "AI Analyse",
    summaries_processing: "Opretter resumé...",
    topics_country_placeholder: "Välj land for at tilføje...",
    topics_region_nordic: "Norden",
    topics_region_weurope: "Vesteuropa",
    topics_region_seurope: "Sydeuropa",
    topics_region_namerica: "Nordamerika",
    topics_region_asia: "Asien",
    topics_difficulty_label: "Niveau på resumé",
    topics_diff_public: "Offentlighed",
    topics_diff_student: "Entusiast",
    topics_diff_expert: "Ekspert",
    usage_limit_reached: "Du har nået din grænse på {max} testkørsler for dit niveau ({tier}).",
    usage_error: "Kunne ikke verificere kontostatus.",
    save_watch_trial_blocked: "Som Trial-bruger kan du ikke gemme overvågninger. Opgrader til Basic eller Premium!",
    save_watch_limit_reached: "Loftet er nået! Dit niveau ({tier}) tillader maks {max} overvågninger.",
    save_watch_journal_limit_reached: "Loftet for tidsskrifter er nået! Dit niveau ({tier}) tillader kun {max} overvågning med specifikt tidsskrift.",
    save_watch_fetch_error: "Der opstod en fejl under kontrol af kontostatus.",
    save_watch_error: "Kunne ikke gemme.",
    save_watch_success: "Overvågning gemt!",
    error_select_criteria: "Vælg venligst en forfatter, tidsskrift, emne eller land først.",
    error_limit_reached_generic: "Du har nået din søgegrænse. Opgrader venligst for at søge mere.",
    error_no_abstracts: "Ingen artikler med resumé blev fundet.",
    error_generic: "Der opstod en uventet fejl.",
    error_save_article_failed: "Kunne ikke gemme artiklen."
  },
  Finnish: {
    menu_home: "Etusivu",
    menu_search: "Hae",
    menu_inbox: "Saapuneet",
    menu_saved: "Tallennettu",
    menu_watches: "Seurantani",
    menu_logout: "Kirjaudu ulos",
    home_welcome: "Hyvää huomenta",
    home_new_user_title: "Tervetuloa! Luodaan ensimmäinen seurantasi.",
    home_user_title: "Tässä on tutkimuskatsauksesi tänään.",
    home_robot_title: "Näin se toimii",
    home_robot_desc: "Aseta seurannat suosikkiaiheillesi, niin tekoälymme lukee ja tiivistää uusimman tutkimuksen puolestasi joka yö.",
    home_step1_title: "1. Luo seuranta",
    home_step1_desc: "Kirjoita aihe, kirjoittaja tai tietty lehti, jota haluat seurata.",
    home_step2_title: "2. Tekoäly tiivistää",
    home_step2_desc: "Joka yö avustaja etsii uusia artikkeleita ja kirjoittaa lyhyitä tiivistelmiä.",
    home_step3_title: "3. Lue saapuneet-kansiosta",
    home_step3_desc: "Tallenna artikkelit, jotka haluat lukea myöhemmin, ja poista loput yhdellä napsautuksella.",
    home_btn_create: "Luo ensimmäinen seuranta",
    home_stat_inbox: "Saapuneet",
    home_stat_articles: "Lukemattomat artikkelit",
    home_stat_unread: "Lukemattomat",
    home_action_read: "Siirry saapuneisiin",
    home_stat_assistants: "Avustajat",
    home_stat_active: "Aktiiviset",
    home_action_manage: "Hallinnoi seurantoja",
    home_stat_library: "Kirjasto",
    home_stat_saved: "Tallennetut",
    home_action_open: "Avaa kirjasto",
    home_quick_title: "Uusi tutkimusaihe?",
    home_quick_desc: "Aseta uusi tekoälyseuranta alle minuutissa.",
    home_btn_new: "Uusi seuranta",
    topics_title: "Anna avustajallesi tehtävä",
    topics_subtitle: "Kirjoita mitä etsit. Seuraamme tuhansia julkaisuja.",
    topics_ai_title: "Anna tekoälyn löytää parhaat hakusanat",
    topics_ai_desc: "Kuvaile kiinnostuksesi kohteita omin sanoin, niin käännämme ne tieteellisiksi hakutermeiksi.",
    topics_ai_placeholder: "Esim: Haluan tietää, miten mikrouni vaikuttaa lasten oppimiseen...",
    topics_ai_thinking: "Mietitään...",
    topics_ai_suggest: "Ehdotus",
    topics_search_label: "Haku",
    topics_search_placeholder: "Esim. 'CRISPR' tai 'AI AND healthcare'",
    topics_add_btn: "Lisää",
    topics_quick_picks: "Pikavalinnat",
    topics_filter_title: "Rajaa hakua",
    topics_filter_open: "Avaa",
    topics_author_label: "Hae tiettyä kirjailijaa",
    topics_author_placeholder: "Esim. 'Stephen Hawking'",
    topics_search_btn: "Hae",
    topics_change_btn: "Muuta",
    topics_journal_label: "Hae tiettyä lehteä",
    topics_journal_placeholder: "Esim. 'Nature' tai 'Lancet'",
    topics_date_label: "Ajanjakso (Testiajo)",
    topics_date_from: "Alkaen",
    topics_date_to: "Asti",
    topics_apply_filter: "Käytä suodatinta",
    topics_test_btn: "Testiajo",
    topics_save_btn: "Aktivoi avustaja",
    topics_ai_error: "Hakusanojen luonti epäonnistui. Yritä uudelleen.",
    topic_ai: "Tekoäly",
    topic_climate: "Ilmastonmuutos",
    topic_oncology: "Onkologia",
    topic_pedagogy: "Pedagogiikka",
    topic_quantum: "Kvanttifysiikka",
    inbox_mark_read: "Merkitse luetuksi",
    inbox_delete: "Poista",
    inbox_new: "Uusi",
    inbox_delete_permanent: "Poista pysyvästi",
    inbox_mark_as_read: "Merkitse luetuksi",
    inbox_unknown_author: "Tuntematon kirjoittaja",
    inbox_unknown_journal: "Tuntematon lehti",
    inbox_published: "Julkaistu",
    inbox_ai_summary: "Tekoälyn tiivistelmä",
    inbox_read_original: "Lue alkuperäinen",
    inbox_archive: "Arkistoi",
    inbox_title: "Saapuneet",
    inbox_subtitle: "Tässä on päivittäinen yhteenvetosi automaattisesta seurannasta.",
    inbox_refresh: "Päivitä",
    inbox_empty_title: "Ei uusia päivityksiä!",
    inbox_empty_desc: "Tutkimusavustajasi on toimittanut kaiken tälle päivälle. Ota kahvi ja pohdi löydöksiäsi.",
    inbox_btn_new: "+ Aloita uusi seuranta",
    inbox_unread_singular: "lukematon artikkeli",
    inbox_unread_plural: "lukematonta artikkelia",
    watches_empty_title: "Ei aktiivisia avustajia",
    watches_empty_desc: "Et ole vielä antanut tekoälyllesi mitään tehtäviä.",
    watches_title: "Seurantani",
    watches_subtitle: "Tässä ovat aktiiviset tekoälyavustajasi, jotka etsivät verkosta puolestasi joka yö.",
    watches_delete: "Poista avustaja",
    watches_status_active: "Aktiivinen",
    watches_btn_edit: "Muokkaa & Testiaja",
    saved_title: "Tallennetut Artikkelit",
    saved_subtitle: "Käsin poimitut kultajyvät tekoälyavustajalta.",
    saved_refresh: "Päivitä",
    saved_empty: "Et ole vielä tallentanut yhtään artikkelia.",
    saved_delete: "Poista",
    saved_unknown_author: "Tuntematon kirjoittaja",
    saved_unknown_journal: "Tuntematon lehti",
    saved_ai_summary: "Tekoälyn tiivistelmä",
    saved_read_original: "Lue alkuperäinen",
    topics_country_label: "Maantiede / Maa",
    topics_country_all: "Kaikki maat (Globaali)",
    summaries_fetching: "Haetaan ja analysoidaan tietoja...",
    summaries_ai_analysis: "Tekoälyanalyysi",
    summaries_processing: "Luodaan tiivistelmää...",
    topics_country_placeholder: "Valitse lisättävä maa...",
    topics_region_nordic: "Pohjoismaat",
    topics_region_weurope: "Länsi-Eurooppa",
    topics_region_seurope: "Etelä-Eurooppa",
    topics_region_namerica: "Pohjois-Amerikka",
    topics_region_asia: "Aasia",
    topics_difficulty_label: "Tiivistelmän taso",
    topics_diff_public: "Yleisö",
    topics_diff_student: "Harrastaja",
    topics_diff_expert: "Asiantuntija",
    usage_limit_reached: "Olet saavuttanut tasosi mukaisen testiajojen enimmäismäärän ({max}) tasolla ({tier}).",
    usage_error: "Tilin tilaa ei voitu vahvistaa.",
    save_watch_trial_blocked: "Kokeilukäyttäjänä (Trial) et voi tallentaa seurantoja. Päivitä Basic- tai Premium-tasolle!",
    save_watch_limit_reached: "Raja saavutettu! Tasosi ({tier}) sallii enintään {max} seurantaa.",
    save_watch_journal_limit_reached: "Julkaisujen raja saavutettu! Tasosi ({tier}) sallii vain {max} seurannan tietylle lehdelle.",
    save_watch_fetch_error: "Tilin tilaa tarkistettaessa tapahtui virhe.",
    save_watch_error: "Tallennus epäonnistui.",
    save_watch_success: "Seuranta tallennettu!",
    error_select_criteria: "Valitse ensin kirjoittaja, lehti, aihe tai maa.",
    error_limit_reached_generic: "Hakurajasi on täynnä. Päivitä tiliä tehdäksesi lisää hakuja.",
    error_no_abstracts: "Artikkeleita, joissa on tiivistelmä, ei löytynyt.",
    error_generic: "Tapahtui odottamaton virhe.",
    error_save_article_failed: "Artikkelia ei voitu tallentaa."
  },
  Italian: {
    menu_home: "Home",
    menu_search: "Cerca",
    menu_inbox: "La mia posta",
    menu_saved: "Salvato",
    menu_watches: "Le mie ricerche",
    menu_logout: "Esci",
    home_welcome: "Buongiorno",
    home_new_user_title: "Benvenuto! Impostiamo la tua prima ricerca.",
    home_user_title: "Ecco la tua panoramica di ricerca di oggi.",
    home_robot_title: "Come funziona",
    home_robot_desc: "Imposta ricerche per i tuoi argomenti preferiti e la nostra IA leggerà e riassumerà le ultime ricerche per te ogni notte.",
    home_step1_title: "1. Crea ricerca",
    home_step1_desc: "Inserisci un argomento, un autore o una rivista specifica che desideri seguire.",
    home_step2_title: "2. L'IA riassume",
    home_step2_desc: "Ogni notte, l'assistente cerca nuovi articoli e scrive brevi riassunti.",
    home_step3_title: "3. Leggi nella posta",
    home_step3_desc: "Salva gli articoli che vuoi leggere in seguito e scarta il resto con un clic.",
    home_btn_create: "Crea la tua prima ricerca",
    home_stat_inbox: "Posta",
    home_stat_articles: "Articoli non letti",
    home_stat_unread: "Non letti",
    home_action_read: "Vai alla posta",
    home_stat_assistants: "Assistenti",
    home_stat_active: "Attivi",
    home_action_manage: "Gestisci ricerche",
    home_stat_library: "Biblioteca",
    home_stat_saved: "Salvati",
    home_action_open: "Apri biblioteca",
    home_quick_title: "Nuovo argomento di ricerca?",
    home_quick_desc: "Imposta una nuova ricerca IA in meno di un minuto.",
    home_btn_new: "Nuova ricerca",
    topics_title: "Assegna una missione al tuo assistente",
    topics_subtitle: "Inserisci ciò che stai cercando. Monitoriamo migliaia di riviste.",
    topics_ai_title: "Lascia che l'IA trovi le parole chiave migliori",
    topics_ai_desc: "Descrivi ciò che ti interessa con parole tue e noi lo tradurremo in termini di ricerca scientifica.",
    topics_ai_placeholder: "Es: Voglio sapere come il microsonno influisce sull'apprendimento dei bambini...",
    topics_ai_thinking: "Pensando...",
    topics_ai_suggest: "Suggerisci",
    topics_search_label: "Ricerca",
    topics_search_placeholder: "Es. 'CRISPR' o 'AI AND healthcare'",
    topics_add_btn: "Aggiungi",
    topics_quick_picks: "Scelte rapide",
    topics_filter_title: "Raffina la ricerca",
    topics_filter_open: "Opri",
    topics_author_label: "Cerca autore specifico",
    topics_author_placeholder: "Es. 'Stephen Hawking'",
    topics_search_btn: "Cerca",
    topics_change_btn: "Modifica",
    topics_journal_label: "Cerca rivista specifica",
    topics_journal_placeholder: "Es. 'Nature' o 'Lancet'",
    topics_date_label: "Periodo (Test)",
    topics_date_from: "Da",
    topics_date_to: "A",
    topics_apply_filter: "Applica filtro",
    topics_test_btn: "Fai un test",
    topics_save_btn: "Attiva Assistente",
    topics_ai_error: "Impossibile generare le parole chiave al momento. Riprova.",
    topic_ai: "Intelligenza Artificiale",
    topic_climate: "Cambiamento Climatico",
    topic_oncology: "Oncology",
    topic_pedagogy: "Pedagogia",
    topic_quantum: "Fisica Quantistica",
    inbox_mark_read: "Segna letto",
    inbox_delete: "Elimina",
    inbox_new: "Nuovo",
    inbox_delete_permanent: "Elimina definitivamente",
    inbox_mark_as_read: "Segna come letto",
    inbox_unknown_author: "Autore sconosciuto",
    inbox_unknown_journal: "Rivista sconosciuta",
    inbox_published: "Pubblicato",
    inbox_ai_summary: "Riepilogo IA",
    inbox_read_original: "Leggi originale",
    inbox_archive: "Archivia",
    inbox_title: "La mia posta",
    inbox_subtitle: "Ecco il tuo riepilogo quotidiano dal monitoraggio automatico.",
    inbox_refresh: "Aggiorna",
    inbox_empty_title: "Nessun nuovo aggiornamento!",
    inbox_empty_desc: "Il tuo assistente di ricerca ha consegnato tutto per oggi. Prendi un caffè e rifletti sulle tue scoperte.",
    inbox_btn_new: "+ Avvia nuova ricerca",
    inbox_unread_singular: "articolo non letto",
    inbox_unread_plural: "articoli non letti",
    watches_empty_title: "Nessun assistente attivo",
    watches_empty_desc: "Non hai ancora assegnato alcuna missione alla tua IA.",
    watches_title: "Le mie ricerche",
    watches_subtitle: "Ecco i tuoi assistenti IA attivi che cercano sul web per te ogni notte.",
    watches_delete: "Elimina assistente",
    watches_status_active: "Aktiv",
    watches_btn_edit: "Modifica e Testa",
    saved_title: "Articoli Salvati",
    saved_subtitle: "Le tue perle scelte a mano dall'assistente IA.",
    saved_refresh: "Aggiorna",
    saved_empty: "Non hai ancora salvato alcun articolo.",
    saved_delete: "Rimuovi",
    saved_unknown_author: "Autore sconosciuto",
    saved_unknown_journal: "Rivista sconosciuta",
    saved_ai_summary: "Riepilogo IA",
    saved_read_original: "Leggi originale",
    topics_country_label: "Geografia / Paese",
    topics_country_all: "Tutti i paesi (Globale)",
    summaries_fetching: "Recupero e analisi dei dati...",
    summaries_ai_analysis: "Analisi IA",
    summaries_processing: "Creazione del riepilogo...",
    topics_country_placeholder: "Seleziona paese da aggiungere...",
    topics_region_nordic: "Paesi Nordici",
    topics_region_weurope: "Europa Occidentale",
    topics_region_seurope: "Europa Meridionale",
    topics_region_namerica: "Nord America",
    topics_region_asia: "Asia",
    topics_difficulty_label: "Livello del riepilogo",
    topics_diff_public: "Pubblico",
    topics_diff_student: "Appassionato",
    topics_diff_expert: "Esperto",
    usage_limit_reached: "Hai raggiunto il limite di {max} test per il tuo livello ({tier}).",
    usage_error: "Impossibile verificare lo stato dell'account.",
    save_watch_trial_blocked: "Come utente Trial, non puoi salvare le ricerche. Passa a Basic o Premium!",
    save_watch_limit_reached: "Limite raggiunto! Il tuo livello ({tier}) consente un massimo di {max} ricerche.",
    save_watch_journal_limit_reached: "Limite di riviste raggiunto! Il tuo livello ({tier}) consente solo {max} ricerca con una rivista specifica.",
    save_watch_fetch_error: "Si è verificato un errore durante la verifica dello stato dell'account.",
    save_watch_error: "Impossibile salvare.",
    save_watch_success: "Ricerca salvata!",
    error_select_criteria: "Seleziona prima un autore, una rivista, un argomento o un paese.",
    error_limit_reached_generic: "Hai raggiunto il limite di ricerca. Aggiorna l'account per effettuare più ricerche.",
    error_no_abstracts: "Non sono stati trovati articoli con riassunto.",
    error_generic: "Si è verificato un errore imprevisto.",
    error_save_article_failed: "Impossibile salvare l'articolo."
  },
  French: {
    menu_home: "Accueil",
    menu_search: "Recherche",
    menu_inbox: "Ma boîte de réception",
    menu_saved: "Sauvegardé",
    menu_watches: "Mes surveillances",
    menu_logout: "Se déconnecter",
    
    home_welcome: "Bonjour",
    home_new_user_title: "Bienvenue ! Configurons votre première surveillance.",
    home_user_title: "Voici votre aperçu de la recherche aujourd'hui.",
    home_robot_title: "Comment ça marche",
    home_robot_desc: "Configurez des surveillances pour vos sujets préférés, et notre IA lira et résumera pour vous les dernières recherches chaque nuit.",
    home_step1_title: "1. Créer une surveillance",
    home_step1_desc: "Entrez un sujet, un auteur ou une revue spécifique que vous souhaitez suivre.",
    home_step2_title: "2. L'IA résume",
    home_step2_desc: "Chaque nuit, l'assistant recherche de nouveaux articles et rédige de brefs résumés.",
    home_step3_title: "3. Lire dans la boîte de réception",
    home_step3_desc: "Sauvegardez les articles que vous souhaitez lire plus tard et jetez le reste en un clic.",
    home_btn_create: "Créer votre première surveillance",
    home_stat_inbox: "Boîte",
    home_stat_articles: "Articles non lus",
    home_stat_unread: "Non lus",
    home_action_read: "Aller à la boîte",
    home_stat_assistants: "Assistants",
    home_stat_active: "Actifs",
    home_action_manage: "Gérer les surveillances",
    home_stat_library: "Bibliothèque",
    home_stat_saved: "Sauvegardés",
    home_action_open: "Ouvrir la bibliothèque",
    home_quick_title: "Nouveau sujet de recherche ?",
    home_quick_desc: "Configurez une nouvelle surveillance IA en moins d'une minute.",
    home_btn_new: "Nouvelle surveillance",

    topics_title: "Donnez une mission à votre assistant",
    topics_subtitle: "Indiquez ce que vous recherchez. Nous surveillons des milliers de revues.",
    topics_ai_title: "Laissez l'IA trouver les meilleurs mots-clés",
    topics_ai_desc: "Décrivez ce qui vous intéresse avec vos propres mots et nous le traduirons en termes de recherche scientifiques.",
    topics_ai_placeholder: "Ex: Je veux savoir comment le microsommeil affecte l'apprentissage chez les enfants...",
    topics_ai_thinking: "Réflexion...",
    topics_ai_suggest: "Suggérer",
    topics_search_label: "Recherche",
    topics_search_placeholder: "Ex. 'CRISPR' ou 'AI AND healthcare'",
    topics_add_btn: "Ajouter",
    topics_quick_picks: "Choix rapides",
    topics_filter_title: "Affiner la recherche",
    topics_filter_open: "Ouvrir",
    topics_author_label: "Rechercher un auteur spécifique",
    topics_author_placeholder: "Ex. 'Stephen Hawking'",
    topics_search_btn: "Rechercher",
    topics_change_btn: "Modifier",
    topics_journal_label: "Rechercher une revue spécifique",
    topics_journal_placeholder: "Ex. 'Nature' ou 'Lancet'",
    topics_date_label: "Période (Essai)",
    topics_date_from: "De",
    topics_date_to: "À",
    topics_apply_filter: "Appliquer le filtre",
    topics_test_btn: "Essai",
    topics_save_btn: "Activer l'assistant",
    topics_ai_error: "Impossible de générer des mots-clés pour le moment. Veuillez réessayer.",
    
    topic_ai: "Intelligence Artificielle",
    topic_climate: "Changement Climatique",
    topic_oncology: "Oncologie",
    topic_pedagogy: "Pédagogie",
    topic_quantum: "Physique Quantique",

    inbox_mark_read: "Marquer lu",
    inbox_delete: "Supprimer",
    inbox_new: "Nouveau",
    inbox_delete_permanent: "Supprimer définitivement",
    inbox_mark_as_read: "Marquer comme lu",
    inbox_unknown_author: "Auteur inconnu",
    inbox_unknown_journal: "Revue inconnue",
    inbox_published: "Publié",
    inbox_ai_summary: "Résumé IA",
    inbox_read_original: "Lire l'original",
    inbox_archive: "Archiver",
    inbox_title: "Ma boîte de réception",
    inbox_subtitle: "Voici votre résumé quotidien de la surveillance automatique.",
    inbox_refresh: "Actualiser",
    inbox_empty_title: "Pas de nouvelles mises à jour !",
    inbox_empty_desc: "Votre assistant a tout livré pour aujourd'hui. Prenez un café et réfléchissez à vos découvertes.",
    inbox_btn_new: "+ Nouvelle surveillance",
    inbox_unread_singular: "article non lu",
    inbox_unread_plural: "articles non lus",

    watches_empty_title: "Aucun assistant actif",
    watches_empty_desc: "Vous n'avez pas encore confié de mission à votre IA.",
    watches_title: "Mes Surveillances",
    watches_subtitle: "Voici vos assistants IA actifs qui effectuent des recherches pour vous chaque nuit.",
    watches_delete: "Supprimer l'assistant",
    watches_status_active: "Activo",
    watches_btn_edit: "Modifier et Tester",

    saved_title: "Articles Sauvegardés",
    saved_subtitle: "Vos pépites sélectionnées par l'assistant IA.",
    saved_refresh: "Actualiser",
    saved_empty: "Vous n'avez pas encore sauvegardé d'articles.",
    saved_delete: "Supprimer",
    saved_unknown_author: "Auteur inconnu",
    saved_unknown_journal: "Revue inconnue",
    saved_ai_summary: "Résumé IA",
    saved_read_original: "Lire l'original",

    topics_country_label: "Géographie / Pays",
    topics_country_all: "Tous les pays (Mondial)",

    summaries_fetching: "Récupération et analyse des données...",
    summaries_ai_analysis: "Analyse IA",
    summaries_processing: "Création du résumé...",

    topics_country_placeholder: "Sélectionner le pays à ajouter...",
    topics_region_nordic: "Pays Nordiques",
    topics_region_weurope: "Europe de l'Ouest",
    topics_region_seurope: "Europe du Sud",
    topics_region_namerica: "Amérique du Nord",
    topics_region_asia: "Asie",
    
    topics_difficulty_label: "Niveau du résumé",
    topics_diff_public: "Grand public",
    topics_diff_student: "Passionné",
    topics_diff_expert: "Expert",

    // --- NOUVELLES CHAÎNES POUR LES RÈGLES DE GESTION ---
    usage_limit_reached: "Vous avez atteint votre limite de {max} essais pour votre forfait ({tier}).",
    usage_error: "Impossible de vérifier le statut du compte.",
    save_watch_trial_blocked: "En tant qu'utilisateur d'essai, vous ne pouvez pas enregistrer de surveillances. Passez à l'offre Basic ou Premium !",
    save_watch_limit_reached: "Limite atteinte ! Votre forfait ({tier}) permet un maximum de {max} surveillances.",
    save_watch_journal_limit_reached: "Limite de revues atteinte ! Votre forfait ({tier}) ne permet que {max} surveillance avec une revue spécifique.",
    save_watch_fetch_error: "Une erreur est survenue lors de la vérification du statut du compte.",
    save_watch_error: "Impossible d'enregistrer.",
    save_watch_success: "Surveillance enregistrée !",
    error_select_criteria: "Veuillez d'abord sélectionner un auteur, une revue, un sujet ou un pays.",
    error_limit_reached_generic: "Vous avez atteint votre limite de recherche. Veuillez mettre à niveau pour effectuer plus de recherches.",
    error_no_abstracts: "Aucun article avec résumé n'a été trouvé.",
    error_generic: "Une erreur inattendue est survenue.",
    error_save_article_failed: "Impossible d'enregistrer l'article."
  },
  German: {
    menu_home: "Startseite",
    menu_search: "Suche",
    menu_inbox: "Posteingang",
    menu_saved: "Gespeichert",
    menu_watches: "Meine Suchen",
    menu_logout: "Abmelden",
    
    home_welcome: "Guten Morgen",
    home_new_user_title: "Willkommen! Lassen Sie uns Ihre erste Beobachtung einrichten.",
    home_user_title: "Hier ist Ihre Forschungsübersicht heute.",
    home_robot_title: "Wie es funktioniert",
    home_robot_desc: "Richten Sie Beobachtungen für Ihre Lieblingsthemen ein, und unsere KI liest und fasst jede Nacht die neuesten Forschungsergebnisse für Sie zusammen.",
    home_step1_title: "1. Beobachtung erstellen",
    home_step1_desc: "Geben Sie ein Thema, einen Autor oder eine bestimmte Zeitschrift ein, die Sie verfolgen möchten.",
    home_step2_title: "2. KI fasst zusammen",
    home_step2_desc: "Jede Nacht sucht der Assistent nach neuen Artikeln und schreibt kurze Zusammenfassungen.",
    home_step3_title: "3. Im Posteingang lesen",
    home_step3_desc: "Speichern Sie die Artikel, die Sie später lesen möchten, und verwerfen Sie den Rest mit einem Klick.",
    home_btn_create: "Erstellen Sie Ihre erste Beobachtung",
    home_stat_inbox: "Posteingang",
    home_stat_articles: "Ungelesene Artikel",
    home_stat_unread: "Ungelesen",
    home_action_read: "Zum Posteingang gehen",
    home_stat_assistants: "Assistenten",
    home_stat_active: "Aktive",
    home_action_manage: "Beobachtungen verwalten",
    home_stat_library: "Bibliothek",
    home_stat_saved: "Gespeicherte",
    home_action_open: "Bibliothek öffnen",
    home_quick_title: "Neues Forschungsthema?",
    home_quick_desc: "Richten Sie in weniger als einer Minute eine neue KI-Beobachtung ein.",
    home_btn_new: "Neue Beobachtung",

    topics_title: "Geben Sie Ihrem Assistenten eine Aufgabe",
    topics_subtitle: "Geben Sie ein, wonach Sie suchen. Wir überwachen Tausende von Zeitschriften.",
    topics_ai_title: "Lassen Sie KI die besten Schlüsselwörter finden",
    topics_ai_desc: "Beschreiben Sie mit eigenen Worten, was Sie interessiert, und wir übersetzen es in wissenschaftliche Suchbegriffe.",
    topics_ai_placeholder: "Z.B.: Ich möchte wissen, wie sich Mikroschlaf auf das Lernen von Kindern auswirkt...",
    topics_ai_thinking: "Denkt nach...",
    topics_ai_suggest: "Vorschlagen",
    topics_search_label: "Suche",
    topics_search_placeholder: "Z.B. 'CRISPR' oder 'AI AND healthcare'",
    topics_add_btn: "Hinzufügen",
    topics_quick_picks: "Schnellauswahl",
    topics_filter_title: "Suche eingrenzen",
    topics_filter_open: "Öffnen",
    topics_author_label: "Bestimmten Autor suchen",
    topics_author_placeholder: "Z.B. 'Stephen Hawking'",
    topics_search_btn: "Suchen",
    topics_change_btn: "Ändern",
    topics_journal_label: "Bestimmte Zeitschrift suchen",
    topics_journal_placeholder: "Z.B. 'Nature' oder 'Lancet'",
    topics_date_label: "Zeitraum (Testlauf)",
    topics_date_from: "Von",
    topics_date_to: "Bis",
    topics_apply_filter: "Filter anwenden",
    topics_test_btn: "Testlauf",
    topics_save_btn: "Assistenten aktivieren",
    topics_ai_error: "Schlüsselwörter konnten derzeit nicht generiert werden. Bitte versuchen Sie es erneut.",
    
    topic_ai: "Künstliche Intelligenz",
    topic_climate: "Klimawandel",
    topic_oncology: "Onkologie",
    topic_pedagogy: "Pädagogik",
    topic_quantum: "Quantenphysik",

    inbox_mark_read: "Gelesen",
    inbox_delete: "Löschen",
    inbox_new: "Neu",
    inbox_delete_permanent: "Dauerhaft löschen",
    inbox_mark_as_read: "Als gelesen markieren",
    inbox_unknown_author: "Unbekannter Autor",
    inbox_unknown_journal: "Unbekannte Zeitschrift",
    inbox_published: "Veröffentlicht",
    inbox_ai_summary: "KI-Zusammenfassung",
    inbox_read_original: "Original lesen",
    inbox_archive: "Archivieren",
    inbox_title: "Mein Posteingang",
    inbox_subtitle: "Hier ist Ihre tägliche Zusammenfassung aus der automatischen Beobachtung.",
    inbox_refresh: "Aktualisieren",
    inbox_empty_title: "Keine neuen Updates!",
    inbox_empty_desc: "Ihr Forschungsassistent hat für heute alles geliefert. Schnappen Sie sich einen Kaffee und reflektieren Sie Ihre Ergebnisse.",
    inbox_btn_new: "+ Neue Beobachtung starten",
    inbox_unread_singular: "ungelesener Artikel",
    inbox_unread_plural: "ungelesene Artikel",

    watches_empty_title: "Keine aktiven Assistenten",
    watches_empty_desc: "Sie haben Ihrer KI noch keine Aufgaben zugewiesen.",
    watches_title: "Meine Beobachtungen",
    watches_subtitle: "Hier sind Ihre aktiven KI-Assistenten, die jede Nacht für Sie das Web durchsuchen.",
    watches_delete: "Assistent löschen",
    watches_status_active: "Aktiv",
    watches_btn_edit: "Bearbeiten & Testen",

    saved_title: "Gespeicherte Artikel",
    saved_subtitle: "Ihre handverlesenen Nuggets vom KI-Assistenten.",
    saved_refresh: "Aktualisierung",
    saved_empty: "Sie haben noch keine Artikel gespeichert.",
    saved_delete: "Entfernen",
    saved_unknown_author: "Unbekannter Autor",
    saved_unknown_journal: "Unbekannte Zeitschrift",
    saved_ai_summary: "KI-Zusammenfassung",
    saved_read_original: "Original lesen",

    topics_country_label: "Geografie / Land",
    topics_country_all: "Alle Länder (Global)",

    summaries_fetching: "Daten abrufen und analysieren...",
    summaries_ai_analysis: "KI-Analyse",
    summaries_processing: "Zusammenfassung wird erstellt...",

    topics_country_placeholder: "Land zum Hinzufügen auswählen...",
    topics_region_nordic: "Skandinavien",
    topics_region_weurope: "Westeuropa",
    topics_region_seurope: "Südeuropa",
    topics_region_namerica: "Nordamerika",
    topics_region_asia: "Asien",
    
    topics_difficulty_label: "Zusammenfassungsstufe",
    topics_diff_public: "Öffentlichkeit",
    topics_diff_student: "Enthusiast",
    topics_diff_expert: "Experte",

    // --- NEUE STRINGS FÜR GESCHÄFTSREGELN ---
    usage_limit_reached: "Sie haben Ihr Limit von {max} Testläufen für Ihre Stufe ({tier}) erreicht.",
    usage_error: "Kontostatus konnte nicht überprüft werden.",
    save_watch_trial_blocked: "Als Testnutzer können Sie keine Beobachtungen speichern. Bitte upgraden Sie auf Basic oder Premium!",
    save_watch_limit_reached: "Limit erreicht! Ihre Stufe ({tier}) erlaubt maximal {max} Beobachtungen.",
    save_watch_journal_limit_reached: "Zeitschriften-Limit erreicht! Ihre Stufe ({tier}) erlaubt nur {max} Beobachtung mit einer bestimmten Zeitschrift.",
    save_watch_fetch_error: "Beim Überprüfen des Kontostatus ist ein Fehler aufgetreten.",
    save_watch_error: "Konnte nicht gespeichert werden.",
    save_watch_success: "Beobachtung gespeichert!",
    error_select_criteria: "Bitte wählen Sie zuerst einen Autor, eine Zeitschrift, ein Thema oder ein Land aus.",
    error_limit_reached_generic: "Sie haben Ihr Suchlimit erreicht. Bitte upgraden Sie, um weitere Suchen durchzuführen.",
    error_no_abstracts: "Es wurden keine Artikel mit Zusammenfassung gefunden.",
    error_generic: "Ein unerwarteter Fehler ist aufgetreten.",
    error_save_article_failed: "Artikel konnte nicht gespeichert werden."
  },
  Spanish: {
    menu_home: "Inicio",
    menu_search: "Buscar",
    menu_inbox: "Mi Bandeja",
    menu_saved: "Guardado",
    menu_watches: "Mis Vigilancias",
    menu_logout: "Cerrar sesión",
    
    home_welcome: "Buenos días",
    home_new_user_title: "¡Bienvenido! Configuremos tu primera vigilancia.",
    home_user_title: "Aquí está tu resumen de investigación de hoy.",
    home_robot_title: "Cómo funciona",
    home_robot_desc: "Configura vigilancias para tus temas favoritos y nuestra IA leerá y resumirá las últimas investigaciones para ti cada noche.",
    home_step1_title: "1. Crear vigilancia",
    home_step1_desc: "Ingresa un tema, un autor o una revista específica que desees seguir.",
    home_step2_title: "2. La IA resume",
    home_step2_desc: "Cada noche, el asistente busca nuevos artículos y escribe breves resúmenes.",
    home_step3_title: "3. Leer en la bandeja",
    home_step3_desc: "Guarda los artículos que quieras leer más tarde y descarta el resto con un clic.",
    home_btn_create: "Crea tu primera vigilancia",
    home_stat_inbox: "Bandeja",
    home_stat_articles: "Artículos no leídos",
    home_stat_unread: "No leídos",
    home_action_read: "Ir a la bandeja",
    home_stat_assistants: "Asistentes",
    home_stat_active: "Activos",
    home_action_manage: "Gestionar vigilancias",
    home_stat_library: "Biblioteca",
    home_stat_saved: "Guardados",
    home_action_open: "Abrir biblioteca",
    home_quick_title: "¿Nuevo tema de investigación?",
    home_quick_desc: "Configura una nueva vigilancia de IA en menos de un minuto.",
    home_btn_new: "Nueva vigilancia",

    topics_title: "Dale una misión a tu asistente",
    topics_subtitle: "Ingresa lo que buscas. Monitoreamos miles de revistas.",
    topics_ai_title: "Deja que la IA encuentre las mejores palabras clave",
    topics_ai_desc: "Describe lo que te interesa con tus propias palabras y lo traduciremos a términos de búsqueda científicos.",
    topics_ai_placeholder: "Ej: Quiero saber cómo afecta el microsueño al aprendizaje en los niños...",
    topics_ai_thinking: "Pensando...",
    topics_ai_suggest: "Sugerir",
    topics_search_label: "Búsqueda",
    topics_search_placeholder: "Ej. 'CRISPR' o 'AI AND healthcare'",
    topics_add_btn: "Añadir",
    topics_quick_picks: "Selección rápida",
    topics_filter_title: "Refinar búsqueda",
    topics_filter_open: "Abrir",
    topics_author_label: "Buscar autor específico",
    topics_author_placeholder: "Ej. 'Stephen Hawking'",
    topics_search_btn: "Buscar",
    topics_change_btn: "Cambiar",
    topics_journal_label: "Buscar revista específica",
    topics_journal_placeholder: "Ej. 'Nature' o 'Lancet'",
    topics_date_label: "Período (Prueba)",
    topics_date_from: "Desde",
    topics_date_to: "Hasta",
    topics_apply_filter: "Aplicar filtro",
    topics_test_btn: "Probar",
    topics_save_btn: "Activar Asistente",
    topics_ai_error: "No se pudieron generar palabras clave en este momento. Inténtalo de nuevo.",
    
    topic_ai: "Inteligencia Artificial",
    topic_climate: "Cambio Climático",
    topic_oncology: "Oncología",
    topic_pedagogy: "Pedagogía",
    topic_quantum: "Física Cuántica",

    inbox_mark_read: "Marcar leído",
    inbox_delete: "Eliminar",
    inbox_new: "Nuevo",
    inbox_delete_permanent: "Eliminar permanentemente",
    inbox_mark_as_read: "Marcar como leído",
    inbox_unknown_author: "Autor desconocido",
    inbox_unknown_journal: "Revista desconocida",
    inbox_published: "Publicado",
    inbox_ai_summary: "Resumen IA",
    inbox_read_original: "Leer original",
    inbox_archive: "Archivar",
    inbox_title: "Mi Bandeja",
    inbox_subtitle: "Aquí está su resumen diario del monitoreo automático.",
    inbox_refresh: "Actualizar",
    inbox_empty_title: "¡No hay actualizaciones nuevas!",
    inbox_empty_desc: "Tu asistente de investigación ha entregado todo por hoy. Toma un café y reflexiona sobre tus hallazgos.",
    inbox_btn_new: "+ Iniciar nueva vigilancia",
    inbox_unread_singular: "artículo no leído",
    inbox_unread_plural: "artículos no leídos",

    watches_empty_title: "Sin asistentes activos",
    watches_empty_desc: "Aún no le has dado ninguna misión a tu IA.",
    watches_title: "Mis Vigilancias",
    watches_subtitle: "Aquí están tus asistentes de IA activos buscando en la web para ti cada noche.",
    watches_delete: "Eliminar asistente",
    watches_status_active: "Activo",
    watches_btn_edit: "Editar y Probar",

    saved_title: "Artículos Guardados",
    saved_subtitle: "Tus joyas seleccionadas por el asistente de IA.",
    saved_refresh: "Actualizar",
    saved_empty: "Aún no has guardado ningún artículo.",
    saved_delete: "Eliminar",
    saved_unknown_author: "Autor desconocido",
    saved_unknown_journal: "Revista desconocida",
    saved_ai_summary: "Resumen IA",
    saved_read_original: "Leer original",

    topics_country_label: "Geografía / País",
    topics_country_all: "Todos los países (Global)",

    summaries_fetching: "Recuperando y analizando datos...",
    summaries_ai_analysis: "Análisis IA",
    summaries_processing: "Generando resumen...",

    topics_country_placeholder: "Seleccionar país para añadir...",
    topics_region_nordic: "Países Nórdicos",
    topics_region_weurope: "Europa Occidental",
    topics_region_seurope: "Europa del Sur",
    topics_region_namerica: "América del Norte",
    topics_region_asia: "Asia",
    
    topics_difficulty_label: "Nivel del resumen",
    topics_diff_public: "Público",
    topics_diff_student: "Entusiasta",
    topics_diff_expert: "Experto",

    // --- NUEVAS CADENAS PARA REGLAS DE NEGOCIO ---
    usage_limit_reached: "Has alcanzado el límite de {max} pruebas para tu nivel ({tier}).",
    usage_error: "No se pudo verificar el estado de la cuenta.",
    save_watch_trial_blocked: "Como usuario de prueba, no puedes guardar vigilancias. ¡Actualiza a Basic o Premium!",
    save_watch_limit_reached: "¡Límite alcanzado! Tu nivel ({tier}) permite un máximo de {max} vigilancias.",
    save_watch_journal_limit_reached: "¡Límite de revistas alcanzado! Tu nivel ({tier}) solo permite {max} vigilancia con una revista específica.",
    save_watch_fetch_error: "Ocurrió un error al verificar el estado de la cuenta.",
    save_watch_error: "No se pudo guardar.",
    save_watch_success: "¡Vigilancia guardada!",
    error_select_criteria: "Por favor, selecciona primero un autor, revista, tema o país.",
    error_limit_reached_generic: "Has alcanzado tu límite de búsqueda. Por favor, actualiza para realizar más búsquedas.",
    error_no_abstracts: "No se encontraron artículos con resumen.",
    error_generic: "Ocurrió un error inesperado.",
    error_save_article_failed: "No se pudo guardar el artículo."
  },
  Portuguese: {
    menu_home: "Início",
    menu_search: "Pesquisar",
    menu_inbox: "Caixa de Entrada",
    menu_saved: "Salvos",
    menu_watches: "Meus Alertas",
    menu_logout: "Sair",
    
    home_welcome: "Bom dia",
    home_new_user_title: "Bem-vindo! Vamos configurar seu primeiro alerta.",
    home_user_title: "Aqui está o seu resumo de pesquisa de hoje.",
    home_robot_title: "Como funciona",
    home_robot_desc: "Configure alertas para seus tópicos favoritos e nossa IA lerá e resumirá as pesquisas mais recentes para você todas as noites.",
    home_step1_title: "1. Criar alerta",
    home_step1_desc: "Insira um tópico, autor ou uma revista específica que deseja acompanhar.",
    home_step2_title: "2. A IA resume",
    home_step2_desc: "Todas as noites, o assistente procura novos artigos e escreve resumos curtos.",
    home_step3_title: "3. Leia na caixa de entrada",
    home_step3_desc: "Salve os artigos que deseja ler mais tarde e descarte o resto com um clique.",
    home_btn_create: "Criar seu primeiro alerta",
    home_stat_inbox: "Caixa de Entrada",
    home_stat_articles: "Artigos não lidos",
    home_stat_unread: "Não lidos",
    home_action_read: "Ir para a caixa de entrada",
    home_stat_assistants: "Assistentes",
    home_stat_active: "Ativos",
    home_action_manage: "Gerenciar alertas",
    home_stat_library: "Biblioteca",
    home_stat_saved: "Salvos",
    home_action_open: "Abrir biblioteca",
    home_quick_title: "Novo tópico de pesquisa?",
    home_quick_desc: "Configure um novo alerta de IA em menos de um minuto.",
    home_btn_new: "Novo alerta",

    topics_title: "Dê uma missão ao seu assistente",
    topics_subtitle: "Insira o que você está procurando. Monitoramos milhares de revistas.",
    topics_ai_title: "Deixe a IA encontrar as melhores palavras-chave",
    topics_ai_desc: "Descreva o que lhe interessa com suas próprias palavras, e nós traduziremos para termos de pesquisa científicos.",
    topics_ai_placeholder: "Ex: Quero saber como o microssono afeta o aprendizado em crianças...",
    topics_ai_thinking: "Pensando...",
    topics_ai_suggest: "Sugerir",
    topics_search_label: "Pesquisar",
    topics_search_placeholder: "Ex. 'CRISPR' ou 'AI AND healthcare'",
    topics_add_btn: "Adicionar",
    topics_quick_picks: "Escolhas rápidas",
    topics_filter_title: "Refinar pesquisa",
    topics_filter_open: "Abrir",
    topics_author_label: "Buscar autor específico",
    topics_author_placeholder: "Ex. 'Stephen Hawking'",
    topics_search_btn: "Buscar",
    topics_change_btn: "Alterar",
    topics_journal_label: "Buscar revista específica",
    topics_journal_placeholder: "Ex. 'Nature' ou 'Lancet'",
    topics_date_label: "Período (Teste)",
    topics_date_from: "De",
    topics_date_to: "Até",
    topics_apply_filter: "Aplicar filtro",
    topics_test_btn: "Testar",
    topics_save_btn: "Ativar Assistente",
    topics_ai_error: "Não foi possível gerar palavras-chave no momento. Tente novamente.",
    
    topic_ai: "Inteligência Artificial",
    topic_climate: "Mudanças Climáticas",
    topic_oncology: "Oncologia",
    topic_pedagogy: "Pedagogia",
    topic_quantum: "Física Quântica",

    inbox_mark_read: "Marcar como lido",
    inbox_delete: "Excluir",
    inbox_new: "Novo",
    inbox_delete_permanent: "Excluir permanentemente",
    inbox_mark_as_read: "Marcar como lido",
    inbox_unknown_author: "Autor desconhecido",
    inbox_unknown_journal: "Revista desconhecida",
    inbox_published: "Publicado",
    inbox_ai_summary: "Resumo da IA",
    inbox_read_original: "Ler original",
    inbox_archive: "Arquivar",
    inbox_title: "Minha Caixa de Entrada",
    inbox_subtitle: "Aqui está o seu resumo diário do monitoramento automático.",
    inbox_refresh: "Atualizar",
    inbox_empty_title: "Nenhuma atualização nova!",
    inbox_empty_desc: "Seu assistente de pesquisa entregou tudo por hoje. Pegue um café e reflita sobre suas descobertas.",
    inbox_btn_new: "+ Iniciar novo alerta",
    inbox_unread_singular: "artigo não lido",
    inbox_unread_plural: "artigos não lidos",

    watches_empty_title: "Nenhum assistente ativo",
    watches_empty_desc: "Você ainda não deu nenhuma missão à sua IA.",
    watches_title: "Meus Alertas",
    watches_subtitle: "Aqui estão seus assistentes de IA ativos pesquisando na web para você todas as noites.",
    watches_delete: "Excluir assistente",
    watches_status_active: "Ativo",
    watches_btn_edit: "Editar e Testar",

    saved_title: "Artigos Salvos",
    saved_subtitle: "Suas pérolas escolhidas a dedo pelo assistente de IA.",
    saved_refresh: "Atualizar",
    saved_empty: "Você ainda não salvou nenhum artigo.",
    saved_delete: "Remover",
    saved_unknown_author: "Autor desconhecido",
    saved_unknown_journal: "Revista desconhecida",
    saved_ai_summary: "Resumo da IA",
    saved_read_original: "Ler original",

    topics_country_label: "Geografia / País",
    topics_country_all: "Todos os países (Global)",

    summaries_fetching: "Buscando e analisando dados...",
    summaries_ai_analysis: "Análise de IA",
    summaries_processing: "Gerando resumo...",

    topics_country_placeholder: "Selecione o país para adicionar...",
    topics_region_nordic: "Países Nórdicos",
    topics_region_weurope: "Europa Ocidental",
    topics_region_seurope: "Europa do Sul",
    topics_region_namerica: "América do Norte",
    topics_region_asia: "Ásia",
    
    topics_difficulty_label: "Nível do resumo",
    topics_diff_public: "Público",
    topics_diff_student: "Entusiasta",
    topics_diff_expert: "Especialista",

    // --- NOVAS STRINGS PARA REGRAS DE NEGÓCIO ---
    usage_limit_reached: "Você atingiu o seu limite de {max} testes para o seu nível ({tier}).",
    usage_error: "Não foi possível verificar o status da conta.",
    save_watch_trial_blocked: "Como usuário de teste, você não pode salvar alertas. Atualize para Basic ou Premium!",
    save_watch_limit_reached: "Limite atingido! Seu nível ({tier}) permite no máximo {max} alertas.",
    save_watch_journal_limit_reached: "Limite de revistas atingido! Seu nível ({tier}) permite apenas {max} alerta com uma revista específica.",
    save_watch_fetch_error: "Ocorreu um erro ao verificar o status da conta.",
    save_watch_error: "Não foi possível salvar.",
    save_watch_success: "Alerta salvo!",
    error_select_criteria: "Por favor, selecione primeiro um autor, revista, tópico ou país.",
    error_limit_reached_generic: "Você atingiu o seu limite de pesquisa. Por favor, atualize para fazer mais pesquisas.",
    error_no_abstracts: "Nenhum artigo com resumo foi encontrado.",
    error_generic: "Ocorreu um erro inesperado.",
    error_save_article_failed: "Não foi possível salvar o artigo."
  },
  Hindi: {
    menu_home: "होम",
    menu_search: "खोजें",
    menu_inbox: "इनबॉक्स",
    menu_saved: "सहेजे गए",
    menu_watches: "मेरे अलर्ट",
    menu_logout: "लॉग आउट",
    
    home_welcome: "सुप्रभात",
    home_new_user_title: "स्वागत है! अपना पहला अलर्ट सेट करें।",
    home_user_title: "यहां आज का आपका शोध अवलोकन है।",
    home_robot_title: "यह कैसे काम करता है",
    home_robot_desc: "अपने पसंदीदा विषयों के लिए अलर्ट सेट करें, und हमारा AI हर रात आपके लिए नवीनतम शोध पढ़ेगा और सारांशित करेगा।",
    home_step1_title: "1. अलर्ट बनाएं",
    home_step1_desc: "एक विषय, लेखक, या एक विशिष्ट पत्रिका दर्ज करें जिसका आप अनुसरण करना चाहते हैं।",
    home_step2_title: "2. AI सारांशित करता है",
    home_step2_desc: "हर रात, सहायक नए लेखों की तलाश करता है और छोटे सारांश लिखता है।",
    home_step3_title: "3. इनबॉक्स में पढ़ें",
    home_step3_desc: "जिन लेखों को आप बाद में पढ़ना चाहते हैं उन्हें सहेजें और बाकी को एक क्लिक से हटा दें।",
    home_btn_create: "अपना पहला अलर्ट बनाएं",
    home_stat_inbox: "इनबॉक्स",
    home_stat_articles: "अपठित लेख",
    home_stat_unread: "अपठित",
    home_action_read: "इनबॉक्स में जाएं",
    home_stat_assistants: "सहायक",
    home_stat_active: "सक्रिय",
    home_action_manage: "अलर्ट प्रबंधित करें",
    home_stat_library: "पुस्तकालय",
    home_stat_saved: "सहेजे गए",
    home_action_open: "पुस्तकालय खोलें",
    home_quick_title: "नया शोध विषय?",
    home_quick_desc: "एक मिनट से भी कम समय में एक नया AI अलर्ट सेट करें।",
    home_btn_new: "नया अलर्ट",

    topics_title: "अपने सहायक को एक mission दें",
    topics_subtitle: "आप जो खोज रहे हैं उसे दर्ज करें। हम हजारों पत्रिकाओं की निगरानी करते.",
    topics_ai_title: "AI को सर्वश्रेष्ठ कीवर्ड खोजने दें",
    topics_ai_desc: "अपने शब्दों में बताएं कि आपको किसमें रुचि है, और हम इसे वैज्ञानिक खोज शब्दों में बदल देंगे।",
    topics_ai_placeholder: "उदा: मैं जानना चाहता हूँ कि माइक्रोसलीप बच्चों के सीखने को कैसे प्रभावित करता है...",
    topics_ai_thinking: "सोच रहा है...",
    topics_ai_suggest: "सुझाव दें",
    topics_search_label: "खोज",
    topics_search_placeholder: "उदा. 'CRISPR' या 'AI AND healthcare'",
    topics_add_btn: "जोड़ें",
    topics_quick_picks: "त्वरित चयन",
    topics_filter_title: "खोज को परिष्कृत करें",
    topics_filter_open: "खोलें",
    topics_author_label: "विशिष्ट लेखक खोजें",
    topics_author_placeholder: "उदा. 'Stephen Hawking'",
    topics_search_btn: "खोजें",
    topics_change_btn: "बदलें",
    topics_journal_label: "विशिष्ट पत्रिका खोजें",
    topics_journal_placeholder: "उदा. 'Nature' या 'Lancet'",
    topics_date_label: "समय अवधि (परीक्षण)",
    topics_date_from: "से",
    topics_date_to: "तक",
    topics_apply_filter: "फ़िल्टर लागू करें",
    topics_test_btn: "परीक्षण करें",
    topics_save_btn: "सहायक सक्रिय करें",
    topics_ai_error: "अभी कीवर्ड जनरेट नहीं किए जा सके। कृपया पुनः प्रयास करें।",
    
    topic_ai: "कृत्रिम बुद्धिमत्ता (AI)",
    topic_climate: "जलवायु परिवर्तन",
    topic_oncology: "ऑन्कोलॉजी (कैंसर विज्ञान)",
    topic_pedagogy: "शिक्षा शास्त्र",
    topic_quantum: "क्वांटम भौतिकी",

    inbox_mark_read: "पढ़ा हुआ चिह्नित करें",
    inbox_delete: "हटाएं",
    inbox_new: "नया",
    inbox_delete_permanent: "स्थायी रूप से हटाएं",
    inbox_mark_as_read: "पढ़ा हुआ चिह्नित करें",
    inbox_unknown_author: "अक्यात लेखक",
    inbox_unknown_journal: "अज्ञात पत्रिका",
    inbox_published: "प्रकाशित",
    inbox_ai_summary: "AI सारांश",
    inbox_read_original: "मूल पढ़ें",
    inbox_archive: "संग्रह करें",
    inbox_title: "मेरा इनबॉक्स",
    inbox_subtitle: "स्वचालित अलर्ट से आपका दैनिक सारांश यहां दिया गया है।",
    inbox_refresh: "रीफ़्रेश करें",
    inbox_empty_title: "अभी कोई नया अपडेट नहीं!",
    inbox_empty_desc: "आपके शोध सहायक ने आज के लिए सब कुछ दे दिया है। एक कॉफी लें और अपने निष्कर्षों पर विचार करें।",
    inbox_btn_new: "+ एक नया अलर्ट शुरू करें",
    inbox_unread_singular: "अपठित लेख",
    inbox_unread_plural: "अपठित लेख",

    watches_empty_title: "कोई सक्रिय सहायक नहीं",
    watches_empty_desc: "आपने अभी तक अपने AI को कोई मिशन नहीं दिया है।",
    watches_title: "मेरे अलर्ट",
    watches_subtitle: "यहां आपके सक्रिय AI सहायक हैं जो हर रात आपके लिए वेब खोजते हैं।",
    watches_delete: "सहायक हटाएं",
    watches_status_active: "सक्रिय",
    watches_btn_edit: "संपादित करें और परीक्षण करें",

    saved_title: "सहेजे गए लेख",
    saved_subtitle: "AI सहायक से आपके चुने हुए रत्न।",
    saved_refresh: "रीफ़्रेश करें",
    saved_empty: "आपने अभी तक कोई लेख नहीं सहेजा है।",
    saved_delete: "निकालें",
    saved_unknown_author: "अज्ञात लेखक",
    saved_unknown_journal: "अज्ञात पत्रिका",
    saved_ai_summary: "AI सारांश",
    saved_read_original: "मूल पढ़ें",

    topics_country_label: "भूगोल / देश",
    topics_country_all: "सभी देश (वैश्विक)",

    summaries_fetching: "डेटा प्राप्त और विश्लेषित कर रहा है...",
    summaries_ai_analysis: "AI विश्लेषण",
    summaries_processing: "सारांश बना रहा है...",

    topics_country_placeholder: "जोड़ने के लिए देश चुनें...",
    topics_region_nordic: "नॉर्डिक देश",
    topics_region_weurope: "पश्चिमी यूरोप",
    topics_region_seurope: "दक्षिणी यूरोप",
    topics_region_namerica: "उत्तरी अमेरिका",
    topics_region_asia: "एशिया",
    
    topics_difficulty_label: "सारांश स्तर",
    topics_diff_public: "सार्वजनिक",
    topics_diff_student: "उत्साही",
    topics_diff_expert: "विशेषज्ञ",

    // --- व्यावसायिक नियमों के लिए नई स्ट्रिंग्स ---
    usage_limit_reached: "आप अपने स्तर ({tier}) के लिए {max} परीक्षण रनों की अपनी सीमा तक पहुँच चुके हैं।",
    usage_error: "खाते की स्थिति की पुष्टि नहीं की जा सकी।",
    save_watch_trial_blocked: "ट्रायल उपयोगकर्ता के रूप में, आप अलर्ट सहेज नहीं सकते। कृपया बेसिक या प्रीमियम में अपग्रेड करें!",
    save_watch_limit_reached: "सीमा समाप्त! आपका स्तर ({tier}) अधिकतम {max} अलर्ट की अनुमति देता है।",
    save_watch_journal_limit_reached: "पत्रिका सीमा समाप्त! आपका स्तर ({tier}) विशिष्ट पत्रिका के साथ केवल {max} अलर्ट की अनुमति देता है।",
    save_watch_fetch_error: "खाते की स्थिति की जांच करते समय एक त्रुटि हुई।",
    save_watch_error: "सहेजा नहीं जा सका।",
    save_watch_success: "अलर्ट सहेजा गया!",
    error_select_criteria: "कृपया पहले एक लेखक, पत्रिका, विषय या देश का चयन करें।",
    error_limit_reached_generic: "आप अपनी खोज सीमा तक पहुँच चुके हैं। अधिक खोज करने के लिए कृपया अपग्रेड करें।",
    error_no_abstracts: "कोई सार वाले लेख नहीं मिले।",
    error_generic: "एक अप्रत्याशित त्रुटि हुई।",
    error_save_article_failed: "लेख सहेजा नहीं जा सका।"
  },
  Mandarin: {
    menu_home: "首页",
    menu_search: "搜索",
    menu_inbox: "收件箱",
    menu_saved: "已保存",
    menu_watches: "我的监控",
    menu_logout: "登出",
    
    home_welcome: "早上好",
    home_new_user_title: "欢迎！让我们设置您的第一个监控。",
    home_user_title: "这是您今天的研究概览。",
    home_robot_title: "工作原理",
    home_robot_desc: "为您喜欢的主题设置监控，我们的AI将每晚为您阅读并总结最新研究。",
    home_step1_title: "1. 创建监控",
    home_step1_desc: "输入您想要关注的主题、作者或特定期刊。",
    home_step2_title: "2. AI 总结",
    home_step2_desc: "每晚，助手会查找新文章并编写简短的摘要。",
    home_step3_title: "3. 在收件箱中阅读",
    home_step3_desc: "保存您想稍后阅读的文章，一键丢弃其余文章。",
    home_btn_create: "创建您的第一个监控",
    home_stat_inbox: "收件箱",
    home_stat_articles: "未读文章",
    home_stat_unread: "未读",
    home_action_read: "前往收件箱",
    home_stat_assistants: "助手",
    home_stat_active: "活跃",
    home_action_manage: "管理监控",
    home_stat_library: "图书馆",
    home_stat_saved: "已保存",
    home_action_open: "打开图书馆",
    home_quick_title: "新的研究主题？",
    home_quick_desc: "在不到一分钟内设置一个新的AI监控。",
    home_btn_new: "新监控",

    topics_title: "给您的助手分配任务",
    topics_subtitle: "输入您正在寻找的内容。我们监控着数千种期刊。",
    topics_ai_title: "让AI找到最佳关键词",
    topics_ai_desc: "用您自己的话描述您感兴趣的内容，我们会将其翻译成科学的搜索词。",
    topics_ai_placeholder: "例如：我想知道微睡眠如何影响儿童的学习...",
    topics_ai_thinking: "思考中...",
    topics_ai_suggest: "建议",
    topics_search_label: "搜索",
    topics_search_placeholder: "例如 'CRISPR' 或 'AI AND healthcare'",
    topics_add_btn: "添加",
    topics_quick_picks: "快速选择",
    topics_filter_title: "优化搜索",
    topics_filter_open: "打开",
    topics_author_label: "搜索特定作者",
    topics_author_placeholder: "例如 'Stephen Hawking'",
    topics_search_btn: "搜索",
    topics_change_btn: "更改",
    topics_journal_label: "搜索特定期刊",
    topics_journal_placeholder: "例如 'Nature' 或 'Lancet'",
    topics_date_label: "时间范围（测试）",
    topics_date_from: "从",
    topics_date_to: "至",
    topics_apply_filter: "应用过滤器",
    topics_test_btn: "测试运行",
    topics_save_btn: "激活助手",
    topics_ai_error: "目前无法生成关键词，请重试。",
    
    topic_ai: "人工智能",
    topic_climate: "气候变化",
    topic_oncology: "肿瘤学",
    topic_pedagogy: "教育学",
    topic_quantum: "量子物理学",

    inbox_mark_read: "标记已读",
    inbox_delete: "删除",
    inbox_new: "新",
    inbox_delete_permanent: "永久删除",
    inbox_mark_as_read: "标记为已读",
    inbox_unknown_author: "未知作者",
    inbox_unknown_journal: "未知期刊",
    inbox_published: "已发布",
    inbox_ai_summary: "AI 摘要",
    inbox_read_original: "阅读原文",
    inbox_archive: "归档",
    inbox_title: "我的收件箱",
    inbox_subtitle: "这是自动监控为您生成的每日摘要。",
    inbox_refresh: "刷新",
    inbox_empty_title: "目前没有新更新！",
    inbox_empty_desc: "您的研究助手已交付今天的所有内容。喝杯咖啡，回顾一下您的发现。",
    inbox_btn_new: "+ 开始新的监控",
    inbox_unread_singular: "篇未读文章",
    inbox_unread_plural: "篇未读文章",

    watches_empty_title: "没有活跃的助手",
    watches_empty_desc: "您还没有给您的AI分配任何任务。",
    watches_title: "我的监控",
    watches_subtitle: "以下是您活跃的AI助手，它们每晚都在为您搜索网络。",
    watches_delete: "删除助手",
    watches_status_active: "活跃",
    watches_btn_edit: "编辑和测试",

    saved_title: "已保存文章",
    saved_subtitle: "您从AI助手中精心挑选的精华。",
    saved_refresh: "刷新",
    saved_empty: "您还没有保存任何文章。",
    saved_delete: "移除",
    saved_unknown_author: "未知作者",
    saved_unknown_journal: "未知期刊",
    saved_ai_summary: "AI 摘要",
    saved_read_original: "阅读原文",

    topics_country_label: "地理 / 国家",
    topics_country_all: "所有国家 (全球)",

    summaries_fetching: "正在获取并分析数据...",
    summaries_ai_analysis: "AI 分析",
    summaries_processing: "正在生成摘要...",

    topics_country_placeholder: "选择要添加的国家...",
    topics_region_nordic: "北欧",
    topics_region_weurope: "西欧",
    topics_region_seurope: "南欧",
    topics_region_namerica: "北美",
    topics_region_asia: "亚洲",
    
    topics_difficulty_label: "摘要级别",
    topics_diff_public: "大众",
    topics_diff_student: "爱好者",
    topics_diff_expert: "专家",

    // --- 业务规则新增字符串 ---
    usage_limit_reached: "您已达到当前级别 ({tier}) 的测试运行限制（最多 {max} 次）。",
    usage_error: "无法验证账户状态。",
    save_watch_trial_blocked: "作为试用用户，您无法保存监控。请升级到基础版或高级版！",
    save_watch_limit_reached: "已达上限！您的级别 ({tier}) 最多允许 {max} 个监控。",
    save_watch_journal_limit_reached: "监控期刊数已达上限！您的级别 ({tier}) 仅允许设置 {max} 个包含特定期刊的监控。",
    save_watch_fetch_error: "检查账户状态时出错。",
    save_watch_error: "无法保存。",
    save_watch_success: "监控已保存！",
    error_select_criteria: "请先选择作者、期刊、主题或国家。",
    error_limit_reached_generic: "您已达到搜索限制。请升级账户以进行更多搜索。",
    error_no_abstracts: "未找到包含摘要的文章。",
    error_generic: "发生未知错误。",
    error_save_article_failed: "无法保存文章。"
  }
};

const supplementalTranslations = {
  Norwegian: {
    inbox_group_other: "Annet",
    error_auth_required: "Autentiseringsfeil: Du må være logget inn for å generere et sammendrag.",
    watch_title_countries: "Land: ",
    watch_title_fallback: "Navnløs overvåking",
    watch_author_prefix: "Forfatter: ",
    watch_search_default: "Søk",
    summary_no_text: "Ingen tekst tilgjengelig.",
    saved_unknown_title: "Ukjent tittel",
    saved_from_inbox_topic: "Lagret fra innboksen",
    error_archive_failed: "Kunne ikke arkivere artikkelen: ",
    card_blurred_placeholder: "Denne studien undersøker de underliggende mekanismene og virkningene deres...",
    card_quota_title: "Månedskvoten er brukt opp",
    card_quota_desc_desktop: "Du har brukt alle {maxLimit} AI-sammendragene for denne måneden. Oppgrader for å fortsette å få grundige analyser direkte i innboksen.",
    card_quota_desc_mobile: "Du har brukt alle {maxLimit} sammendragene. Oppgrader for å fortsette.",
    card_quota_btn: "Se abonnementer",
    home_onboarding_heading: "Gå aldri glipp av et gjennombrudd igjen.",
    home_onboarding_desc: "Vi følger tusenvis av publikasjoner over hele verden. Fortell oss hva du er interessert i, så leverer AI-en vår tilpasset, oppsummert innsikt til Science Monitor-innboksen din hver morgen.",
    home_onboarding_step1_title: "Definer fokusområdet ditt",
    home_onboarding_step1_desc: "Opprett en assistent ved å skrive inn søkeord, forfattere eller emner du vil følge.",
    home_onboarding_step2_title: "AI-en setter i gang",
    home_onboarding_step2_desc: "Mens du sover, søker AI-en vår i globale databaser, finner nøyaktige treff og oppsummerer hovedfunnene.",
    home_onboarding_step3_title: "Start dagen smart",
    home_onboarding_step3_desc: "Åpne innboksen med morgenkaffen. Sveip til høyre for å markere som lest og til venstre for å slette.",
    home_onboarding_btn_create: "Opprett din første AI-assistent",
    inbox_total: "totalt",
    login_subtitle: "Logg inn for å administrere forskningsoversvåkingene dine og se dine personlige AI-analyser.",
    login_google: "Fortsett med Google",
    login_apple: "Fortsett med Apple",
    login_terms_prefix: "Ved å fortsette godtar du våre ",
    login_terms_link: "bruksvilkår",
    login_terms_and: " og vår ",
    login_privacy_link: "personvernerklæring",
    portal_login_required: "Du må være logget inn for å administrere abonnementet ditt.",
    portal_error: "Serverfeil ({status})",
    portal_customer_not_found: "Fant ingen Stripe-kunde for denne kontoen.",
    portal_no_url: "Stripe returnerte ingen URL.",
    portal_opening: "Åpner...",
    portal_btn_manage: "Administrer abonnement",
    offline_title: "Ingen internettforbindelse",
    offline_description: "Appen trenger en aktiv internettforbindelse for å hente den nyeste forskningen. Kontroller nettverksinnstillingene.",
    offline_waiting: "Venter på nettverk...",
    paywall_checkout_error: "Kunne ikke starte betalingen. Prøv igjen.",
    paywall_checkout_unexpected_error: "Det oppstod en uventet feil under betalingen.",
    paywall_back: "Tilbake",
    paywall_quota_reached_badge: "Månedskvoten er nådd",
    paywall_tier_basic: "Science Monitor Basic",
    paywall_unlock_title: "Lås opp full tilgang",
    paywall_quota_desc: "Du har brukt alle de 775 AI-genererte forskningssammendragene som er inkludert i planen din denne måneden. Kvoten tilbakestilles automatisk den første i neste måned.",
    paywall_trial_desc: "Prøveperioden eller de inkluderte søkene dine er brukt opp. Abonner for å låse opp automatisk vitenskapelig overvåking og omfattende AI-sammendrag.",
    paywall_standard_plan: "Standardabonnement",
    paywall_monthly_sub: "Månedsabonnement",
    paywall_price_amount: "25 SEK",
    paywall_price_suffix: "/ måned (inkl. mva.)",
    paywall_feature_summaries: "Opptil 775 automatiske AI-sammendrag per måned (opptil 5 per natt per overvåking)",
    paywall_feature_watches: "Opprett opptil 5 tilpassede vitenskapelige overvåkinger",
    paywall_feature_saved: "Ubegrenset, permanent tilgang til biblioteket med lagrede artikler",
    paywall_feature_cancel: "Si opp når som helst i kontoinnstillingene",
    paywall_opening_checkout: "Åpner betaling...",
    paywall_btn_manage: "Administrer abonnement",
    paywall_btn_subscribe: "Abonner nå – 25 SEK / måned",
    paywall_back_home: "Tilbake til startsiden",
    paywall_renewal_notice: "Abonnementet fornyes automatisk hver måned til det sies opp.",
    paywall_agree_notice: "Ved å abonnere godtar du våre ",
    paywall_terms_link: "bruksvilkår",
    paywall_and: " og ",
    paywall_privacy_link: "personvernerklæring",
    common_back: "Tilbake",
    privacy_title: "Personvernerklæring",
    privacy_updated: "Sist oppdatert: 22. september 2026",
    summaries_header: "AI-arbeidsbenk",
    summaries_btn_saved: "Lagret",
    summaries_btn_save: "Lagre",
    terms_title: "Bruksvilkår",
    terms_updated: "Sist oppdatert: 22. september 2026",
    openalex_no_institution: "Ingen institusjon oppgitt",
    openalex_no_publisher: "Ingen utgiver oppgitt",
    checkout_login_required: "Du må være logget inn for å starte et abonnement.",
    checkout_failed: "Kunne ikke starte betalingen.",
    paywall_title: "Lås opp full tilgang",
    paywall_description: "Prøveperioden eller de inkluderte søkene dine er brukt opp. Abonner for å fortsette å motta automatiske forskningssammendrag uten begrensninger.",
    paywall_purchase_error: "Kjøpet kunne ikke fullføres. Prøv igjen.",
    paywall_loading: "Laster abonnementsalternativer...",
    paywall_popular_badge: "Mest populær",
    paywall_plan_name: "Månedsabonnement",
    paywall_month_suffix: "mnd.",
    paywall_cancel_anytime: "Si opp når som helst i kontoinnstillingene.",
    paywall_no_packages: "Ingen abonnementspakker er tilgjengelige for øyeblikket.",
    paywall_processing: "Behandler...",
    paywall_subscribe_button: "Abonner nå",
    paywall_renewal_terms: "Abonnementet fornyes automatisk med mindre det sies opp minst 24 timer før den gjeldende perioden utløper."
  },
  Danish: {
    inbox_group_other: "Andet",
    error_auth_required: "Godkendelsesfejl: Du skal være logget ind for at generere et resumé.",
    watch_title_countries: "Lande: ",
    watch_title_fallback: "Unavngiven overvågning",
    watch_author_prefix: "Forfatter: ",
    watch_search_default: "Søgning",
    summary_no_text: "Ingen tekst tilgængelig.",
    saved_unknown_title: "Ukendt titel",
    saved_from_inbox_topic: "Gemt fra indbakken",
    error_archive_failed: "Artiklen kunne ikke arkiveres: ",
    card_blurred_placeholder: "Dette studie undersøger de underliggende mekanismer og deres virkninger...",
    card_quota_title: "Månedskvoten er opbrugt",
    card_quota_desc_desktop: "Du har brugt alle {maxLimit} AI-resuméer for denne måned. Opgrader for fortsat at få dybdegående analyser direkte i din indbakke.",
    card_quota_desc_mobile: "Du har brugt alle {maxLimit} resuméer. Opgrader for at fortsætte.",
    card_quota_btn: "Se abonnementer",
    home_onboarding_heading: "Gå aldrig glip af et gennembrud igen.",
    home_onboarding_desc: "Vi overvåger tusindvis af publikationer verden over. Fortæl os, hvad du interesserer dig for, så leverer vores AI skræddersyede, opsummerede indsigter til din Science Monitor-indbakke hver morgen.",
    home_onboarding_step1_title: "Definér dit fokus",
    home_onboarding_step1_desc: "Opret en assistent ved at indtaste de søgeord, forfattere eller emner, du vil overvåge.",
    home_onboarding_step2_title: "AI går i gang",
    home_onboarding_step2_desc: "Mens du sover, søger vores AI i globale databaser, finder præcise match og opsummerer de vigtigste resultater.",
    home_onboarding_step3_title: "Start dagen godt",
    home_onboarding_step3_desc: "Åbn din indbakke med morgenkaffen. Stryg til højre for at markere som læst og til venstre for at slette.",
    home_onboarding_btn_create: "Opret din første AI-assistent",
    inbox_total: "i alt",
    login_subtitle: "Log ind for at administrere dine forskningsovervågninger og se dine personlige AI-analyser.",
    login_google: "Fortsæt med Google",
    login_apple: "Fortsæt med Apple",
    login_terms_prefix: "Ved at fortsætte accepterer du vores ",
    login_terms_link: "servicevilkår",
    login_terms_and: " og vores ",
    login_privacy_link: "privatlivspolitik",
    portal_login_required: "Du skal være logget ind for at administrere dit abonnement.",
    portal_error: "Serverfejl ({status})",
    portal_customer_not_found: "Der blev ikke fundet en Stripe-kunde for denne konto.",
    portal_no_url: "Der blev ikke returneret nogen URL fra Stripe.",
    portal_opening: "Åbner...",
    portal_btn_manage: "Administrer abonnement",
    offline_title: "Ingen internetforbindelse",
    offline_description: "Appen kræver en aktiv internetforbindelse for at hente den nyeste forskning. Kontrollér dine netværksindstillinger.",
    offline_waiting: "Venter på netværk...",
    paywall_checkout_error: "Betalingen kunne ikke startes. Prøv igen.",
    paywall_checkout_unexpected_error: "Der opstod en uventet fejl under betalingen.",
    paywall_back: "Tilbage",
    paywall_quota_reached_badge: "Månedskvoten er nået",
    paywall_tier_basic: "Science Monitor Basic",
    paywall_unlock_title: "Få fuld adgang",
    paywall_quota_desc: "Du har brugt alle 775 AI-genererede forskningsresuméer, der er inkluderet i dit abonnement for denne måned. Kvoten nulstilles automatisk den første i næste måned.",
    paywall_trial_desc: "Din prøveperiode eller dine inkluderede søgninger er udløbet. Abonnér for at få automatisk videnskabelig overvågning og omfattende AI-resuméer.",
    paywall_standard_plan: "Standardabonnement",
    paywall_monthly_sub: "Månedsabonnement",
    paywall_price_amount: "25 SEK",
    paywall_price_suffix: "/ måned (inkl. moms)",
    paywall_feature_summaries: "Op til 775 automatiske AI-resuméer om måneden (op til 5 pr. nat pr. overvågning)",
    paywall_feature_watches: "Opret op til 5 tilpassede videnskabelige overvågninger",
    paywall_feature_saved: "Ubegrænset permanent adgang til dit bibliotek med gemte artikler",
    paywall_feature_cancel: "Opsig når som helst via kontoindstillingerne",
    paywall_opening_checkout: "Åbner betaling...",
    paywall_btn_manage: "Administrer abonnement",
    paywall_btn_subscribe: "Abonnér nu – 25 SEK / måned",
    paywall_back_home: "Tilbage til forsiden",
    paywall_renewal_notice: "Abonnementet fornyes automatisk hver måned, indtil det opsiges.",
    paywall_agree_notice: "Ved at abonnere accepterer du vores ",
    paywall_terms_link: "servicevilkår",
    paywall_and: " og ",
    paywall_privacy_link: "privatlivspolitik",
    common_back: "Tilbage",
    privacy_title: "Privatlivspolitik",
    privacy_updated: "Senest opdateret: 22. september 2026",
    summaries_header: "AI-arbejdsbord",
    summaries_btn_saved: "Gemt",
    summaries_btn_save: "Gem",
    terms_title: "Servicevilkår",
    terms_updated: "Senest opdateret: 22. september 2026",
    openalex_no_institution: "Ingen institution angivet",
    openalex_no_publisher: "Ingen udgiver angivet",
    checkout_login_required: "Du skal være logget ind for at starte et abonnement.",
    checkout_failed: "Betalingen kunne ikke startes.",
    paywall_title: "Få fuld adgang",
    paywall_description: "Din prøveperiode eller dine inkluderede søgninger er udløbet. Abonnér for fortsat at modtage automatiske forskningsresuméer uden begrænsninger.",
    paywall_purchase_error: "Købet kunne ikke gennemføres. Prøv igen.",
    paywall_loading: "Indlæser abonnementsmuligheder...",
    paywall_popular_badge: "Mest populær",
    paywall_plan_name: "Månedsabonnement",
    paywall_month_suffix: "md.",
    paywall_cancel_anytime: "Opsig når som helst via kontoindstillingerne.",
    paywall_no_packages: "Der er ingen abonnementspakker tilgængelige lige nu.",
    paywall_processing: "Behandler...",
    paywall_subscribe_button: "Abonnér nu",
    paywall_renewal_terms: "Abonnementet fornyes automatisk, medmindre det opsiges mindst 24 timer før den aktuelle periode udløber."
  },
  Finnish: {
    inbox_group_other: "Muut",
    error_auth_required: "Todennusvirhe: sinun on kirjauduttava sisään yhteenvedon luomiseksi.",
    watch_title_countries: "Maat: ",
    watch_title_fallback: "Nimetön seuranta",
    watch_author_prefix: "Kirjoittaja: ",
    watch_search_default: "Haku",
    summary_no_text: "Tekstiä ei ole saatavilla.",
    saved_unknown_title: "Tuntematon otsikko",
    saved_from_inbox_topic: "Tallennettu saapuneista",
    error_archive_failed: "Artikkelin arkistointi epäonnistui: ",
    card_blurred_placeholder: "Tässä tutkimuksessa tarkastellaan taustalla olevia mekanismeja ja niiden vaikutuksia...",
    card_quota_title: "Kuukausikiintiö on käytetty",
    card_quota_desc_desktop: "Olet käyttänyt kaikki tämän kuukauden {maxLimit} tekoäly-yhteenvetoa. Päivitä tilauksesi, jotta saat jatkossakin perusteellisia analyyseja suoraan saapuneisiin.",
    card_quota_desc_mobile: "Olet käyttänyt kaikki {maxLimit} yhteenvetoa. Päivitä tilauksesi jatkaaksesi.",
    card_quota_btn: "Näytä tilaukset",
    home_onboarding_heading: "Älä enää koskaan ohita merkittävää läpimurtoa.",
    home_onboarding_desc: "Seuraamme tuhansia julkaisuja maailmanlaajuisesti. Kerro, mistä olet kiinnostunut, niin tekoälymme toimittaa räätälöityjä, tiivistettyjä näkemyksiä Science Monitor -saapuneisiisi joka aamu.",
    home_onboarding_step1_title: "Määritä kiinnostuksenkohteesi",
    home_onboarding_step1_desc: "Luo avustaja antamalla seurattavat hakusanat, kirjoittajat tai aiheet.",
    home_onboarding_step2_title: "Tekoäly ryhtyy töihin",
    home_onboarding_step2_desc: "Kun nukut, tekoälymme etsii maailmanlaajuisista tietokannoista täsmällisiä osumia ja tiivistää tärkeimmät havainnot.",
    home_onboarding_step3_title: "Aloita päiväsi viisaasti",
    home_onboarding_step3_desc: "Avaa saapuneet aamukahvin kanssa. Merkitse luetuksi pyyhkäisemällä oikealle ja poista pyyhkäisemällä vasemmalle.",
    home_onboarding_btn_create: "Luo ensimmäinen tekoälyavustajasi",
    inbox_total: "yhteensä",
    login_subtitle: "Kirjaudu sisään hallitaksesi tutkimusseurantojasi ja nähdäksesi henkilökohtaiset tekoälyanalyysisi.",
    login_google: "Jatka Googlella",
    login_apple: "Jatka Applella",
    login_terms_prefix: "Jatkamalla hyväksyt ",
    login_terms_link: "käyttöehdot",
    login_terms_and: " ja ",
    login_privacy_link: "tietosuojakäytännön",
    portal_login_required: "Sinun on kirjauduttava sisään hallitaksesi tilaustasi.",
    portal_error: "Palvelinvirhe ({status})",
    portal_customer_not_found: "Tälle tilille ei löytynyt Stripe-asiakasta.",
    portal_no_url: "Stripe ei palauttanut URL-osoitetta.",
    portal_opening: "Avataan...",
    portal_btn_manage: "Hallinnoi tilausta",
    offline_title: "Ei internetyhteyttä",
    offline_description: "Sovellus tarvitsee aktiivisen internetyhteyden uusimman tutkimustiedon hakemiseen. Tarkista verkkoasetuksesi.",
    offline_waiting: "Odotetaan verkkoyhteyttä...",
    paywall_checkout_error: "Maksua ei voitu aloittaa. Yritä uudelleen.",
    paywall_checkout_unexpected_error: "Maksun aikana tapahtui odottamaton virhe.",
    paywall_back: "Takaisin",
    paywall_quota_reached_badge: "Kuukausikiintiö täynnä",
    paywall_tier_basic: "Science Monitor Basic",
    paywall_unlock_title: "Avaa kaikki ominaisuudet",
    paywall_quota_desc: "Olet käyttänyt kaikki tilaukseesi tämän kuukauden ajaksi sisältyvät 775 tekoälyn luomaa tutkimusyhteenvetoa. Kiintiö nollautuu automaattisesti ensi kuun ensimmäisenä päivänä.",
    paywall_trial_desc: "Kokeilujaksosi tai siihen sisältyneet haut ovat päättyneet. Tilaa palvelu, jotta saat käyttöösi automaattisen tieteellisen seurannan ja kattavat tekoälyyhteenvedot.",
    paywall_standard_plan: "Vakiotilaus",
    paywall_monthly_sub: "Kuukausitilaus",
    paywall_price_amount: "25 SEK",
    paywall_price_suffix: "/ kuukausi (sis. ALV)",
    paywall_feature_summaries: "Enintään 775 automaattista tekoälyyhteenvetoa kuukaudessa (enintään 5 yössä seurantaa kohden)",
    paywall_feature_watches: "Luo enintään 5 mukautettua tieteellistä seurantaa",
    paywall_feature_saved: "Rajoittamaton pysyvä pääsy tallennettujen artikkelien kirjastoon",
    paywall_feature_cancel: "Peruuta milloin tahansa tiliasetuksista",
    paywall_opening_checkout: "Avataan maksua...",
    paywall_btn_manage: "Hallinnoi tilausta",
    paywall_btn_subscribe: "Tilaa nyt – 25 SEK / kuukausi",
    paywall_back_home: "Takaisin etusivulle",
    paywall_renewal_notice: "Tilaus uusiutuu automaattisesti kuukausittain, kunnes se peruutetaan.",
    paywall_agree_notice: "Tilaamalla hyväksyt ",
    paywall_terms_link: "käyttöehdot",
    paywall_and: " ja ",
    paywall_privacy_link: "tietosuojakäytännön",
    common_back: "Takaisin",
    privacy_title: "Tietosuojakäytäntö",
    privacy_updated: "Päivitetty viimeksi: 22. syyskuuta 2026",
    summaries_header: "Tekoälyn työpöytä",
    summaries_btn_saved: "Tallennettu",
    summaries_btn_save: "Tallenna",
    terms_title: "Käyttöehdot",
    terms_updated: "Päivitetty viimeksi: 22. syyskuuta 2026",
    openalex_no_institution: "Instituutiota ei ole määritetty",
    openalex_no_publisher: "Julkaisijaa ei ole määritetty",
    checkout_login_required: "Sinun on kirjauduttava sisään aloittaaksesi tilauksen.",
    checkout_failed: "Maksua ei voitu aloittaa.",
    paywall_title: "Avaa kaikki ominaisuudet",
    paywall_description: "Kokeilujaksosi tai siihen sisältyneet haut ovat päättyneet. Tilaa palvelu, jotta saat automaattisia tutkimusyhteenvetoja ilman rajoituksia.",
    paywall_purchase_error: "Ostoa ei voitu suorittaa. Yritä uudelleen.",
    paywall_loading: "Ladataan tilausvaihtoehtoja...",
    paywall_popular_badge: "Suosituin",
    paywall_plan_name: "Kuukausitilaus",
    paywall_month_suffix: "kk",
    paywall_cancel_anytime: "Peruuta milloin tahansa tiliasetuksista.",
    paywall_no_packages: "Tilauspaketteja ei ole tällä hetkellä saatavilla.",
    paywall_processing: "Käsitellään...",
    paywall_subscribe_button: "Tilaa nyt",
    paywall_renewal_terms: "Tilaus uusiutuu automaattisesti, ellei sitä peruuteta vähintään 24 tuntia ennen nykyisen jakson päättymistä."
  },
  Italian: {
    inbox_group_other: "Altro",
    error_auth_required: "Errore di autenticazione: devi aver effettuato l'accesso per generare un riepilogo.",
    watch_title_countries: "Paesi: ",
    watch_title_fallback: "Monitoraggio senza nome",
    watch_author_prefix: "Autore: ",
    watch_search_default: "Ricerca",
    summary_no_text: "Nessun testo disponibile.",
    saved_unknown_title: "Titolo sconosciuto",
    saved_from_inbox_topic: "Salvato dalla posta in arrivo",
    error_archive_failed: "Impossibile archiviare l'articolo: ",
    card_blurred_placeholder: "Questo studio esamina i meccanismi sottostanti e i loro effetti...",
    card_quota_title: "Quota mensile esaurita",
    card_quota_desc_desktop: "Hai utilizzato tutti i {maxLimit} riepiloghi AI disponibili per questo mese. Passa a un piano superiore per continuare a ricevere analisi approfondite direttamente nella posta in arrivo.",
    card_quota_desc_mobile: "Hai utilizzato tutti i {maxLimit} riepiloghi. Passa a un piano superiore per continuare.",
    card_quota_btn: "Visualizza abbonamenti",
    home_onboarding_heading: "Non perderti più nessuna scoperta rivoluzionaria.",
    home_onboarding_desc: "Monitoriamo migliaia di pubblicazioni in tutto il mondo. Indicaci i tuoi interessi e ogni mattina la nostra IA invierà alla posta in arrivo di Science Monitor approfondimenti personalizzati e sintetici.",
    home_onboarding_step1_title: "Definisci il tuo ambito",
    home_onboarding_step1_desc: "Crea un assistente inserendo le parole chiave, gli autori o gli argomenti che vuoi monitorare.",
    home_onboarding_step2_title: "L'IA si mette al lavoro",
    home_onboarding_step2_desc: "Mentre dormi, la nostra IA esamina i database globali, trova corrispondenze precise e riassume i risultati principali.",
    home_onboarding_step3_title: "Inizia la giornata con il piede giusto",
    home_onboarding_step3_desc: "Apri la posta in arrivo con il caffè del mattino. Scorri a destra per segnare come letto e a sinistra per eliminare.",
    home_onboarding_btn_create: "Crea il tuo primo assistente IA",
    inbox_total: "totali",
    login_subtitle: "Accedi per gestire i tuoi monitoraggi di ricerca e consultare le tue analisi IA personali.",
    login_google: "Continua con Google",
    login_apple: "Continua con Apple",
    login_terms_prefix: "Continuando, accetti i nostri ",
    login_terms_link: "Termini di servizio",
    login_terms_and: " e la nostra ",
    login_privacy_link: "Informativa sulla privacy",
    portal_login_required: "Devi aver effettuato l'accesso per gestire il tuo abbonamento.",
    portal_error: "Errore del server ({status})",
    portal_customer_not_found: "Non è stato trovato un cliente Stripe per questo account.",
    portal_no_url: "Stripe non ha restituito alcun URL.",
    portal_opening: "Apertura...",
    portal_btn_manage: "Gestisci abbonamento",
    offline_title: "Nessuna connessione Internet",
    offline_description: "L'app richiede una connessione Internet attiva per recuperare le ricerche più recenti. Controlla le impostazioni di rete.",
    offline_waiting: "In attesa della rete...",
    paywall_checkout_error: "Impossibile avviare il pagamento. Riprova.",
    paywall_checkout_unexpected_error: "Si è verificato un errore imprevisto durante il pagamento.",
    paywall_back: "Indietro",
    paywall_quota_reached_badge: "Quota mensile raggiunta",
    paywall_tier_basic: "Science Monitor Basic",
    paywall_unlock_title: "Sblocca l'accesso completo",
    paywall_quota_desc: "Hai utilizzato tutti i 775 riepiloghi di ricerca generati dall'IA inclusi nel tuo piano per questo mese. La quota si ripristinerà automaticamente il primo giorno del mese prossimo.",
    paywall_trial_desc: "Il periodo di prova o le ricerche incluse sono terminati. Abbonati per sbloccare il monitoraggio scientifico automatico e riepiloghi di ricerca IA completi.",
    paywall_standard_plan: "Piano standard",
    paywall_monthly_sub: "Abbonamento mensile",
    paywall_price_amount: "25 SEK",
    paywall_price_suffix: "/ mese (IVA incl.)",
    paywall_feature_summaries: "Fino a 775 riepiloghi IA automatici al mese (fino a 5 per notte per monitoraggio)",
    paywall_feature_watches: "Crea fino a 5 monitoraggi scientifici personalizzati",
    paywall_feature_saved: "Accesso permanente e illimitato alla raccolta degli articoli salvati",
    paywall_feature_cancel: "Annulla in qualsiasi momento dalle impostazioni dell'account",
    paywall_opening_checkout: "Apertura del pagamento...",
    paywall_btn_manage: "Gestisci abbonamento",
    paywall_btn_subscribe: "Abbonati ora – 25 SEK / mese",
    paywall_back_home: "Torna alla home",
    paywall_renewal_notice: "L'abbonamento si rinnova automaticamente ogni mese fino alla disdetta.",
    paywall_agree_notice: "Abbonandoti, accetti i nostri ",
    paywall_terms_link: "Termini di servizio",
    paywall_and: " e l'",
    paywall_privacy_link: "Informativa sulla privacy",
    common_back: "Indietro",
    privacy_title: "Informativa sulla privacy",
    privacy_updated: "Ultimo aggiornamento: 22 settembre 2026",
    summaries_header: "AI Workbench",
    summaries_btn_saved: "Salvato",
    summaries_btn_save: "Salva",
    terms_title: "Termini di servizio",
    terms_updated: "Ultimo aggiornamento: 22 settembre 2026",
    openalex_no_institution: "Nessuna istituzione specificata",
    openalex_no_publisher: "Nessun editore specificato",
    checkout_login_required: "Devi aver effettuato l'accesso per avviare un abbonamento.",
    checkout_failed: "Impossibile avviare il pagamento.",
    paywall_title: "Sblocca l'accesso completo",
    paywall_description: "Il periodo di prova o le ricerche incluse sono terminati. Abbonati per continuare a ricevere riepiloghi automatici della ricerca senza limiti.",
    paywall_purchase_error: "Non è stato possibile completare l'acquisto. Riprova.",
    paywall_loading: "Caricamento delle opzioni di abbonamento...",
    paywall_popular_badge: "Più popolare",
    paywall_plan_name: "Abbonamento mensile",
    paywall_month_suffix: "mesi",
    paywall_cancel_anytime: "Annulla in qualsiasi momento dalle impostazioni dell'account.",
    paywall_no_packages: "Nessun pacchetto di abbonamento è al momento disponibile.",
    paywall_processing: "Elaborazione...",
    paywall_subscribe_button: "Abbonati ora",
    paywall_renewal_terms: "L'abbonamento si rinnova automaticamente, a meno che non venga annullato almeno 24 ore prima della fine del periodo corrente."
  },
  French: {
    inbox_group_other: "Autre",
    error_auth_required: "Erreur d'authentification : vous devez être connecté pour générer un résumé.",
    watch_title_countries: "Pays : ",
    watch_title_fallback: "Veille sans nom",
    watch_author_prefix: "Auteur : ",
    watch_search_default: "Recherche",
    summary_no_text: "Aucun texte disponible.",
    saved_unknown_title: "Titre inconnu",
    saved_from_inbox_topic: "Enregistré depuis la boîte de réception",
    error_archive_failed: "Impossible d'archiver l'article : ",
    card_blurred_placeholder: "Cette étude examine les mécanismes sous-jacents et leurs effets...",
    card_quota_title: "Quota mensuel épuisé",
    card_quota_desc_desktop: "Vous avez utilisé les {maxLimit} résumés IA disponibles ce mois-ci. Passez à une offre supérieure pour continuer à recevoir des analyses approfondies directement dans votre boîte de réception.",
    card_quota_desc_mobile: "Vous avez utilisé les {maxLimit} résumés. Passez à une offre supérieure pour continuer.",
    card_quota_btn: "Voir les abonnements",
    home_onboarding_heading: "Ne manquez plus aucune découverte majeure.",
    home_onboarding_desc: "Nous surveillons des milliers de publications dans le monde entier. Indiquez-nous vos centres d'intérêt et notre IA vous fournira chaque matin des analyses personnalisées et synthétiques dans votre boîte de réception Science Monitor.",
    home_onboarding_step1_title: "Définissez vos centres d'intérêt",
    home_onboarding_step1_desc: "Créez un assistant en indiquant les mots-clés, les auteurs ou les sujets que vous souhaitez suivre.",
    home_onboarding_step2_title: "L'IA se met au travail",
    home_onboarding_step2_desc: "Pendant votre sommeil, notre IA parcourt les bases de données mondiales, trouve les correspondances exactes et résume les principaux résultats.",
    home_onboarding_step3_title: "Commencez bien votre journée",
    home_onboarding_step3_desc: "Ouvrez votre boîte de réception avec votre café du matin. Balayez vers la droite pour marquer comme lu et vers la gauche pour supprimer.",
    home_onboarding_btn_create: "Créer votre premier assistant IA",
    inbox_total: "au total",
    login_subtitle: "Connectez-vous pour gérer vos veilles de recherche et consulter vos analyses IA personnalisées.",
    login_google: "Continuer avec Google",
    login_apple: "Continuer avec Apple",
    login_terms_prefix: "En continuant, vous acceptez nos ",
    login_terms_link: "Conditions d'utilisation",
    login_terms_and: " et notre ",
    login_privacy_link: "Politique de confidentialité",
    portal_login_required: "Vous devez être connecté pour gérer votre abonnement.",
    portal_error: "Erreur du serveur ({status})",
    portal_customer_not_found: "Aucun client Stripe n'a été trouvé pour ce compte.",
    portal_no_url: "Stripe n'a renvoyé aucune URL.",
    portal_opening: "Ouverture...",
    portal_btn_manage: "Gérer l'abonnement",
    offline_title: "Aucune connexion Internet",
    offline_description: "L'application nécessite une connexion Internet active pour récupérer les dernières recherches. Vérifiez vos paramètres réseau.",
    offline_waiting: "En attente du réseau...",
    paywall_checkout_error: "Impossible de lancer le paiement. Veuillez réessayer.",
    paywall_checkout_unexpected_error: "Une erreur inattendue s'est produite lors du paiement.",
    paywall_back: "Retour",
    paywall_quota_reached_badge: "Quota mensuel atteint",
    paywall_tier_basic: "Science Monitor Basic",
    paywall_unlock_title: "Débloquer l'accès complet",
    paywall_quota_desc: "Vous avez utilisé les 775 résumés de recherche générés par l'IA inclus dans votre offre pour ce mois. Votre quota sera automatiquement réinitialisé le premier jour du mois prochain.",
    paywall_trial_desc: "Votre période d'essai ou vos recherches incluses sont terminées. Abonnez-vous pour bénéficier du suivi scientifique automatisé et de résumés de recherche complets par IA.",
    paywall_standard_plan: "Offre standard",
    paywall_monthly_sub: "Abonnement mensuel",
    paywall_price_amount: "25 SEK",
    paywall_price_suffix: "/ mois (TVA incluse)",
    paywall_feature_summaries: "Jusqu'à 775 résumés IA automatisés par mois (jusqu'à 5 par nuit et par veille)",
    paywall_feature_watches: "Créez jusqu'à 5 veilles scientifiques personnalisées",
    paywall_feature_saved: "Accès permanent et illimité à votre bibliothèque d'articles enregistrés",
    paywall_feature_cancel: "Résiliez à tout moment depuis les paramètres de votre compte",
    paywall_opening_checkout: "Ouverture du paiement...",
    paywall_btn_manage: "Gérer l'abonnement",
    paywall_btn_subscribe: "S'abonner – 25 SEK / mois",
    paywall_back_home: "Retour à l'accueil",
    paywall_renewal_notice: "L'abonnement est renouvelé automatiquement chaque mois jusqu'à sa résiliation.",
    paywall_agree_notice: "En vous abonnant, vous acceptez nos ",
    paywall_terms_link: "Conditions d'utilisation",
    paywall_and: " et notre ",
    paywall_privacy_link: "Politique de confidentialité",
    common_back: "Retour",
    privacy_title: "Politique de confidentialité",
    privacy_updated: "Dernière mise à jour : 22 septembre 2026",
    summaries_header: "AI Workbench",
    summaries_btn_saved: "Enregistré",
    summaries_btn_save: "Enregistrer",
    terms_title: "Conditions d'utilisation",
    terms_updated: "Dernière mise à jour : 22 septembre 2026",
    openalex_no_institution: "Aucun établissement indiqué",
    openalex_no_publisher: "Aucun éditeur indiqué",
    checkout_login_required: "Vous devez être connecté pour démarrer un abonnement.",
    checkout_failed: "Impossible de lancer le paiement.",
    paywall_title: "Débloquer l'accès complet",
    paywall_description: "Votre période d'essai ou vos recherches incluses sont terminées. Abonnez-vous pour continuer à recevoir des résumés de recherche automatisés sans limite.",
    paywall_purchase_error: "L'achat n'a pas pu aboutir. Veuillez réessayer.",
    paywall_loading: "Chargement des options d'abonnement...",
    paywall_popular_badge: "Le plus populaire",
    paywall_plan_name: "Abonnement mensuel",
    paywall_month_suffix: "mois",
    paywall_cancel_anytime: "Résiliez à tout moment depuis les paramètres de votre compte.",
    paywall_no_packages: "Aucune formule d'abonnement n'est disponible pour le moment.",
    paywall_processing: "Traitement en cours...",
    paywall_subscribe_button: "S'abonner maintenant",
    paywall_renewal_terms: "L'abonnement est renouvelé automatiquement, sauf résiliation au moins 24 heures avant la fin de la période en cours."
  },
  German: {
    inbox_group_other: "Sonstiges",
    error_auth_required: "Authentifizierungsfehler: Du musst angemeldet sein, um eine Zusammenfassung zu erstellen.",
    watch_title_countries: "Länder: ",
    watch_title_fallback: "Unbenannte Überwachung",
    watch_author_prefix: "Autor: ",
    watch_search_default: "Suche",
    summary_no_text: "Kein Text verfügbar.",
    saved_unknown_title: "Unbekannter Titel",
    saved_from_inbox_topic: "Aus dem Posteingang gespeichert",
    error_archive_failed: "Der Artikel konnte nicht archiviert werden: ",
    card_blurred_placeholder: "Diese Studie untersucht die zugrunde liegenden Mechanismen und ihre Auswirkungen...",
    card_quota_title: "Monatliches Kontingent aufgebraucht",
    card_quota_desc_desktop: "Du hast alle {maxLimit} KI-Zusammenfassungen für diesen Monat verwendet. Führe ein Upgrade durch, um weiterhin ausführliche Analysen direkt in deinem Posteingang zu erhalten.",
    card_quota_desc_mobile: "Du hast alle {maxLimit} Zusammenfassungen verwendet. Führe ein Upgrade durch, um fortzufahren.",
    card_quota_btn: "Abonnements anzeigen",
    home_onboarding_heading: "Verpasse nie wieder einen Durchbruch.",
    home_onboarding_desc: "Wir überwachen weltweit Tausende von Veröffentlichungen. Teile uns deine Interessen mit und unsere KI liefert dir jeden Morgen maßgeschneiderte, zusammengefasste Erkenntnisse direkt in deinen Science-Monitor-Posteingang.",
    home_onboarding_step1_title: "Lege deinen Schwerpunkt fest",
    home_onboarding_step1_desc: "Erstelle einen Assistenten, indem du die Suchbegriffe, Autoren oder Themen eingibst, die du überwachen möchtest.",
    home_onboarding_step2_title: "Die KI macht sich an die Arbeit",
    home_onboarding_step2_desc: "Während du schläfst, durchsucht unsere KI globale Datenbanken, findet passende Treffer und fasst die wichtigsten Ergebnisse zusammen.",
    home_onboarding_step3_title: "Starte gut in den Tag",
    home_onboarding_step3_desc: "Öffne deinen Posteingang beim Morgenkaffee. Wische nach rechts, um Artikel als gelesen zu markieren, und nach links, um sie zu löschen.",
    home_onboarding_btn_create: "Ersten KI-Assistenten erstellen",
    inbox_total: "insgesamt",
    login_subtitle: "Melde dich an, um deine Forschungsüberwachungen zu verwalten und deine persönlichen KI-Analysen anzusehen.",
    login_google: "Mit Google fortfahren",
    login_apple: "Mit Apple fortfahren",
    login_terms_prefix: "Wenn du fortfährst, akzeptierst du unsere ",
    login_terms_link: "Nutzungsbedingungen",
    login_terms_and: " und unsere ",
    login_privacy_link: "Datenschutzerklärung",
    portal_login_required: "Du musst angemeldet sein, um dein Abonnement zu verwalten.",
    portal_error: "Serverfehler ({status})",
    portal_customer_not_found: "Für dieses Konto wurde kein Stripe-Kunde gefunden.",
    portal_no_url: "Stripe hat keine URL zurückgegeben.",
    portal_opening: "Wird geöffnet...",
    portal_btn_manage: "Abonnement verwalten",
    offline_title: "Keine Internetverbindung",
    offline_description: "Die App benötigt eine aktive Internetverbindung, um die neueste Forschung abzurufen. Bitte überprüfe deine Netzwerkeinstellungen.",
    offline_waiting: "Warte auf Netzwerk...",
    paywall_checkout_error: "Der Bezahlvorgang konnte nicht gestartet werden. Bitte versuche es erneut.",
    paywall_checkout_unexpected_error: "Beim Bezahlvorgang ist ein unerwarteter Fehler aufgetreten.",
    paywall_back: "Zurück",
    paywall_quota_reached_badge: "Monatskontingent erreicht",
    paywall_tier_basic: "Science Monitor Basic",
    paywall_unlock_title: "Vollen Zugriff freischalten",
    paywall_quota_desc: "Du hast alle 775 KI-generierten Forschungszusammenfassungen aufgebraucht, die in diesem Monat in deinem Tarif enthalten sind. Dein Kontingent wird am ersten Tag des nächsten Monats automatisch zurückgesetzt.",
    paywall_trial_desc: "Dein Testzeitraum oder die enthaltenen Suchanfragen sind abgelaufen. Abonniere den Dienst, um automatische wissenschaftliche Überwachung und umfassende KI-Forschungszusammenfassungen freizuschalten.",
    paywall_standard_plan: "Standardtarif",
    paywall_monthly_sub: "Monatsabonnement",
    paywall_price_amount: "25 SEK",
    paywall_price_suffix: "/ Monat (inkl. MwSt.)",
    paywall_feature_summaries: "Bis zu 775 automatische KI-Zusammenfassungen pro Monat (bis zu 5 pro Nacht und Überwachung)",
    paywall_feature_watches: "Erstelle bis zu 5 individuelle wissenschaftliche Überwachungen",
    paywall_feature_saved: "Unbegrenzter, dauerhafter Zugriff auf deine Bibliothek gespeicherter Artikel",
    paywall_feature_cancel: "Jederzeit über die Kontoeinstellungen kündbar",
    paywall_opening_checkout: "Bezahlvorgang wird geöffnet...",
    paywall_btn_manage: "Abonnement verwalten",
    paywall_btn_subscribe: "Jetzt abonnieren – 25 SEK / Monat",
    paywall_back_home: "Zurück zur Startseite",
    paywall_renewal_notice: "Das Abonnement verlängert sich automatisch jeden Monat, bis es gekündigt wird.",
    paywall_agree_notice: "Mit deinem Abonnement akzeptierst du unsere ",
    paywall_terms_link: "Nutzungsbedingungen",
    paywall_and: " und unsere ",
    paywall_privacy_link: "Datenschutzerklärung",
    common_back: "Zurück",
    privacy_title: "Datenschutzerklärung",
    privacy_updated: "Zuletzt aktualisiert: 22. September 2026",
    summaries_header: "KI-Werkbank",
    summaries_btn_saved: "Gespeichert",
    summaries_btn_save: "Speichern",
    terms_title: "Nutzungsbedingungen",
    terms_updated: "Zuletzt aktualisiert: 22. September 2026",
    openalex_no_institution: "Keine Institution angegeben",
    openalex_no_publisher: "Kein Herausgeber angegeben",
    checkout_login_required: "Du musst angemeldet sein, um ein Abonnement zu starten.",
    checkout_failed: "Der Bezahlvorgang konnte nicht gestartet werden.",
    paywall_title: "Vollen Zugriff freischalten",
    paywall_description: "Dein Testzeitraum oder die enthaltenen Suchanfragen sind abgelaufen. Abonniere den Dienst, um weiterhin unbegrenzt automatische Forschungszusammenfassungen zu erhalten.",
    paywall_purchase_error: "Der Kauf konnte nicht abgeschlossen werden. Bitte versuche es erneut.",
    paywall_loading: "Abonnementoptionen werden geladen...",
    paywall_popular_badge: "Am beliebtesten",
    paywall_plan_name: "Monatsabonnement",
    paywall_month_suffix: "Mon.",
    paywall_cancel_anytime: "Jederzeit über die Kontoeinstellungen kündbar.",
    paywall_no_packages: "Derzeit sind keine Abonnementpakete verfügbar.",
    paywall_processing: "Wird verarbeitet...",
    paywall_subscribe_button: "Jetzt abonnieren",
    paywall_renewal_terms: "Das Abonnement verlängert sich automatisch, sofern es nicht mindestens 24 Stunden vor Ablauf des aktuellen Zeitraums gekündigt wird."
  },
  Spanish: {
    inbox_group_other: "Otros",
    error_auth_required: "Error de autenticación: debes iniciar sesión para generar un resumen.",
    watch_title_countries: "Países: ",
    watch_title_fallback: "Seguimiento sin nombre",
    watch_author_prefix: "Autor: ",
    watch_search_default: "Búsqueda",
    summary_no_text: "No hay texto disponible.",
    saved_unknown_title: "Título desconocido",
    saved_from_inbox_topic: "Guardado desde la bandeja de entrada",
    error_archive_failed: "No se pudo archivar el artículo: ",
    card_blurred_placeholder: "Este estudio investiga los mecanismos subyacentes y sus efectos...",
    card_quota_title: "Se ha agotado la cuota mensual",
    card_quota_desc_desktop: "Has utilizado los {maxLimit} resúmenes de IA disponibles este mes. Mejora tu plan para seguir recibiendo análisis detallados directamente en tu bandeja de entrada.",
    card_quota_desc_mobile: "Has utilizado los {maxLimit} resúmenes. Mejora tu plan para continuar.",
    card_quota_btn: "Ver suscripciones",
    home_onboarding_heading: "No vuelvas a perderte un gran avance.",
    home_onboarding_desc: "Supervisamos miles de publicaciones de todo el mundo. Cuéntanos qué te interesa y nuestra IA te enviará cada mañana información personalizada y resumida a tu bandeja de entrada de Science Monitor.",
    home_onboarding_step1_title: "Define tus intereses",
    home_onboarding_step1_desc: "Crea un asistente indicando las palabras clave, autores o temas que quieras seguir.",
    home_onboarding_step2_title: "La IA se pone manos a la obra",
    home_onboarding_step2_desc: "Mientras duermes, nuestra IA explora bases de datos globales, encuentra coincidencias exactas y resume los hallazgos principales.",
    home_onboarding_step3_title: "Empieza el día con buen pie",
    home_onboarding_step3_desc: "Abre tu bandeja de entrada con el café de la mañana. Desliza a la derecha para marcar como leído y a la izquierda para eliminar.",
    home_onboarding_btn_create: "Crea tu primer asistente de IA",
    inbox_total: "en total",
    login_subtitle: "Inicia sesión para gestionar tus seguimientos de investigación y consultar tus análisis personales de IA.",
    login_google: "Continuar con Google",
    login_apple: "Continuar con Apple",
    login_terms_prefix: "Al continuar, aceptas nuestros ",
    login_terms_link: "Términos del servicio",
    login_terms_and: " y nuestra ",
    login_privacy_link: "Política de privacidad",
    portal_login_required: "Debes iniciar sesión para gestionar tu suscripción.",
    portal_error: "Error del servidor ({status})",
    portal_customer_not_found: "No se encontró ningún cliente de Stripe para esta cuenta.",
    portal_no_url: "Stripe no devolvió ninguna URL.",
    portal_opening: "Abriendo...",
    portal_btn_manage: "Gestionar suscripción",
    offline_title: "Sin conexión a Internet",
    offline_description: "La aplicación necesita una conexión activa a Internet para obtener las últimas investigaciones. Comprueba la configuración de red.",
    offline_waiting: "Esperando conexión...",
    paywall_checkout_error: "No se pudo iniciar el pago. Inténtalo de nuevo.",
    paywall_checkout_unexpected_error: "Se produjo un error inesperado durante el pago.",
    paywall_back: "Volver",
    paywall_quota_reached_badge: "Cuota mensual alcanzada",
    paywall_tier_basic: "Science Monitor Basic",
    paywall_unlock_title: "Desbloquear acceso completo",
    paywall_quota_desc: "Has utilizado los 775 resúmenes de investigación generados por IA incluidos en tu plan para este mes. La cuota se restablecerá automáticamente el primer día del próximo mes.",
    paywall_trial_desc: "Tu periodo de prueba o las búsquedas incluidas han terminado. Suscríbete para desbloquear el seguimiento científico automático y resúmenes completos de investigación con IA.",
    paywall_standard_plan: "Plan estándar",
    paywall_monthly_sub: "Suscripción mensual",
    paywall_price_amount: "25 SEK",
    paywall_price_suffix: "/ mes (IVA incluido)",
    paywall_feature_summaries: "Hasta 775 resúmenes automáticos de IA al mes (hasta 5 por noche y seguimiento)",
    paywall_feature_watches: "Crea hasta 5 seguimientos científicos personalizados",
    paywall_feature_saved: "Acceso permanente e ilimitado a tu biblioteca de artículos guardados",
    paywall_feature_cancel: "Cancela cuando quieras desde la configuración de tu cuenta",
    paywall_opening_checkout: "Abriendo el pago...",
    paywall_btn_manage: "Gestionar suscripción",
    paywall_btn_subscribe: "Suscribirse ahora – 25 SEK / mes",
    paywall_back_home: "Volver al inicio",
    paywall_renewal_notice: "La suscripción se renueva automáticamente cada mes hasta que se cancele.",
    paywall_agree_notice: "Al suscribirte, aceptas nuestros ",
    paywall_terms_link: "Términos del servicio",
    paywall_and: " y nuestra ",
    paywall_privacy_link: "Política de privacidad",
    common_back: "Volver",
    privacy_title: "Política de privacidad",
    privacy_updated: "Última actualización: 22 de septiembre de 2026",
    summaries_header: "AI Workbench",
    summaries_btn_saved: "Guardado",
    summaries_btn_save: "Guardar",
    terms_title: "Términos del servicio",
    terms_updated: "Última actualización: 22 de septiembre de 2026",
    openalex_no_institution: "No se ha indicado ninguna institución",
    openalex_no_publisher: "No se ha indicado ningún editor",
    checkout_login_required: "Debes iniciar sesión para empezar una suscripción.",
    checkout_failed: "No se pudo iniciar el pago.",
    paywall_title: "Desbloquear acceso completo",
    paywall_description: "Tu periodo de prueba o las búsquedas incluidas han terminado. Suscríbete para seguir recibiendo resúmenes de investigación automáticos sin límites.",
    paywall_purchase_error: "No se pudo completar la compra. Inténtalo de nuevo.",
    paywall_loading: "Cargando opciones de suscripción...",
    paywall_popular_badge: "Más popular",
    paywall_plan_name: "Suscripción mensual",
    paywall_month_suffix: "mes",
    paywall_cancel_anytime: "Cancela cuando quieras desde la configuración de tu cuenta.",
    paywall_no_packages: "No hay paquetes de suscripción disponibles en este momento.",
    paywall_processing: "Procesando...",
    paywall_subscribe_button: "Suscribirse ahora",
    paywall_renewal_terms: "La suscripción se renueva automáticamente, salvo que se cancele al menos 24 horas antes de que termine el periodo actual."
  },
  Portuguese: {
    inbox_group_other: "Outro",
    error_auth_required: "Erro de autenticação: tem de iniciar sessão para gerar um resumo.",
    watch_title_countries: "Países: ",
    watch_title_fallback: "Monitorização sem nome",
    watch_author_prefix: "Autor: ",
    watch_search_default: "Pesquisa",
    summary_no_text: "Não há texto disponível.",
    saved_unknown_title: "Título desconhecido",
    saved_from_inbox_topic: "Guardado da caixa de entrada",
    error_archive_failed: "Não foi possível arquivar o artigo: ",
    card_blurred_placeholder: "Este estudo analisa os mecanismos subjacentes e os seus efeitos...",
    card_quota_title: "Quota mensal esgotada",
    card_quota_desc_desktop: "Já utilizou os {maxLimit} resumos de IA disponíveis para este mês. Atualize o seu plano para continuar a receber análises aprofundadas diretamente na caixa de entrada.",
    card_quota_desc_mobile: "Já utilizou os {maxLimit} resumos. Atualize o seu plano para continuar.",
    card_quota_btn: "Ver subscrições",
    home_onboarding_heading: "Nunca mais perca uma descoberta revolucionária.",
    home_onboarding_desc: "Monitorizamos milhares de publicações em todo o mundo. Diga-nos o que lhe interessa e a nossa IA enviará todas as manhãs informações personalizadas e resumidas para a sua caixa de entrada do Science Monitor.",
    home_onboarding_step1_title: "Defina os seus interesses",
    home_onboarding_step1_desc: "Crie um assistente indicando as palavras-chave, os autores ou os temas que pretende acompanhar.",
    home_onboarding_step2_title: "A IA começa a trabalhar",
    home_onboarding_step2_desc: "Enquanto dorme, a nossa IA pesquisa bases de dados globais, encontra correspondências exatas e resume as principais conclusões.",
    home_onboarding_step3_title: "Comece bem o seu dia",
    home_onboarding_step3_desc: "Abra a caixa de entrada com o café da manhã. Deslize para a direita para marcar como lido e para a esquerda para eliminar.",
    home_onboarding_btn_create: "Criar o seu primeiro assistente de IA",
    inbox_total: "no total",
    login_subtitle: "Inicie sessão para gerir as suas monitorizações de investigação e consultar as suas análises pessoais de IA.",
    login_google: "Continuar com o Google",
    login_apple: "Continuar com a Apple",
    login_terms_prefix: "Ao continuar, aceita os nossos ",
    login_terms_link: "Termos de Serviço",
    login_terms_and: " e a nossa ",
    login_privacy_link: "Política de Privacidade",
    portal_login_required: "Tem de iniciar sessão para gerir a sua subscrição.",
    portal_error: "Erro do servidor ({status})",
    portal_customer_not_found: "Não foi encontrado um cliente Stripe para esta conta.",
    portal_no_url: "O Stripe não devolveu um URL.",
    portal_opening: "A abrir...",
    portal_btn_manage: "Gerir subscrição",
    offline_title: "Sem ligação à Internet",
    offline_description: "A aplicação precisa de uma ligação ativa à Internet para obter as pesquisas mais recentes. Verifique as definições de rede.",
    offline_waiting: "À espera da rede...",
    paywall_checkout_error: "Não foi possível iniciar o pagamento. Tente novamente.",
    paywall_checkout_unexpected_error: "Ocorreu um erro inesperado durante o pagamento.",
    paywall_back: "Voltar",
    paywall_quota_reached_badge: "Quota mensal atingida",
    paywall_tier_basic: "Science Monitor Basic",
    paywall_unlock_title: "Desbloquear acesso completo",
    paywall_quota_desc: "Já utilizou os 775 resumos de investigação gerados por IA incluídos no seu plano para este mês. A quota será reposta automaticamente no primeiro dia do próximo mês.",
    paywall_trial_desc: "O período de avaliação ou as pesquisas incluídas terminaram. Subscreva para desbloquear a monitorização científica automática e resumos de investigação abrangentes com IA.",
    paywall_standard_plan: "Plano padrão",
    paywall_monthly_sub: "Subscrição mensal",
    paywall_price_amount: "25 SEK",
    paywall_price_suffix: "/ mês (IVA incluído)",
    paywall_feature_summaries: "Até 775 resumos automáticos de IA por mês (até 5 por noite e monitorização)",
    paywall_feature_watches: "Crie até 5 monitorizações científicas personalizadas",
    paywall_feature_saved: "Acesso permanente e ilimitado à biblioteca de artigos guardados",
    paywall_feature_cancel: "Cancele a qualquer momento nas definições da conta",
    paywall_opening_checkout: "A abrir o pagamento...",
    paywall_btn_manage: "Gerir subscrição",
    paywall_btn_subscribe: "Subscrever agora – 25 SEK / mês",
    paywall_back_home: "Voltar ao início",
    paywall_renewal_notice: "A subscrição é renovada automaticamente todos os meses até ser cancelada.",
    paywall_agree_notice: "Ao subscrever, aceita os nossos ",
    paywall_terms_link: "Termos de Serviço",
    paywall_and: " e a nossa ",
    paywall_privacy_link: "Política de Privacidade",
    common_back: "Voltar",
    privacy_title: "Política de Privacidade",
    privacy_updated: "Última atualização: 22 de setembro de 2026",
    summaries_header: "AI Workbench",
    summaries_btn_saved: "Guardado",
    summaries_btn_save: "Guardar",
    terms_title: "Termos de Serviço",
    terms_updated: "Última atualização: 22 de setembro de 2026",
    openalex_no_institution: "Nenhuma instituição indicada",
    openalex_no_publisher: "Nenhuma editora indicada",
    checkout_login_required: "Tem de iniciar sessão para começar uma subscrição.",
    checkout_failed: "Não foi possível iniciar o pagamento.",
    paywall_title: "Desbloquear acesso completo",
    paywall_description: "O período de avaliação ou as pesquisas incluídas terminaram. Subscreva para continuar a receber resumos automáticos de investigação sem limites.",
    paywall_purchase_error: "Não foi possível concluir a compra. Tente novamente.",
    paywall_loading: "A carregar opções de subscrição...",
    paywall_popular_badge: "Mais popular",
    paywall_plan_name: "Subscrição mensal",
    paywall_month_suffix: "mês",
    paywall_cancel_anytime: "Cancele a qualquer momento nas definições da conta.",
    paywall_no_packages: "Não existem pacotes de subscrição disponíveis neste momento.",
    paywall_processing: "A processar...",
    paywall_subscribe_button: "Subscrever agora",
    paywall_renewal_terms: "A subscrição é renovada automaticamente, salvo cancelamento pelo menos 24 horas antes do fim do período atual."
  },
  Hindi: {
    inbox_group_other: "अन्य",
    error_auth_required: "प्रमाणीकरण त्रुटि: सारांश बनाने के लिए आपको लॉग इन करना होगा।",
    watch_title_countries: "देश: ",
    watch_title_fallback: "बिना नाम की निगरानी",
    watch_author_prefix: "लेखक: ",
    watch_search_default: "खोज",
    summary_no_text: "कोई पाठ उपलब्ध नहीं है।",
    saved_unknown_title: "अज्ञात शीर्षक",
    saved_from_inbox_topic: "इनबॉक्स से सहेजा गया",
    error_archive_failed: "लेख को संग्रहित नहीं किया जा सका: ",
    card_blurred_placeholder: "यह अध्ययन अंतर्निहित तंत्रों और उनके प्रभावों की जाँच करता है...",
    card_quota_title: "मासिक सीमा समाप्त हो गई",
    card_quota_desc_desktop: "आपने इस महीने के सभी {maxLimit} AI सारांशों का उपयोग कर लिया है। इनबॉक्स में विस्तृत विश्लेषण पाने के लिए अपग्रेड करें।",
    card_quota_desc_mobile: "आपने सभी {maxLimit} सारांशों का उपयोग कर लिया है। जारी रखने के लिए अपग्रेड करें।",
    card_quota_btn: "सदस्यताएँ देखें",
    home_onboarding_heading: "अब कोई बड़ी वैज्ञानिक खोज आपसे न छूटे।",
    home_onboarding_desc: "हम दुनिया भर के हज़ारों प्रकाशनों पर नज़र रखते हैं। अपनी रुचि के विषय बताएँ और हमारी AI हर सुबह Science Monitor इनबॉक्स में आपके लिए चुनी हुई, संक्षिप्त जानकारी भेजेगी।",
    home_onboarding_step1_title: "अपनी रुचि तय करें",
    home_onboarding_step1_desc: "जिन कीवर्ड, लेखकों या विषयों पर नज़र रखनी है, उन्हें दर्ज करके एक सहायक बनाएँ।",
    home_onboarding_step2_title: "AI काम शुरू करती है",
    home_onboarding_step2_desc: "जब आप सो रहे होते हैं, हमारी AI वैश्विक डेटाबेस खोजती है, सटीक परिणाम ढूँढ़ती है और मुख्य निष्कर्षों का सारांश बनाती है।",
    home_onboarding_step3_title: "दिन की शुरुआत समझदारी से करें",
    home_onboarding_step3_desc: "सुबह की कॉफ़ी के साथ इनबॉक्स खोलें। पढ़ा हुआ चिह्नित करने के लिए दाईं ओर और हटाने के लिए बाईं ओर स्वाइप करें।",
    home_onboarding_btn_create: "अपना पहला AI सहायक बनाएँ",
    inbox_total: "कुल",
    login_subtitle: "अपनी शोध निगरानियों को प्रबंधित करने और व्यक्तिगत AI विश्लेषण देखने के लिए लॉग इन करें।",
    login_google: "Google के साथ जारी रखें",
    login_apple: "Apple के साथ जारी रखें",
    login_terms_prefix: "जारी रखकर आप हमारी ",
    login_terms_link: "सेवा की शर्तें",
    login_terms_and: " और ",
    login_privacy_link: "गोपनीयता नीति",
    portal_login_required: "सदस्यता प्रबंधित करने के लिए आपको लॉग इन करना होगा।",
    portal_error: "सर्वर त्रुटि ({status})",
    portal_customer_not_found: "इस खाते के लिए कोई Stripe ग्राहक नहीं मिला।",
    portal_no_url: "Stripe से कोई URL प्राप्त नहीं हुआ।",
    portal_opening: "खोला जा रहा है...",
    portal_btn_manage: "सदस्यता प्रबंधित करें",
    offline_title: "इंटरनेट कनेक्शन नहीं है",
    offline_description: "नवीनतम शोध प्राप्त करने के लिए ऐप को सक्रिय इंटरनेट कनेक्शन चाहिए। अपनी नेटवर्क सेटिंग जाँचें।",
    offline_waiting: "नेटवर्क की प्रतीक्षा है...",
    paywall_checkout_error: "भुगतान शुरू नहीं हो सका। कृपया फिर से प्रयास करें।",
    paywall_checkout_unexpected_error: "भुगतान के दौरान एक अप्रत्याशित त्रुटि हुई।",
    paywall_back: "वापस",
    paywall_quota_reached_badge: "मासिक सीमा पूरी हो गई",
    paywall_tier_basic: "Science Monitor Basic",
    paywall_unlock_title: "पूर्ण पहुँच अनलॉक करें",
    paywall_quota_desc: "आपने इस महीने की योजना में शामिल सभी 775 AI-निर्मित शोध सारांशों का उपयोग कर लिया है। आपकी सीमा अगले महीने की पहली तारीख को अपने आप रीसेट हो जाएगी।",
    paywall_trial_desc: "आपकी परीक्षण अवधि या शामिल खोजें समाप्त हो गई हैं। स्वचालित वैज्ञानिक निगरानी और विस्तृत AI शोध सारांश पाने के लिए सदस्यता लें।",
    paywall_standard_plan: "मानक योजना",
    paywall_monthly_sub: "मासिक सदस्यता",
    paywall_price_amount: "25 SEK",
    paywall_price_suffix: "/ माह (कर सहित)",
    paywall_feature_summaries: "हर महीने 775 तक स्वचालित AI सारांश (प्रति निगरानी हर रात अधिकतम 5)",
    paywall_feature_watches: "5 तक अनुकूलित वैज्ञानिक निगरानियाँ बनाएँ",
    paywall_feature_saved: "सहेजे गए लेखों की लाइब्रेरी तक असीमित स्थायी पहुँच",
    paywall_feature_cancel: "खाता सेटिंग से कभी भी रद्द करें",
    paywall_opening_checkout: "भुगतान पृष्ठ खोला जा रहा है...",
    paywall_btn_manage: "सदस्यता प्रबंधित करें",
    paywall_btn_subscribe: "अभी सदस्यता लें – 25 SEK / माह",
    paywall_back_home: "मुखपृष्ठ पर वापस जाएँ",
    paywall_renewal_notice: "रद्द किए जाने तक सदस्यता हर महीने अपने आप नवीनीकृत होती है।",
    paywall_agree_notice: "सदस्यता लेकर आप हमारी ",
    paywall_terms_link: "सेवा की शर्तें",
    paywall_and: " और ",
    paywall_privacy_link: "गोपनीयता नीति",
    common_back: "वापस",
    privacy_title: "गोपनीयता नीति",
    privacy_updated: "अंतिम अपडेट: 22 सितंबर 2026",
    summaries_header: "AI कार्यक्षेत्र",
    summaries_btn_saved: "सहेजा गया",
    summaries_btn_save: "सहेजें",
    terms_title: "सेवा की शर्तें",
    terms_updated: "अंतिम अपडेट: 22 सितंबर 2026",
    openalex_no_institution: "कोई संस्थान निर्दिष्ट नहीं",
    openalex_no_publisher: "कोई प्रकाशक निर्दिष्ट नहीं",
    checkout_login_required: "सदस्यता शुरू करने के लिए आपको लॉग इन करना होगा।",
    checkout_failed: "भुगतान शुरू नहीं हो सका।",
    paywall_title: "पूर्ण पहुँच अनलॉक करें",
    paywall_description: "आपकी परीक्षण अवधि या शामिल खोजें समाप्त हो गई हैं। बिना सीमा के स्वचालित शोध सारांश पाने के लिए सदस्यता लें।",
    paywall_purchase_error: "खरीद पूरी नहीं हो सकी। कृपया फिर से प्रयास करें।",
    paywall_loading: "सदस्यता विकल्प लोड हो रहे हैं...",
    paywall_popular_badge: "सबसे लोकप्रिय",
    paywall_plan_name: "मासिक सदस्यता",
    paywall_month_suffix: "माह",
    paywall_cancel_anytime: "खाता सेटिंग से कभी भी रद्द करें।",
    paywall_no_packages: "इस समय सदस्यता पैकेज उपलब्ध नहीं हैं।",
    paywall_processing: "प्रक्रिया जारी है...",
    paywall_subscribe_button: "अभी सदस्यता लें",
    paywall_renewal_terms: "वर्तमान अवधि समाप्त होने से कम से कम 24 घंटे पहले रद्द न करने पर सदस्यता अपने आप नवीनीकृत हो जाएगी।"
  },
  Mandarin: {
    inbox_group_other: "其他",
    error_auth_required: "身份验证错误：您必须登录后才能生成摘要。",
    watch_title_countries: "国家/地区：",
    watch_title_fallback: "未命名监测",
    watch_author_prefix: "作者：",
    watch_search_default: "搜索",
    summary_no_text: "没有可用文本。",
    saved_unknown_title: "未知标题",
    saved_from_inbox_topic: "从收件箱保存",
    error_archive_failed: "无法归档文章：",
    card_blurred_placeholder: "本研究探讨了潜在机制及其影响……",
    card_quota_title: "本月额度已用完",
    card_quota_desc_desktop: "您已用完本月的 {maxLimit} 条 AI 摘要。升级后即可继续在收件箱中获取深入分析。",
    card_quota_desc_mobile: "您已用完全部 {maxLimit} 条摘要。升级后即可继续使用。",
    card_quota_btn: "查看订阅",
    home_onboarding_heading: "不错过任何重大突破。",
    home_onboarding_desc: "我们监测全球数千种出版物。告诉我们您关注的领域，AI 每天早晨会将量身定制的摘要见解发送到 Science Monitor 收件箱。",
    home_onboarding_step1_title: "确定关注方向",
    home_onboarding_step1_desc: "输入想要监测的关键词、作者或主题，创建一个助手。",
    home_onboarding_step2_title: "AI 开始工作",
    home_onboarding_step2_desc: "您休息时，AI 会扫描全球数据库、查找精准匹配，并总结核心发现。",
    home_onboarding_step3_title: "聪明地开启新一天",
    home_onboarding_step3_desc: "伴着晨间咖啡打开收件箱。向右滑动标记为已读，向左滑动删除。",
    home_onboarding_btn_create: "创建您的首个 AI 助手",
    inbox_total: "条",
    login_subtitle: "登录以管理您的研究监测并查看个性化 AI 分析。",
    login_google: "使用 Google 继续",
    login_apple: "使用 Apple 继续",
    login_terms_prefix: "继续即表示您同意我们的",
    login_terms_link: "服务条款",
    login_terms_and: "和",
    login_privacy_link: "隐私政策",
    portal_login_required: "您必须登录后才能管理订阅。",
    portal_error: "服务器错误（{status}）",
    portal_customer_not_found: "未找到此账户对应的 Stripe 客户。",
    portal_no_url: "Stripe 未返回 URL。",
    portal_opening: "正在打开...",
    portal_btn_manage: "管理订阅",
    offline_title: "没有互联网连接",
    offline_description: "应用需要有效的互联网连接才能获取最新研究。请检查网络设置。",
    offline_waiting: "正在等待网络...",
    paywall_checkout_error: "无法启动结账。请重试。",
    paywall_checkout_unexpected_error: "结账过程中发生意外错误。",
    paywall_back: "返回",
    paywall_quota_reached_badge: "本月额度已达上限",
    paywall_tier_basic: "Science Monitor Basic",
    paywall_unlock_title: "解锁完整访问权限",
    paywall_quota_desc: "您已用完本月套餐包含的 775 条 AI 生成研究摘要。额度将在下月 1 日自动重置。",
    paywall_trial_desc: "您的试用期或套餐内搜索次数已用完。订阅即可解锁自动科学监测和全面的 AI 研究摘要。",
    paywall_standard_plan: "标准套餐",
    paywall_monthly_sub: "月度订阅",
    paywall_price_amount: "25 SEK",
    paywall_price_suffix: "/ 月（含增值税）",
    paywall_feature_summaries: "每月最多 775 条自动 AI 摘要（每个监测每晚最多 5 条）",
    paywall_feature_watches: "创建最多 5 个自定义科学监测",
    paywall_feature_saved: "永久无限访问已保存文章库",
    paywall_feature_cancel: "可随时在账户设置中取消",
    paywall_opening_checkout: "正在打开结账页面...",
    paywall_btn_manage: "管理订阅",
    paywall_btn_subscribe: "立即订阅 – 每月 25 SEK",
    paywall_back_home: "返回首页",
    paywall_renewal_notice: "订阅将按月自动续订，直至取消。",
    paywall_agree_notice: "订阅即表示您同意我们的",
    paywall_terms_link: "服务条款",
    paywall_and: "和",
    paywall_privacy_link: "隐私政策",
    common_back: "返回",
    privacy_title: "隐私政策",
    privacy_updated: "最后更新：2026 年 9 月 22 日",
    summaries_header: "AI 工作台",
    summaries_btn_saved: "已保存",
    summaries_btn_save: "保存",
    terms_title: "服务条款",
    terms_updated: "最后更新：2026 年 9 月 22 日",
    openalex_no_institution: "未注明机构",
    openalex_no_publisher: "未注明出版商",
    checkout_login_required: "您必须登录后才能开始订阅。",
    checkout_failed: "无法启动付款。",
    paywall_title: "解锁完整访问权限",
    paywall_description: "您的试用期或套餐内搜索次数已用完。订阅即可继续无限接收自动研究摘要。",
    paywall_purchase_error: "无法完成购买。请重试。",
    paywall_loading: "正在加载订阅选项...",
    paywall_popular_badge: "最受欢迎",
    paywall_plan_name: "月度订阅",
    paywall_month_suffix: "个月",
    paywall_cancel_anytime: "可随时在账户设置中取消。",
    paywall_no_packages: "目前没有可用的订阅套餐。",
    paywall_processing: "正在处理...",
    paywall_subscribe_button: "立即订阅",
    paywall_renewal_terms: "除非在当前周期结束前至少 24 小时取消，否则订阅将自动续订。"
  }
};

const completionTranslations = {
  Swedish: {
    share_btn: 'Dela', share_copied: 'Kopierat!', share_success: 'Delat!', share_title: 'Dela sammanfattning',
    share_footer: 'Läs mer via Science Monitor:'
  },
  English: {
    share_btn: 'Share', share_copied: 'Copied!', share_success: 'Shared!', share_title: 'Share summary',
    share_footer: 'Read more on Science Monitor:'
  },
  Norwegian: {
    topics_institution_label: 'Institusjon / universitet / sykehus',
    topics_institution_placeholder: 'F.eks. Universitetet i Oslo eller Karolinska Institutet...',
    topics_dept_label: 'Spesifikk institutt / avdeling (valgfritt)',
    topics_dept_placeholder: 'F.eks. molekylærmedisin, immunologi eller kjemi...',
    topics_dept_hint: 'Begrenser søket til artikler der forfatterens tilknytning omfatter denne avdelingen.',
    offline_pill_label: 'Frakoblet:',
    offline_pill_desc: 'Viser lagrede artikler og innboks.',
    offline_reconnected: 'Tilkoblet igjen – synkroniserer...',
    inbox_group_test_runs: '🧪 Manuelle testsøk',
    inbox_paused_title: 'Overvåkingene dine er satt på pause (20/20 sammendrag)',
    topics_paused_desc: 'Du har nådd grensen for prøveperioden. Oppgrader til Basic for å opprette flere overvåkinger og kjøre testsøk.',
    inbox_paused_btn: 'Aktiver på nytt med Basic (25 SEK/mnd.)',
    login_badge_verified: 'Åpen og kvalitetssikret vitenskap',
    login_tagline: 'Vitenskap for alle – på ditt språk',
    login_hero_title1: 'Vitenskapens frontlinje.',
    login_hero_title2: 'På ditt eget språk. For alle.',
    login_hero_desc: 'Hver dag publiseres tusenvis av vitenskapelige funn på engelsk, ofte i et språk som er vanskelig å forstå. Science Monitor bryter ned språk- og fagbarrierer og leverer fersk forskning oppsummert på morsmålet ditt – tilpasset kunnskapsnivået ditt.',
    login_explore_label: 'Populære fagområder:',
    login_topic_quantum: 'Kvantefysikk', login_topic_literature: 'Litteraturvitenskap', login_topic_immunology: 'Immunologi',
    login_topic_astrobiology: 'Astrobiologi', login_topic_marine_bio: 'Marinbiologi', login_topic_climate: 'Klimaforskning',
    login_feature_lang_title: 'Direkte på morsmålet ditt',
    login_feature_lang_desc: 'Internasjonale forskningsartikler oversettes og oppsummeres automatisk til et naturlig og forståelig språk du foretrekker.',
    login_feature_curious_title: 'For deg som er nysgjerrig',
    login_feature_curious_desc: 'Velg nivået «Allmennheten» for å slippe akademiske faguttrykk. Få hovedpoenget og hvorfor funnet er viktig på 30 sekunder.',
    login_feature_pro_title: 'For fagfolk',
    login_feature_pro_desc: 'Følg bestemte forfattere, institusjoner eller land med faglig presisjon og statistiske parametere intakt.',
    login_card_title: 'Begynn å utforske gratis',
    login_card_subtitle: 'Opprett din første overvåking på under ett minutt. Ingen bindingstid eller betalingskort.',
    login_apple_tip: '💡 Tips: Velg «Del e-postadressen min» for å motta morgenoppdateringer på e-post.',
    login_trial_point1: '14 dagers gratis prøveperiode inkludert',
    login_trial_point2: 'Opptil 20 sammendrag i prøveperioden',
    login_trial_point3: 'Morgenoppdateringer på e-post bare når nye artikler finnes',
    login_footer_copy: 'Science Monitor. Kvalitetssikret forskning tilgjengelig for alle.',
    login_footer_terms: 'Vilkår', login_footer_privacy: 'Personvern',
    about_title: 'Om Science Monitor',
    about_subtitle: 'Demokratiserer fagfellevurdert vitenskap for både nysgjerrige og fagfolk.',
    about_mission_title: 'Vårt oppdrag',
    about_mission_desc: 'Hver dag publiseres tusenvis av banebrytende vitenskapelige funn i databaser verden over. Mye av kunnskapen forblir utilgjengelig på grunn av akademisk fagspråk, språkbarrierer og fragmenterte databaser. Science Monitor bygger bro over dette gapet og gjør fagfellevurdert forskning tilgjengelig, strukturert og forståelig for alle.',
    about_founder_title: 'Bak Science Monitor',
    about_founder_desc: 'Science Monitor ble grunnlagt av Fredrik Mokvist, doktor i kjemi med omfattende ledererfaring fra legemiddel- og livsvitenskapsbransjen. Erfaring fra akademiske laboratorier og kliniske miljøer viste at verktøyene for å følge, forstå og sammenfatte den verdifulle forskningen ikke holdt tritt med utviklingen – før nå.',
    about_how_title: 'Slik fungerer det',
    about_how_desc: 'Vi overvåker åpne vitenskapelige registre og millioner av publikasjoner hver dag. Når ny forskning samsvarer med interessene dine, sammenfatter systemet funnene i tydelige oversikter tilpasset ønsket detaljnivå.',
    about_principles_title: 'Våre grunnprinsipper',
    about_p1_title: 'Dokumentasjon og integritet',
    about_p1_desc: 'Vi behandler kun fagfellevurderte vitenskapelige arbeider. Ingen rykter eller sensasjonssaker – bare etterprøvbar forskning med direkte lenker til originalkildene.',
    about_p2_title: 'Uavhengig av språk',
    about_p2_desc: 'Forskning publiseres internasjonalt, men kunnskap bør være tilgjengelig på morsmålet ditt uten tungvint manuell oversettelse.',
    about_p3_title: 'Personvern fra grunnen av',
    about_p3_desc: 'Vi selger ikke personopplysninger, sporer ikke brukere på nettet og tjener ikke penger på annonser. Plattformens eneste formål er å formidle innsikt.',
    about_contact_title: 'Ta kontakt',
    about_contact_desc: 'Har du tilbakemeldinger, spørsmål eller ideer til samarbeid? Kontakt oss på',
    share_btn: 'Del', share_copied: 'Kopiert!', share_success: 'Delt!', share_title: 'Del sammendrag',
    share_footer: 'Les mer via Science Monitor:'
  },
  Danish: {
    topics_institution_label: 'Institution / universitet / hospital',
    topics_institution_placeholder: 'F.eks. Københavns Universitet eller Karolinska Institutet...',
    topics_dept_label: 'Specifik afdeling / fakultet (valgfrit)',
    topics_dept_placeholder: 'F.eks. molekylær medicin, immunologi eller kemi...',
    topics_dept_hint: 'Begrænser søgningen til artikler, hvor forfatterens tilknytning omfatter denne afdeling.',
    offline_pill_label: 'Offline:', offline_pill_desc: 'Viser gemte artikler og indbakke.',
    offline_reconnected: 'Forbindelsen er genoprettet – synkroniserer...',
    inbox_group_test_runs: '🧪 Manuelle testsøgninger',
    inbox_paused_title: 'Dine overvågninger er sat på pause (20/20 resuméer)',
    topics_paused_desc: 'Du har nået prøveperiodens grænse. Opgrader til Basic for at oprette flere overvågninger og køre testsøgninger.',
    inbox_paused_btn: 'Genaktivér med Basic (25 SEK/md.)',
    login_badge_verified: 'Åben og verificeret videnskab',
    login_tagline: 'Demokratiseret forskning på dit sprog',
    login_hero_title1: 'Videnskabens frontlinje.', login_hero_title2: 'På dit eget sprog. For alle.',
    login_hero_desc: 'Hver dag offentliggøres tusindvis af videnskabelige opdagelser på engelsk, som kan være svære at forstå. Science Monitor nedbryder sprog- og fagbarrierer og formidler den nyeste forskning i et resumé på dit modersmål – tilpasset dit niveau.',
    login_explore_label: 'Populære fagområder:',
    login_topic_quantum: 'Kvantefysik', login_topic_literature: 'Litteraturvidenskab', login_topic_immunology: 'Immunologi',
    login_topic_astrobiology: 'Astrobiologi', login_topic_marine_bio: 'Marinbiologi', login_topic_climate: 'Klimaforskning',
    login_feature_lang_title: 'Direkte på dit modersmål',
    login_feature_lang_desc: 'Internationale forskningsartikler oversættes og sammenfattes automatisk til et naturligt og forståeligt sprog, som du foretrækker.',
    login_feature_curious_title: 'Til den nysgerrige',
    login_feature_curious_desc: 'Vælg niveauet »Almenheden«, og undgå akademiske fagudtryk. Få hovedresultatet og forklaringen på dets betydning på 30 sekunder.',
    login_feature_pro_title: 'Til fagfolk',
    login_feature_pro_desc: 'Følg bestemte forfattere, institutioner eller lande med teknisk præcision og intakte statistiske parametre.',
    login_card_title: 'Begynd at udforske gratis',
    login_card_subtitle: 'Opret din første overvågning på under ét minut. Ingen binding eller kreditkort.',
    login_apple_tip: '💡 Tip: Vælg »Del min e-mailadresse« for at modtage morgenopdateringer via e-mail.',
    login_trial_point1: '14 dages gratis prøveperiode inkluderet',
    login_trial_point2: 'Op til 20 resuméer i prøveperioden',
    login_trial_point3: 'Morgenmails kun når der findes nye artikler',
    login_footer_copy: 'Science Monitor. Verificeret forskning for alle.',
    login_footer_terms: 'Vilkår', login_footer_privacy: 'Privatliv',
    about_title: 'Om Science Monitor',
    about_subtitle: 'Gør fagfællebedømt videnskab tilgængelig for både nysgerrige og specialister.',
    about_mission_title: 'Vores mission',
    about_mission_desc: 'Hver dag offentliggøres tusindvis af banebrydende videnskabelige opdagelser verden over. Meget viden er dog utilgængelig på grund af akademisk fagsprog, sprogbarrierer og fragmenterede databaser. Science Monitor bygger bro over dette gab og gør fagfællebedømt forskning tilgængelig, struktureret og forståelig for alle.',
    about_founder_title: 'Bag Science Monitor',
    about_founder_desc: 'Science Monitor blev grundlagt af Fredrik Mokvist, ph.d. i kemi med omfattende ledelseserfaring fra medicinal- og life science-branchen. Erfaring fra akademiske laboratorier og kliniske miljøer viste, at værktøjerne til at følge, forstå og sammenfatte forskning ikke havde fulgt med udviklingen – før nu.',
    about_how_title: 'Sådan fungerer det',
    about_how_desc: 'Vi overvåger dagligt åbne videnskabelige registre med millioner af publikationer. Når ny forskning matcher dine interesser, sammenfatter systemet resultaterne i klare oversigter på det ønskede detaljeringsniveau.',
    about_principles_title: 'Grundprincipper',
    about_p1_title: 'Evidens og integritet',
    about_p1_desc: 'Vi behandler udelukkende fagfællebedømte videnskabelige værker. Ingen rygter eller clickbait – kun verificerbar forskning med direkte links til primærkilder.',
    about_p2_title: 'Uafhængighed af sprog',
    about_p2_desc: 'Videnskab publiceres internationalt, men viden bør være tilgængelig på dit modersmål uden besværlig manuel oversættelse.',
    about_p3_title: 'Privatliv som standard',
    about_p3_desc: 'Vi sælger ikke personoplysninger, sporer ikke brugere på nettet og tjener ikke penge på annoncer. Platformen findes alene for at formidle indsigt.',
    about_contact_title: 'Kontakt os',
    about_contact_desc: 'Har du feedback, spørgsmål eller idéer til samarbejde? Skriv til os på',
    share_btn: 'Del', share_copied: 'Kopieret!', share_success: 'Delt!', share_title: 'Del resumé',
    share_footer: 'Læs mere via Science Monitor:'
  },
  Finnish: {
    topics_institution_label: 'Organisaatio / yliopisto / sairaala',
    topics_institution_placeholder: 'Esim. Helsingin yliopisto tai Karoliininen instituutti...',
    topics_dept_label: 'Tietty laitos / osasto (valinnainen)',
    topics_dept_placeholder: 'Esim. molekyylilääketiede, immunologia tai kemia...',
    topics_dept_hint: 'Rajaa haun artikkeleihin, joiden tekijän affiliaatio sisältää tämän osaston.',
    offline_pill_label: 'Ei verkkoyhteyttä:', offline_pill_desc: 'Näytetään tallennetut artikkelit ja saapuneet.',
    offline_reconnected: 'Yhteys palautui – synkronoidaan...',
    inbox_group_test_runs: '🧪 Manuaaliset testihakukerrat',
    inbox_paused_title: 'Seurantasi on keskeytetty (20/20 tiivistelmää)',
    topics_paused_desc: 'Kokeilujakson raja on saavutettu. Päivitä Basic-tilaukseen, jotta voit luoda uusia seurantoja ja tehdä testihakuja.',
    inbox_paused_btn: 'Ota uudelleen käyttöön Basic-tilauksella (25 SEK/kk)',
    login_badge_verified: 'Avoin ja varmennettu tiede',
    login_tagline: 'Tutkimustietoa omalla kielelläsi',
    login_hero_title1: 'Tieteen eturintama.', login_hero_title2: 'Omalla kielelläsi. Kaikille.',
    login_hero_desc: 'Joka päivä julkaistaan tuhansia englanninkielisiä tieteellisiä löydöksiä, joiden ymmärtäminen voi olla vaikeaa. Science Monitor madaltaa kieli- ja ammattikielimuureja ja tarjoaa tutkimuksesta yhteenvedon äidinkielelläsi ja sopivalla vaikeustasolla.',
    login_explore_label: 'Suosittuja aloja:',
    login_topic_quantum: 'Kvanttifysiikka', login_topic_literature: 'Kirjallisuudentutkimus', login_topic_immunology: 'Immunologia',
    login_topic_astrobiology: 'Astrobiologia', login_topic_marine_bio: 'Meribiologia', login_topic_climate: 'Ilmastotutkimus',
    login_feature_lang_title: 'Suoraan äidinkielelläsi',
    login_feature_lang_desc: 'Kansainväliset tutkimusartikkelit käännetään ja tiivistetään automaattisesti luonnolliselle ja ymmärrettävälle kielelle.',
    login_feature_curious_title: 'Uteliaille mielille',
    login_feature_curious_desc: 'Valitse tasoksi ”Suuri yleisö”, niin vältät akateemisen erikoissanaston. Ymmärrä tärkeimmät tulokset ja niiden merkitys 30 sekunnissa.',
    login_feature_pro_title: 'Asiantuntijoille',
    login_feature_pro_desc: 'Seuraa tiettyjä kirjoittajia, organisaatioita tai maita teknisesti tarkasti ja tilastolliset parametrit säilyttäen.',
    login_card_title: 'Aloita tutkiminen maksutta',
    login_card_subtitle: 'Luo ensimmäinen seurantasi alle minuutissa. Ei sitoutumista eikä luottokorttia.',
    login_apple_tip: '💡 Vinkki: Valitse ”Jaa sähköpostiosoitteeni”, jos haluat saada aamupäivitykset sähköpostitse.',
    login_trial_point1: 'Sisältää 14 päivän maksuttoman kokeilujakson',
    login_trial_point2: 'Kokeilujaksolla enintään 20 tiivistelmää',
    login_trial_point3: 'Aamukooste sähköpostitse vain, kun uusia artikkeleita löytyy',
    login_footer_copy: 'Science Monitor. Varmennettua tiedettä kaikille.',
    login_footer_terms: 'Käyttöehdot', login_footer_privacy: 'Tietosuoja',
    about_title: 'Tietoa Science Monitorista',
    about_subtitle: 'Tuomme vertaisarvioidun tieteen uteliaiden ja asiantuntijoiden ulottuville.',
    about_mission_title: 'Tehtävämme',
    about_mission_desc: 'Maailmanlaajuisissa tietokannoissa julkaistaan päivittäin uraauurtavia tieteellisiä löydöksiä. Suuri osa tiedosta jää kuitenkin vaikeaselkoisen akateemisen kielen, kielimuurien ja hajanaisten tietokantojen taakse. Science Monitor tekee vertaisarvioidusta tutkimuksesta helposti saatavilla olevaa, jäsenneltyä ja ymmärrettävää kaikille.',
    about_founder_title: 'Science Monitorin taustaa',
    about_founder_desc: 'Science Monitorin perusti kemian tohtori Fredrik Mokvist, jolla on laaja johtamiskokemus lääke- ja biotieteiden aloilta. Kokemus akateemisista laboratorioista ja kliinisistä ympäristöistä osoitti, etteivät työkalut tutkimuksen seuraamiseen, ymmärtämiseen ja koostamiseen olleet pysyneet kehityksen tahdissa – tähän asti.',
    about_how_title: 'Näin se toimii',
    about_how_desc: 'Seuraamme päivittäin avoimia tieteellisiä rekistereitä ja miljoonia julkaisuja. Kun uusi tutkimus vastaa kiinnostuksenkohteitasi, järjestelmämme kokoaa tulokset selkeiksi katsauksiksi valitsemallasi vaikeustasolla.',
    about_principles_title: 'Perusperiaatteet',
    about_p1_title: 'Näyttö ja luotettavuus',
    about_p1_desc: 'Käsittelemme ainoastaan vertaisarvioituja tieteellisiä julkaisuja. Emme huhuja tai klikkiotsikoita – vain todennettavaa tiedettä ja suorat linkit alkuperäislähteisiin.',
    about_p2_title: 'Kielestä riippumaton',
    about_p2_desc: 'Tiedettä julkaistaan kansainvälisesti, mutta tiedon tulisi olla saatavilla äidinkielelläsi ilman vaivalloista käsin kääntämistä.',
    about_p3_title: 'Yksityisyys suunnittelun lähtökohtana',
    about_p3_desc: 'Emme myy henkilötietoja, seuraa käyttäjiä verkossa tai ansaitse rahaa mainoksilla. Alustan ainoa tarkoitus on tarjota tietoa.',
    about_contact_title: 'Ota yhteyttä',
    about_contact_desc: 'Onko sinulla palautetta, kysymyksiä tai yhteistyöideoita? Ota yhteyttä osoitteessa',
    share_btn: 'Jaa', share_copied: 'Kopioitu!', share_success: 'Jaettu!', share_title: 'Jaa tiivistelmä',
    share_footer: 'Lue lisää Science Monitorissa:'
  },
  Italian: {
    topics_institution_label: 'Ente / università / ospedale',
    topics_institution_placeholder: 'Es. Università di Bologna o Karolinska Institutet...',
    topics_dept_label: 'Dipartimento / reparto specifico (facoltativo)',
    topics_dept_placeholder: 'Es. medicina molecolare, immunologia o chimica...',
    topics_dept_hint: 'Limita la ricerca agli articoli la cui affiliazione dell’autore include questo dipartimento.',
    offline_pill_label: 'Modalità offline:', offline_pill_desc: 'Mostra gli articoli salvati e la posta in arrivo.',
    offline_reconnected: 'Connessione ripristinata: sincronizzazione...',
    inbox_group_test_runs: '🧪 Ricerche di prova manuali',
    inbox_paused_title: 'I tuoi monitoraggi sono in pausa (20/20 riepiloghi)',
    topics_paused_desc: 'Hai raggiunto il limite del periodo di prova. Passa a Basic per creare altri monitoraggi ed eseguire ricerche di prova.',
    inbox_paused_btn: 'Riattiva con Basic (25 SEK/mese)',
    login_badge_verified: 'Scienza aperta e verificata',
    login_tagline: 'La ricerca scientifica nella tua lingua',
    login_hero_title1: 'All’avanguardia della scienza.', login_hero_title2: 'Nella tua lingua. Per tutti.',
    login_hero_desc: 'Ogni giorno vengono pubblicate in inglese migliaia di scoperte scientifiche, spesso difficili da comprendere. Science Monitor supera le barriere linguistiche e il gergo specialistico, offrendo ricerche recenti sintetizzate nella tua lingua e adattate al tuo livello.',
    login_explore_label: 'Aree più seguite:',
    login_topic_quantum: 'Fisica quantistica', login_topic_literature: 'Studi letterari', login_topic_immunology: 'Immunologia',
    login_topic_astrobiology: 'Astrobiologia', login_topic_marine_bio: 'Biologia marina', login_topic_climate: 'Scienze del clima',
    login_feature_lang_title: 'Direttamente nella tua lingua',
    login_feature_lang_desc: 'Gli articoli scientifici internazionali vengono tradotti e sintetizzati automaticamente in un linguaggio naturale e comprensibile.',
    login_feature_curious_title: 'Per chi è curioso',
    login_feature_curious_desc: 'Scegli il livello «Pubblico» per evitare il gergo accademico. Comprendi i risultati principali e la loro rilevanza in 30 secondi.',
    login_feature_pro_title: 'Per gli specialisti',
    login_feature_pro_desc: 'Monitora autori, istituzioni o paesi specifici mantenendo precisione tecnica e parametri statistici.',
    login_card_title: 'Inizia a esplorare gratis',
    login_card_subtitle: 'Crea il tuo primo monitoraggio in meno di un minuto. Nessun vincolo e nessuna carta di credito.',
    login_apple_tip: '💡 Suggerimento: scegli «Condividi la mia e-mail» per ricevere gli aggiornamenti mattutini via e-mail.',
    login_trial_point1: 'Periodo di prova gratuito di 14 giorni incluso',
    login_trial_point2: 'Fino a 20 riepiloghi durante il periodo di prova',
    login_trial_point3: 'E-mail del mattino solo quando vengono trovati nuovi articoli',
    login_footer_copy: 'Science Monitor. Ricerca scientifica verificata, accessibile a tutti.',
    login_footer_terms: 'Termini', login_footer_privacy: 'Privacy',
    about_title: 'Informazioni su Science Monitor',
    about_subtitle: 'Rendiamo la scienza sottoposta a revisione paritaria accessibile a curiosi e specialisti.',
    about_mission_title: 'La nostra missione',
    about_mission_desc: 'Ogni giorno vengono pubblicate migliaia di scoperte scientifiche. Gran parte di queste conoscenze resta però inaccessibile a causa del linguaggio accademico complesso, delle barriere linguistiche e dei database frammentati. Science Monitor rende la ricerca autentica e sottoposta a revisione paritaria accessibile, organizzata e comprensibile a tutti.',
    about_founder_title: 'Dietro Science Monitor',
    about_founder_desc: 'Science Monitor è stato fondato da Fredrik Mokvist, dottore di ricerca in chimica con esperienza dirigenziale nei settori farmaceutico e delle scienze della vita. La sua esperienza in laboratori accademici e contesti clinici ha evidenziato la mancanza di strumenti adeguati per seguire, comprendere e sintetizzare la ricerca: ora c’è Science Monitor.',
    about_how_title: 'Come funziona',
    about_how_desc: 'Monitoriamo ogni giorno registri scientifici aperti e milioni di pubblicazioni. Quando una nuova ricerca corrisponde ai tuoi interessi, il sistema ne sintetizza i risultati in briefing chiari, calibrati sul livello scelto.',
    about_principles_title: 'Principi fondamentali',
    about_p1_title: 'Evidenza e integrità',
    about_p1_desc: 'Elaboriamo esclusivamente lavori accademici sottoposti a revisione paritaria. Niente voci né titoli sensazionalistici: solo scienza verificabile con collegamenti diretti alle fonti primarie.',
    about_p2_title: 'Indipendenza linguistica',
    about_p2_desc: 'La scienza è pubblicata a livello internazionale, ma la conoscenza dovrebbe essere accessibile nella tua lingua madre senza traduzioni manuali macchinose.',
    about_p3_title: 'Privacy fin dalla progettazione',
    about_p3_desc: 'Non vendiamo dati personali, non tracciamo gli utenti sul web e non ci finanziamo con la pubblicità. La piattaforma esiste unicamente per offrire conoscenza.',
    about_contact_title: 'Contattaci',
    about_contact_desc: 'Hai commenti, domande o idee di collaborazione? Scrivici a',
    share_btn: 'Condividi', share_copied: 'Copiato!', share_success: 'Condiviso!', share_title: 'Condividi il riepilogo',
    share_footer: 'Approfondisci su Science Monitor:'
  },
  French: {
    topics_institution_label: 'Établissement / université / hôpital',
    topics_institution_placeholder: 'Ex. Université de Paris ou Karolinska Institutet...',
    topics_dept_label: 'Département / service spécifique (facultatif)',
    topics_dept_placeholder: 'Ex. médecine moléculaire, immunologie ou chimie...',
    topics_dept_hint: 'Limite la recherche aux articles dont l’affiliation de l’auteur comprend ce département.',
    offline_pill_label: 'Mode hors ligne :', offline_pill_desc: 'Affiche les articles enregistrés et la boîte de réception.',
    offline_reconnected: 'Connexion rétablie – synchronisation...',
    inbox_group_test_runs: '🧪 Recherches de test manuelles',
    inbox_paused_title: 'Vos veilles sont en pause (20/20 résumés)',
    topics_paused_desc: 'Vous avez atteint la limite de la période d’essai. Passez à Basic pour créer d’autres veilles et lancer des recherches de test.',
    inbox_paused_btn: 'Réactiver avec Basic (25 SEK/mois)',
    login_badge_verified: 'Science ouverte et vérifiée',
    login_tagline: 'La recherche scientifique dans votre langue',
    login_hero_title1: 'À la pointe de la science.', login_hero_title2: 'Dans votre langue. Pour tous.',
    login_hero_desc: 'Chaque jour, des milliers de découvertes scientifiques sont publiées en anglais et sont parfois difficiles à comprendre. Science Monitor lève les barrières linguistiques et le jargon spécialisé en présentant les recherches récentes dans votre langue maternelle, à un niveau adapté.',
    login_explore_label: 'Domaines populaires:',
    login_topic_quantum: 'Physique quantique', login_topic_literature: 'Littérature', login_topic_immunology: 'Immunologie',
    login_topic_astrobiology: 'Astrobiologie', login_topic_marine_bio: 'Biologie marine', login_topic_climate: 'Sciences du climat',
    login_feature_lang_title: 'Directement dans votre langue',
    login_feature_lang_desc: 'Les articles internationaux sont automatiquement traduits et synthétisés dans une langue naturelle et compréhensible, celle que vous préférez.',
    login_feature_curious_title: 'Pour les esprits curieux',
    login_feature_curious_desc: 'Choisissez le niveau « Grand public » pour éviter le jargon universitaire. Comprenez les résultats essentiels et leur importance en 30 secondes.',
    login_feature_pro_title: 'Pour les spécialistes',
    login_feature_pro_desc: 'Suivez des auteurs, établissements ou pays précis en conservant la rigueur technique et les paramètres statistiques.',
    login_card_title: 'Commencez à explorer gratuitement',
    login_card_subtitle: 'Configurez votre première veille en moins d’une minute. Sans engagement ni carte bancaire.',
    login_apple_tip: '💡 Conseil : choisissez « Partager mon adresse e-mail » pour recevoir les actualités du matin par e-mail.',
    login_trial_point1: 'Essai gratuit de 14 jours inclus',
    login_trial_point2: 'Jusqu’à 20 résumés pendant l’essai',
    login_trial_point3: 'E-mail matinal uniquement lorsque de nouveaux articles sont trouvés',
    login_footer_copy: 'Science Monitor. La recherche vérifiée accessible à tous.',
    login_footer_terms: 'Conditions', login_footer_privacy: 'Confidentialité',
    about_title: 'À propos de Science Monitor',
    about_subtitle: 'Démocratiser la science évaluée par les pairs pour les curieux comme pour les spécialistes.',
    about_mission_title: 'Notre mission',
    about_mission_desc: 'Des milliers de découvertes scientifiques sont publiées chaque jour dans le monde. Pourtant, le jargon universitaire, les barrières linguistiques et les bases de données fragmentées rendent ces connaissances difficiles d’accès. Science Monitor rend la recherche évaluée par les pairs accessible, structurée et lisible pour tous.',
    about_founder_title: 'À l’origine de Science Monitor',
    about_founder_desc: 'Science Monitor a été fondé par Fredrik Mokvist, docteur en chimie et fort d’une expérience de direction dans les secteurs pharmaceutique et des sciences de la vie. Son expérience des laboratoires universitaires et des environnements cliniques a révélé le manque d’outils pour suivre, comprendre et synthétiser la recherche – jusqu’à présent.',
    about_how_title: 'Comment ça marche',
    about_how_desc: 'Nous surveillons chaque jour des registres scientifiques ouverts et des millions de publications. Lorsqu’une recherche correspond à vos centres d’intérêt, notre système en résume les résultats selon le niveau de détail choisi.',
    about_principles_title: 'Principes fondamentaux',
    about_p1_title: 'Preuves et intégrité',
    about_p1_desc: 'Nous traitons exclusivement des travaux évalués par les pairs. Pas de rumeurs ni de pièges à clics : uniquement des données vérifiables et des liens directs vers les sources primaires.',
    about_p2_title: 'Indépendance linguistique',
    about_p2_desc: 'La science est publiée à l’échelle internationale, mais le savoir doit être accessible dans votre langue maternelle sans traduction manuelle laborieuse.',
    about_p3_title: 'La confidentialité dès la conception',
    about_p3_desc: 'Nous ne vendons pas de données personnelles, ne suivons pas les utilisateurs sur le Web et ne tirons aucun revenu de la publicité. La plateforme existe uniquement pour transmettre des connaissances.',
    about_contact_title: 'Nous contacter',
    about_contact_desc: 'Vous avez des commentaires, des questions ou des idées de collaboration ? Écrivez-nous à',
    share_btn: 'Partager', share_copied: 'Copié !', share_success: 'Partagé !', share_title: 'Partager le résumé',
    share_footer: 'Pour en savoir plus sur Science Monitor :'
  },
  German: {
    topics_institution_label: 'Einrichtung / Universität / Krankenhaus',
    topics_institution_placeholder: 'Z. B. Universität Heidelberg oder Karolinska Institutet...',
    topics_dept_label: 'Bestimmter Fachbereich / Abteilung (optional)',
    topics_dept_placeholder: 'Z. B. Molekularmedizin, Immunologie oder Chemie...',
    topics_dept_hint: 'Beschränkt die Suche auf Artikel, deren Autorenaffiliation diesen Fachbereich umfasst.',
    offline_pill_label: 'Offline-Modus:', offline_pill_desc: 'Gespeicherte Artikel und Posteingang werden angezeigt.',
    offline_reconnected: 'Verbindung wiederhergestellt – Synchronisierung läuft...',
    inbox_group_test_runs: '🧪 Manuelle Testsuchen',
    inbox_paused_title: 'Deine Überwachungen sind pausiert (20/20 Zusammenfassungen)',
    topics_paused_desc: 'Du hast das Testlimit erreicht. Führe ein Upgrade auf Basic durch, um weitere Überwachungen anzulegen und Testsuchen auszuführen.',
    inbox_paused_btn: 'Mit Basic reaktivieren (25 SEK/Monat)',
    login_badge_verified: 'Offene und verifizierte Wissenschaft',
    login_tagline: 'Forschung in deiner Sprache',
    login_hero_title1: 'An der Spitze der Wissenschaft.', login_hero_title2: 'In deiner Sprache. Für alle.',
    login_hero_desc: 'Jeden Tag werden Tausende wissenschaftliche Entdeckungen auf Englisch veröffentlicht, die oft schwer verständlich sind. Science Monitor überwindet Sprachbarrieren und Fachjargon und fasst aktuelle Forschung in deiner Muttersprache und passend zu deinem Wissensstand zusammen.',
    login_explore_label: 'Beliebte Fachgebiete:',
    login_topic_quantum: 'Quantenphysik', login_topic_literature: 'Literaturwissenschaft', login_topic_immunology: 'Immunologie',
    login_topic_astrobiology: 'Astrobiologie', login_topic_marine_bio: 'Meeresbiologie', login_topic_climate: 'Klimaforschung',
    login_feature_lang_title: 'Direkt in deiner Muttersprache',
    login_feature_lang_desc: 'Internationale Forschungsartikel werden automatisch übersetzt und in natürlicher, verständlicher Sprache zusammengefasst.',
    login_feature_curious_title: 'Für Wissbegierige',
    login_feature_curious_desc: 'Wähle die Stufe „Allgemein“, um auf akademischen Fachjargon zu verzichten. Erfahre die wichtigsten Ergebnisse und ihre Bedeutung in 30 Sekunden.',
    login_feature_pro_title: 'Für Fachleute',
    login_feature_pro_desc: 'Verfolge bestimmte Autoren, Einrichtungen oder Länder mit technischer Präzision und unveränderten statistischen Parametern.',
    login_card_title: 'Kostenlos auf Entdeckungsreise gehen',
    login_card_subtitle: 'Richte deine erste Überwachung in weniger als einer Minute ein. Ohne Verpflichtung und ohne Kreditkarte.',
    login_apple_tip: '💡 Tipp: Wähle „Meine E-Mail-Adresse teilen“, um morgendliche Updates per E-Mail zu erhalten.',
    login_trial_point1: '14-tägiger kostenloser Testzeitraum inklusive',
    login_trial_point2: 'Bis zu 20 Zusammenfassungen während des Testzeitraums',
    login_trial_point3: 'Morgendliche E-Mails nur bei neuen Artikeln',
    login_footer_copy: 'Science Monitor. Verifizierte Forschung für alle.',
    login_footer_terms: 'Nutzungsbedingungen', login_footer_privacy: 'Datenschutz',
    about_title: 'Über Science Monitor',
    about_subtitle: 'Begutachtete Wissenschaft für Wissbegierige und Fachleute zugänglich machen.',
    about_mission_title: 'Unsere Mission',
    about_mission_desc: 'Täglich werden weltweit Tausende wissenschaftlicher Entdeckungen veröffentlicht. Akademischer Fachjargon, Sprachbarrieren und fragmentierte Datenbanken erschweren jedoch den Zugang zu diesem Wissen. Science Monitor macht begutachtete Forschung zugänglich, strukturiert und verständlich für alle.',
    about_founder_title: 'Hinter Science Monitor',
    about_founder_desc: 'Science Monitor wurde von Fredrik Mokvist gegründet, promoviertem Chemiker mit Führungserfahrung in der Pharma- und Life-Science-Branche. Seine Erfahrungen in akademischen Laboren und klinischen Umgebungen machten deutlich, dass die Werkzeuge zum Verfolgen, Verstehen und Zusammenfassen der Forschung nicht mithielten – bis jetzt.',
    about_how_title: 'So funktioniert es',
    about_how_desc: 'Wir überwachen täglich offene wissenschaftliche Register und Millionen von Veröffentlichungen. Passt eine neue Studie zu deinen Interessen, fasst unser System die Ergebnisse verständlich und auf dem gewünschten Komplexitätsniveau zusammen.',
    about_principles_title: 'Grundprinzipien',
    about_p1_title: 'Belege und Integrität',
    about_p1_desc: 'Wir verarbeiten ausschließlich wissenschaftliche Arbeiten mit Peer-Review. Keine Gerüchte, kein Clickbait – nur überprüfbare Wissenschaft mit direkten Links zu den Primärquellen.',
    about_p2_title: 'Sprachunabhängigkeit',
    about_p2_desc: 'Wissenschaft wird international veröffentlicht, doch Wissen sollte in deiner Muttersprache zugänglich sein – ohne umständliche manuelle Übersetzung.',
    about_p3_title: 'Datenschutz von Anfang an',
    about_p3_desc: 'Wir verkaufen keine personenbezogenen Daten, verfolgen Nutzer nicht im Web und finanzieren uns nicht durch Werbung. Die Plattform dient ausschließlich der Wissensvermittlung.',
    about_contact_title: 'Kontakt',
    about_contact_desc: 'Hast du Feedback, Fragen oder Ideen für eine Zusammenarbeit? Schreib uns an',
    share_btn: 'Teilen', share_copied: 'Kopiert!', share_success: 'Geteilt!', share_title: 'Zusammenfassung teilen',
    share_footer: 'Mehr dazu bei Science Monitor:'
  },
  Spanish: {
    topics_institution_label: 'Institución / universidad / hospital',
    topics_institution_placeholder: 'Ej.: Universidad de Barcelona o Karolinska Institutet...',
    topics_dept_label: 'Departamento / servicio específico (opcional)',
    topics_dept_placeholder: 'Ej.: medicina molecular, inmunología o química...',
    topics_dept_hint: 'Limita la búsqueda a artículos cuya afiliación del autor incluya este departamento.',
    offline_pill_label: 'Modo sin conexión:', offline_pill_desc: 'Se muestran los artículos guardados y la bandeja de entrada.',
    offline_reconnected: 'Conexión restablecida: sincronizando...',
    inbox_group_test_runs: '🧪 Búsquedas de prueba manuales',
    inbox_paused_title: 'Tus seguimientos están en pausa (20/20 resúmenes)',
    topics_paused_desc: 'Has alcanzado el límite del periodo de prueba. Mejora a Basic para crear más seguimientos y realizar búsquedas de prueba.',
    inbox_paused_btn: 'Reactivar con Basic (25 SEK/mes)',
    login_badge_verified: 'Ciencia abierta y verificada',
    login_tagline: 'Investigación en tu idioma',
    login_hero_title1: 'A la vanguardia de la ciencia.', login_hero_title2: 'En tu idioma. Para todos.',
    login_hero_desc: 'Cada día se publican miles de descubrimientos científicos en inglés que pueden resultar difíciles de entender. Science Monitor supera las barreras lingüísticas y la jerga especializada, y ofrece resúmenes de investigaciones recientes en tu lengua materna y adaptados a tu nivel.',
    login_explore_label: 'Áreas populares:',
    login_topic_quantum: 'Física cuántica', login_topic_literature: 'Estudios literarios', login_topic_immunology: 'Inmunología',
    login_topic_astrobiology: 'Astrobiología', login_topic_marine_bio: 'Biología marina', login_topic_climate: 'Ciencias del clima',
    login_feature_lang_title: 'Directamente en tu lengua materna',
    login_feature_lang_desc: 'Los artículos científicos internacionales se traducen y sintetizan automáticamente en un lenguaje natural y claro, en el idioma que prefieras.',
    login_feature_curious_title: 'Para mentes curiosas',
    login_feature_curious_desc: 'Elige el nivel «Público general» para evitar la jerga académica. Comprende los hallazgos principales y su importancia en 30 segundos.',
    login_feature_pro_title: 'Para especialistas',
    login_feature_pro_desc: 'Sigue a autores, instituciones o países concretos con rigor técnico y conservando los parámetros estadísticos.',
    login_card_title: 'Empieza a explorar gratis',
    login_card_subtitle: 'Configura tu primer seguimiento en menos de un minuto. Sin compromiso ni tarjeta de crédito.',
    login_apple_tip: '💡 Consejo: selecciona «Compartir mi correo electrónico» para recibir las novedades matutinas por correo.',
    login_trial_point1: 'Incluye 14 días de prueba gratuita',
    login_trial_point2: 'Hasta 20 resúmenes durante el periodo de prueba',
    login_trial_point3: 'Correo matutino solo cuando se encuentran artículos nuevos',
    login_footer_copy: 'Science Monitor. Investigación verificada al alcance de todos.',
    login_footer_terms: 'Términos', login_footer_privacy: 'Privacidad',
    about_title: 'Acerca de Science Monitor',
    about_subtitle: 'Democratizamos la ciencia revisada por pares para personas curiosas y especialistas.',
    about_mission_title: 'Nuestra misión',
    about_mission_desc: 'Cada día se publican miles de descubrimientos científicos en todo el mundo. Sin embargo, el lenguaje académico denso, las barreras lingüísticas y las bases de datos fragmentadas dificultan el acceso a este conocimiento. Science Monitor hace que la investigación revisada por pares sea accesible, estructurada y comprensible para todos.',
    about_founder_title: 'Detrás de Science Monitor',
    about_founder_desc: 'Science Monitor fue fundado por Fredrik Mokvist, doctor en Química con experiencia directiva en los sectores farmacéutico y de las ciencias de la vida. Su experiencia en laboratorios académicos y entornos clínicos puso de manifiesto la falta de herramientas para seguir, comprender y sintetizar la investigación: hasta ahora.',
    about_how_title: 'Cómo funciona',
    about_how_desc: 'Supervisamos a diario registros científicos abiertos con millones de publicaciones. Cuando una investigación coincide con tus intereses, el sistema sintetiza los hallazgos en informes claros y adaptados al nivel de detalle que elijas.',
    about_principles_title: 'Principios fundamentales',
    about_p1_title: 'Evidencia e integridad',
    about_p1_desc: 'Procesamos exclusivamente trabajos académicos revisados por pares. Sin rumores ni titulares sensacionalistas: solo ciencia verificable con enlaces directos a las fuentes originales.',
    about_p2_title: 'Independencia lingüística',
    about_p2_desc: 'La ciencia se publica internacionalmente, pero el conocimiento debe estar disponible en tu lengua materna sin traducciones manuales engorrosas.',
    about_p3_title: 'Privacidad desde el diseño',
    about_p3_desc: 'No vendemos datos personales, no rastreamos a los usuarios en la web ni obtenemos ingresos mediante publicidad. La plataforma existe únicamente para ofrecer conocimiento.',
    about_contact_title: 'Contacto',
    about_contact_desc: '¿Tienes comentarios, preguntas o ideas de colaboración? Escríbenos a',
    share_btn: 'Compartir', share_copied: '¡Copiado!', share_success: '¡Compartido!', share_title: 'Compartir resumen',
    share_footer: 'Más información en Science Monitor:'
  },
  Portuguese: {
    topics_institution_label: 'Instituição / universidade / hospital',
    topics_institution_placeholder: 'Ex.: Universidade de Lisboa ou Karolinska Institutet...',
    topics_dept_label: 'Departamento / serviço específico (opcional)',
    topics_dept_placeholder: 'Ex.: medicina molecular, imunologia ou química...',
    topics_dept_hint: 'Limita a pesquisa a artigos cuja afiliação do autor inclua este departamento.',
    offline_pill_label: 'Modo offline:', offline_pill_desc: 'A mostrar artigos guardados e a caixa de entrada.',
    offline_reconnected: 'Ligação restabelecida — a sincronizar...',
    inbox_group_test_runs: '🧪 Pesquisas de teste manuais',
    inbox_paused_title: 'As suas monitorizações estão em pausa (20/20 resumos)',
    topics_paused_desc: 'Atingiu o limite do período de avaliação. Atualize para Basic para criar mais monitorizações e executar pesquisas de teste.',
    inbox_paused_btn: 'Reativar com Basic (25 SEK/mês)',
    login_badge_verified: 'Ciência aberta e verificada',
    login_tagline: 'Investigação no seu idioma',
    login_hero_title1: 'Na vanguarda da ciência.', login_hero_title2: 'No seu idioma. Para todos.',
    login_hero_desc: 'Todos os dias são publicadas milhares de descobertas científicas em inglês que podem ser difíceis de compreender. O Science Monitor ultrapassa as barreiras linguísticas e o jargão técnico, apresentando investigação recente resumida na sua língua materna e adaptada ao seu nível.',
    login_explore_label: 'Áreas populares:',
    login_topic_quantum: 'Física quântica', login_topic_literature: 'Estudos literários', login_topic_immunology: 'Imunologia',
    login_topic_astrobiology: 'Astrobiologia', login_topic_marine_bio: 'Biologia marinha', login_topic_climate: 'Ciências do clima',
    login_feature_lang_title: 'Diretamente na sua língua materna',
    login_feature_lang_desc: 'Os artigos científicos internacionais são traduzidos e sintetizados automaticamente numa linguagem natural e clara, no idioma que preferir.',
    login_feature_curious_title: 'Para mentes curiosas',
    login_feature_curious_desc: 'Escolha o nível «Público» para evitar o jargão académico. Compreenda os resultados principais e a sua importância em 30 segundos.',
    login_feature_pro_title: 'Para especialistas',
    login_feature_pro_desc: 'Acompanhe autores, instituições ou países específicos com rigor técnico e mantendo intactos os parâmetros estatísticos.',
    login_card_title: 'Comece a explorar gratuitamente',
    login_card_subtitle: 'Configure a sua primeira monitorização em menos de um minuto. Sem compromisso nem cartão de crédito.',
    login_apple_tip: '💡 Dica: escolha «Partilhar o meu e-mail» para receber as atualizações matinais por e-mail.',
    login_trial_point1: 'Inclui um período experimental gratuito de 14 dias',
    login_trial_point2: 'Até 20 resumos durante o período experimental',
    login_trial_point3: 'E-mail matinal apenas quando são encontrados novos artigos',
    login_footer_copy: 'Science Monitor. Investigação verificada acessível a todos.',
    login_footer_terms: 'Termos', login_footer_privacy: 'Privacidade',
    about_title: 'Sobre o Science Monitor',
    about_subtitle: 'Democratizamos a ciência com revisão por pares para curiosos e especialistas.',
    about_mission_title: 'A nossa missão',
    about_mission_desc: 'Todos os dias são publicadas milhares de descobertas científicas em todo o mundo. Contudo, o jargão académico, as barreiras linguísticas e as bases de dados fragmentadas dificultam o acesso a esse conhecimento. O Science Monitor torna a investigação revista por pares acessível, organizada e compreensível para todos.',
    about_founder_title: 'A história do Science Monitor',
    about_founder_desc: 'O Science Monitor foi fundado por Fredrik Mokvist, doutorado em Química e com experiência de liderança nos setores farmacêutico e das ciências da vida. A experiência em laboratórios académicos e ambientes clínicos revelou a falta de ferramentas para acompanhar, compreender e sintetizar a investigação — até agora.',
    about_how_title: 'Como funciona',
    about_how_desc: 'Monitorizamos diariamente registos científicos abertos com milhões de publicações. Quando uma investigação corresponde aos seus interesses, o sistema sintetiza os resultados em resumos claros, adaptados ao nível de detalhe escolhido.',
    about_principles_title: 'Princípios fundamentais',
    about_p1_title: 'Evidência e integridade',
    about_p1_desc: 'Processamos exclusivamente trabalhos académicos com revisão por pares. Sem rumores nem títulos sensacionalistas — apenas ciência verificável com ligações diretas às fontes primárias.',
    about_p2_title: 'Independência linguística',
    about_p2_desc: 'A ciência é publicada internacionalmente, mas o conhecimento deve estar acessível na sua língua materna sem traduções manuais pouco práticas.',
    about_p3_title: 'Privacidade desde a conceção',
    about_p3_desc: 'Não vendemos dados pessoais, não rastreamos utilizadores na Web nem obtemos receitas com publicidade. A plataforma existe exclusivamente para partilhar conhecimento.',
    about_contact_title: 'Entre em contacto',
    about_contact_desc: 'Tem comentários, dúvidas ou ideias de colaboração? Escreva-nos para',
    share_btn: 'Partilhar', share_copied: 'Copiado!', share_success: 'Partilhado!', share_title: 'Partilhar resumo',
    share_footer: 'Saiba mais no Science Monitor:'
  },
  Hindi: {
    topics_institution_label: 'संस्थान / विश्वविद्यालय / अस्पताल',
    topics_institution_placeholder: 'उदा. दिल्ली विश्वविद्यालय या Karolinska Institutet...',
    topics_dept_label: 'विशिष्ट विभाग / संकाय (वैकल्पिक)',
    topics_dept_placeholder: 'उदा. आणविक चिकित्सा, प्रतिरक्षा विज्ञान या रसायन विज्ञान...',
    topics_dept_hint: 'खोज को उन लेखों तक सीमित करता है जिनमें लेखक का संस्थागत संबद्धता इस विभाग से जुड़ा हो।',
    offline_pill_label: 'ऑफ़लाइन मोड:', offline_pill_desc: 'सहेजे गए लेख और इनबॉक्स दिखाए जा रहे हैं।',
    offline_reconnected: 'कनेक्शन फिर से जुड़ गया — सिंक हो रहा है...',
    inbox_group_test_runs: '🧪 मैन्युअल परीक्षण खोजें',
    inbox_paused_title: 'आपकी निगरानियाँ रोक दी गई हैं (20/20 सारांश)',
    topics_paused_desc: 'आप परीक्षण अवधि की सीमा तक पहुँच गए हैं। नई निगरानियाँ बनाने और परीक्षण खोज चलाने के लिए Basic में अपग्रेड करें।',
    inbox_paused_btn: 'Basic के साथ फिर सक्रिय करें (25 SEK/माह)',
    login_badge_verified: 'खुला और सत्यापित विज्ञान',
    login_tagline: 'आपकी भाषा में शोध', login_hero_title1: 'विज्ञान की अग्रिम पंक्ति।',
    login_hero_title2: 'आपकी अपनी भाषा में। सभी के लिए।',
    login_hero_desc: 'हर दिन अंग्रेज़ी में हज़ारों वैज्ञानिक खोजें प्रकाशित होती हैं, जिन्हें समझना कठिन हो सकता है। Science Monitor भाषा और तकनीकी शब्दावली की बाधाएँ दूर करता है और नवीनतम शोध को आपकी मातृभाषा तथा समझ के स्तर के अनुसार संक्षेप में प्रस्तुत करता है।',
    login_explore_label: 'लोकप्रिय विषय:',
    login_topic_quantum: 'क्वांटम भौतिकी', login_topic_literature: 'साहित्य अध्ययन', login_topic_immunology: 'प्रतिरक्षा विज्ञान',
    login_topic_astrobiology: 'खगोलजीवविज्ञान', login_topic_marine_bio: 'समुद्री जीवविज्ञान', login_topic_climate: 'जलवायु विज्ञान',
    login_feature_lang_title: 'सीधे आपकी मातृभाषा में',
    login_feature_lang_desc: 'अंतरराष्ट्रीय शोध पत्रों का आपकी पसंदीदा भाषा में स्वाभाविक और सहज सारांश अपने आप तैयार होता है।',
    login_feature_curious_title: 'जिज्ञासु पाठकों के लिए',
    login_feature_curious_desc: 'अकादमिक शब्दावली से बचने के लिए «सामान्य पाठक» स्तर चुनें। मुख्य निष्कर्ष और उनका महत्व 30 सेकंड में जानें।',
    login_feature_pro_title: 'विशेषज्ञों के लिए',
    login_feature_pro_desc: 'तकनीकी सटीकता और सांख्यिकीय मानदंड बनाए रखते हुए विशिष्ट लेखकों, संस्थानों या देशों पर नज़र रखें।',
    login_card_title: 'मुफ़्त में खोज शुरू करें',
    login_card_subtitle: 'एक मिनट से भी कम समय में अपनी पहली निगरानी बनाएँ। कोई बाध्यता या क्रेडिट कार्ड नहीं।',
    login_apple_tip: '💡 सुझाव: ईमेल से सुबह के अपडेट पाने के लिए «मेरा ईमेल साझा करें» चुनें।',
    login_trial_point1: '14 दिन की मुफ़्त परीक्षण अवधि शामिल',
    login_trial_point2: 'परीक्षण अवधि में अधिकतम 20 सारांश',
    login_trial_point3: 'नए लेख मिलने पर ही सुबह का ईमेल',
    login_footer_copy: 'Science Monitor. सत्यापित शोध, सभी के लिए।',
    login_footer_terms: 'शर्तें', login_footer_privacy: 'गोपनीयता',
    about_title: 'Science Monitor के बारे में',
    about_subtitle: 'जिज्ञासु पाठकों और विशेषज्ञों, सभी के लिए सहकर्मी-समीक्षित विज्ञान सुलभ बनाना।',
    about_mission_title: 'हमारा उद्देश्य',
    about_mission_desc: 'दुनिया भर में हर दिन हज़ारों वैज्ञानिक खोजें प्रकाशित होती हैं। कठिन अकादमिक भाषा, भाषाई बाधाओं और बिखरे डेटाबेस के कारण यह ज्ञान अक्सर पहुँच से बाहर रहता है। Science Monitor सहकर्मी-समीक्षित शोध को सभी के लिए सुलभ, व्यवस्थित और पठनीय बनाता है।',
    about_founder_title: 'Science Monitor के पीछे',
    about_founder_desc: 'Science Monitor की स्थापना रसायन विज्ञान में पीएचडी और औषधि तथा जीवन-विज्ञान क्षेत्रों में नेतृत्व अनुभव रखने वाले Fredrik Mokvist ने की। अकादमिक प्रयोगशालाओं और क्लिनिकल परिवेश में उनके अनुभव ने शोध को समझने और सारांशित करने के बेहतर साधनों की आवश्यकता उजागर की।',
    about_how_title: 'यह कैसे काम करता है',
    about_how_desc: 'हम हर दिन खुले वैज्ञानिक रजिस्टरों और लाखों प्रकाशनों पर नज़र रखते हैं। आपकी रुचियों से मेल खाने वाले नए शोध को चुने गए कठिनाई स्तर के अनुसार स्पष्ट सारांश में प्रस्तुत किया जाता है।',
    about_principles_title: 'मुख्य सिद्धांत',
    about_p1_title: 'साक्ष्य और सत्यनिष्ठा',
    about_p1_desc: 'हम केवल सहकर्मी-समीक्षित अकादमिक शोध संसाधित करते हैं। न अफ़वाहें, न सनसनीखेज़ शीर्षक — केवल सत्यापन योग्य विज्ञान और मूल स्रोतों के सीधे लिंक।',
    about_p2_title: 'भाषा की बाधा से मुक्त',
    about_p2_desc: 'विज्ञान अंतरराष्ट्रीय स्तर पर प्रकाशित होता है, लेकिन ज्ञान आपकी मातृभाषा में सहज रूप से उपलब्ध होना चाहिए।',
    about_p3_title: 'डिज़ाइन में ही गोपनीयता',
    about_p3_desc: 'हम व्यक्तिगत डेटा नहीं बेचते, वेब पर उपयोगकर्ताओं को ट्रैक नहीं करते और विज्ञापनों से कमाई नहीं करते। यह मंच केवल ज्ञान साझा करने के लिए है।',
    about_contact_title: 'संपर्क करें',
    about_contact_desc: 'आपकी प्रतिक्रिया, प्रश्न या सहयोग के विचार हैं? हमें यहाँ लिखें:',
    share_btn: 'साझा करें', share_copied: 'कॉपी हो गया!', share_success: 'साझा किया गया!', share_title: 'सारांश साझा करें',
    share_footer: 'Science Monitor पर और पढ़ें:'
  },
  Mandarin: {
    topics_institution_label: '机构 / 大学 / 医院',
    topics_institution_placeholder: '例如：北京大学或卡罗林斯卡学院...',
    topics_dept_label: '具体院系 / 科室（可选）',
    topics_dept_placeholder: '例如：分子医学、免疫学或化学...',
    topics_dept_hint: '仅搜索作者所属机构包含该院系的文章。',
    offline_pill_label: '离线模式：', offline_pill_desc: '显示已保存的文章和收件箱。',
    offline_reconnected: '网络已恢复 — 正在同步...',
    inbox_group_test_runs: '🧪 手动测试搜索',
    inbox_paused_title: '您的监测已暂停（20/20 条摘要）',
    topics_paused_desc: '您已达到试用上限。升级至 Basic，即可创建更多监测并运行测试搜索。',
    inbox_paused_btn: '升级至 Basic 并重新启用（25 SEK/月）',
    login_badge_verified: '开放且经过验证的科学',
    login_tagline: '用您的语言了解科学研究',
    login_hero_title1: '科学前沿。', login_hero_title2: '用您的语言，为每个人。',
    login_hero_desc: '每天都有数千项科学发现以英文发表，阅读和理解并不容易。Science Monitor 消除语言和专业术语障碍，以您的母语和适合您的程度呈现最新研究摘要。',
    login_explore_label: '热门领域：',
    login_topic_quantum: '量子物理', login_topic_literature: '文学研究', login_topic_immunology: '免疫学',
    login_topic_astrobiology: '天体生物学', login_topic_marine_bio: '海洋生物学', login_topic_climate: '气候科学',
    login_feature_lang_title: '直接使用您的母语',
    login_feature_lang_desc: '国际研究论文会自动翻译并提炼为自然、易懂的文字，使用您偏好的语言呈现。',
    login_feature_curious_title: '适合好奇的读者',
    login_feature_curious_desc: '选择“大众”级别，避开学术术语。30 秒了解核心发现及其重要性。',
    login_feature_pro_title: '适合专业人士',
    login_feature_pro_desc: '追踪特定作者、机构或国家，同时保留技术细节和统计参数。',
    login_card_title: '免费开始探索',
    login_card_subtitle: '不到一分钟即可创建首个监测。无需承诺，也无需信用卡。',
    login_apple_tip: '💡 提示：选择“共享我的电子邮件地址”，即可通过邮件接收每日早间更新。',
    login_trial_point1: '自动包含 14 天免费试用期',
    login_trial_point2: '试用期间最多可获取 20 条摘要',
    login_trial_point3: '仅在发现新文章时发送早间邮件',
    login_footer_copy: 'Science Monitor。让每个人都能获取经过验证的研究。',
    login_footer_terms: '条款', login_footer_privacy: '隐私',
    about_title: '关于 Science Monitor',
    about_subtitle: '让好奇的读者和专业人士都能轻松获取经同行评审的科学成果。',
    about_mission_title: '我们的使命',
    about_mission_desc: '每天，全球都会发布数千项科学发现。然而，复杂的学术术语、语言障碍和分散的数据库使许多知识难以获取。Science Monitor 让经同行评审的研究变得易于获取、结构清晰且人人可读。',
    about_founder_title: 'Science Monitor 的创立',
    about_founder_desc: 'Science Monitor 由化学博士 Fredrik Mokvist 创立，他在制药和生命科学领域拥有丰富的领导经验。他在学术实验室和临床环境中的经历表明，研究追踪、理解和提炼工具亟需改进。',
    about_how_title: '工作原理',
    about_how_desc: '我们每天监测开放的科学注册库和数百万篇出版物。符合您兴趣的新研究会根据您选择的难度整理成清晰易读的摘要。',
    about_principles_title: '核心原则',
    about_p1_title: '证据与诚信',
    about_p1_desc: '我们只处理经过同行评审的学术成果。没有传闻或标题党，只有可验证的科学研究，并提供指向原始来源的直接链接。',
    about_p2_title: '语言无障碍',
    about_p2_desc: '科学研究面向全球发表，但知识也应以您的母语呈现，无需费力手动翻译。',
    about_p3_title: '从设计上保护隐私',
    about_p3_desc: '我们不出售个人数据，不在网络上追踪用户，也不通过广告获利。平台只为传递有价值的信息而存在。',
    about_contact_title: '联系我们',
    about_contact_desc: '有反馈、问题或合作想法？欢迎联系：',
    share_btn: '分享', share_copied: '已复制！', share_success: '已分享！', share_title: '分享摘要',
    share_footer: '在 Science Monitor 上了解更多：'
  }
};

const countryNamesByLanguage = {
  Norwegian: { se: "Sverige", no: "Norge", dk: "Danmark", fi: "Finland", gb: "Storbritannia", de: "Tyskland", fr: "Frankrike", nl: "Nederland", be: "Belgia", ch: "Sveits", at: "Østerrike", ie: "Irland", es: "Spania", it: "Italia", pt: "Portugal", us: "USA", ca: "Canada", in: "India", cn: "Kina", jp: "Japan" },
  Danish: { se: "Sverige", no: "Norge", dk: "Danmark", fi: "Finland", gb: "Storbritannien", de: "Tyskland", fr: "Frankrig", nl: "Nederlandene", be: "Belgien", ch: "Schweiz", at: "Østrig", ie: "Irland", es: "Spanien", it: "Italien", pt: "Portugal", us: "USA", ca: "Canada", in: "Indien", cn: "Kina", jp: "Japan" },
  Finnish: { se: "Ruotsi", no: "Norja", dk: "Tanska", fi: "Suomi", gb: "Yhdistynyt kuningaskunta", de: "Saksa", fr: "Ranska", nl: "Alankomaat", be: "Belgia", ch: "Sveitsi", at: "Itävalta", ie: "Irlanti", es: "Espanja", it: "Italia", pt: "Portugali", us: "Yhdysvallat", ca: "Kanada", in: "Intia", cn: "Kiina", jp: "Japani" },
  Italian: { se: "Svezia", no: "Norvegia", dk: "Danimarca", fi: "Finlandia", gb: "Regno Unito", de: "Germania", fr: "Francia", nl: "Paesi Bassi", be: "Belgio", ch: "Svizzera", at: "Austria", ie: "Irlanda", es: "Spagna", it: "Italia", pt: "Portogallo", us: "Stati Uniti", ca: "Canada", in: "India", cn: "Cina", jp: "Giappone" },
  French: { se: "Suède", no: "Norvège", dk: "Danemark", fi: "Finlande", gb: "Royaume-Uni", de: "Allemagne", fr: "France", nl: "Pays-Bas", be: "Belgique", ch: "Suisse", at: "Autriche", ie: "Irlande", es: "Espagne", it: "Italie", pt: "Portugal", us: "États-Unis", ca: "Canada", in: "Inde", cn: "Chine", jp: "Japon" },
  German: { se: "Schweden", no: "Norwegen", dk: "Dänemark", fi: "Finnland", gb: "Vereinigtes Königreich", de: "Deutschland", fr: "Frankreich", nl: "Niederlande", be: "Belgien", ch: "Schweiz", at: "Österreich", ie: "Irland", es: "Spanien", it: "Italien", pt: "Portugal", us: "USA", ca: "Kanada", in: "Indien", cn: "China", jp: "Japan" },
  Spanish: { se: "Suecia", no: "Noruega", dk: "Dinamarca", fi: "Finlandia", gb: "Reino Unido", de: "Alemania", fr: "Francia", nl: "Países Bajos", be: "Bélgica", ch: "Suiza", at: "Austria", ie: "Irlanda", es: "España", it: "Italia", pt: "Portugal", us: "Estados Unidos", ca: "Canadá", in: "India", cn: "China", jp: "Japón" },
  Portuguese: { se: "Suécia", no: "Noruega", dk: "Dinamarca", fi: "Finlândia", gb: "Reino Unido", de: "Alemanha", fr: "França", nl: "Países Baixos", be: "Bélgica", ch: "Suíça", at: "Áustria", ie: "Irlanda", es: "Espanha", it: "Itália", pt: "Portugal", us: "Estados Unidos", ca: "Canadá", in: "Índia", cn: "China", jp: "Japão" },
  Hindi: { se: "स्वीडन", no: "नॉर्वे", dk: "डेनमार्क", fi: "फ़िनलैंड", gb: "यूनाइटेड किंगडम", de: "जर्मनी", fr: "फ़्रांस", nl: "नीदरलैंड", be: "बेल्जियम", ch: "स्विट्ज़रलैंड", at: "ऑस्ट्रिया", ie: "आयरलैंड", es: "स्पेन", it: "इटली", pt: "पुर्तगाल", us: "संयुक्त राज्य अमेरिका", ca: "कनाडा", in: "भारत", cn: "चीन", jp: "जापान" },
  Mandarin: { se: "瑞典", no: "挪威", dk: "丹麦", fi: "芬兰", gb: "英国", de: "德国", fr: "法国", nl: "荷兰", be: "比利时", ch: "瑞士", at: "奥地利", ie: "爱尔兰", es: "西班牙", it: "意大利", pt: "葡萄牙", us: "美国", ca: "加拿大", in: "印度", cn: "中国", jp: "日本" }
};

for (const [language, messages] of Object.entries(supplementalTranslations)) {
  const countries = countryNamesByLanguage[language];
  const countryMessages = Object.fromEntries(
    Object.entries(countries).flatMap(([code, name]) => [
      [`country_${code}`, name],
      [`country_option_${code}`, name]
    ])
  );
  Object.assign(translations[language], messages, countryMessages);
}

for (const [language, messages] of Object.entries(completionTranslations)) {
  Object.assign(translations[language], messages);
}

const landingPageTranslations = {
  Swedish: {
    login_hero_badge: 'Forskningsöversikt på 30 sekunder',
    login_hero_headline: 'Världens forskning. Begriplig varje morgon.',
    login_hero_title1: 'Världens forskning.',
    login_hero_title2: 'Begriplig varje morgon.',
    login_hero_desc: 'Vi scannar öppna vetenskapliga arkiv och sammanfattar nya rön på ren svenska – anpassat efter din nivå och dina intressen.',
    login_hero_cta: 'Få sammanfattningar som denna varje morgon',
    login_trust_free_trial: 'Gratis att prova',
    login_trust_no_card: 'Inget betalkort krävs',
    login_trust_14_days: '14 dagars fri provperiod',
    login_card_ai_summary: 'AI-Sammanfattning',
    login_card_read_original: 'Läs originalstudie på Nature',
    login_card_peer_reviewed: 'Fackgranskad forskning',
    login_summary_heading_summary: 'Sammanfattning',
    login_summary_heading_context: 'Större sammanhang',
    login_summary_heading_results: 'Nyckelresultat'
  },
  English: {
    login_hero_badge: 'Research overview in 30 seconds',
    login_hero_headline: "The world's research. Understandable every morning.",
    login_hero_title1: "The world's research.",
    login_hero_title2: 'Understandable every morning.',
    login_hero_desc: 'We scan open scientific archives and summarize new findings in plain English – tailored to your level and your interests.',
    login_hero_cta: 'Get summaries like this every morning',
    login_trust_free_trial: 'Free to try',
    login_trust_no_card: 'No payment card required',
    login_trust_14_days: '14-day free trial',
    login_card_ai_summary: 'AI Summary',
    login_card_read_original: 'Read original study on Nature',
    login_card_peer_reviewed: 'Peer-reviewed research',
    login_summary_heading_summary: 'Summary',
    login_summary_heading_context: 'Broader context',
    login_summary_heading_results: 'Key results'
  },
  Norwegian: {
    login_hero_badge: 'Forskningsoversikt på 30 sekunder',
    login_hero_headline: 'Verdens forskning. Forståelig hver morgen.',
    login_hero_title1: 'Verdens forskning.',
    login_hero_title2: 'Forståelig hver morgen.',
    login_hero_desc: 'Vi skanner åpne vitenskapelige arkiver og oppsummerer nye funn på klart norsk – tilpasset ditt nivå og dine interesser.',
    login_hero_cta: 'Få sammendrag som dette hver morgen',
    login_trust_free_trial: 'Gratis å prøve',
    login_trust_no_card: 'Ingen betalingskort kreves',
    login_trust_14_days: '14 dagers gratis prøveperiode',
    login_card_ai_summary: 'AI-sammendrag',
    login_card_read_original: 'Les originalstudien på Nature',
    login_card_peer_reviewed: 'Fagfellevurdert forskning',
    login_summary_heading_summary: 'Sammendrag',
    login_summary_heading_context: 'Større sammenheng',
    login_summary_heading_results: 'Nøkkelresultater'
  },
  Danish: {
    login_hero_badge: 'Forskningsoverblik på 30 sekunder',
    login_hero_headline: 'Verdens forskning. Forståelig hver morgen.',
    login_hero_title1: 'Verdens forskning.',
    login_hero_title2: 'Forståelig hver morgen.',
    login_hero_desc: 'Vi scanner åbne videnskabelige arkiver og opsummerer nye resultater på klart dansk – tilpasset dit niveau og dine interesser.',
    login_hero_cta: 'Få resuméer som dette hver morgen',
    login_trust_free_trial: 'Gratis at prøve',
    login_trust_no_card: 'Intet betalingskort påkrævet',
    login_trust_14_days: '14 dages gratis prøveperiode',
    login_card_ai_summary: 'AI-resumé',
    login_card_read_original: 'Læs originalstudiet på Nature',
    login_card_peer_reviewed: 'Fagfællebedømt forskning',
    login_summary_heading_summary: 'Resumé',
    login_summary_heading_context: 'Større sammenhæng',
    login_summary_heading_results: 'Nøgleresultater'
  },
  Finnish: {
    login_hero_badge: 'Tutkimuskatsaus 30 sekunnissa',
    login_hero_headline: 'Maailman tutkimus. Ymmärrettävästi joka aamu.',
    login_hero_title1: 'Maailman tutkimus.',
    login_hero_title2: 'Ymmärrettävästi joka aamu.',
    login_hero_desc: 'Käymme läpi avoimet tieteelliset arkistot ja tiivistämme uudet tulokset selkeälle suomelle – tasosi ja kiinnostuksenkohteidesi mukaan.',
    login_hero_cta: 'Saa tällaisia tiivistelmiä joka aamu',
    login_trust_free_trial: 'Ilmainen kokeilu',
    login_trust_no_card: 'Maksukorttia ei tarvita',
    login_trust_14_days: '14 päivän ilmainen kokeilujakso',
    login_card_ai_summary: 'Tekoälytiivistelmä',
    login_card_read_original: 'Lue alkuperäinen tutkimus Naturessa',
    login_card_peer_reviewed: 'Vertaisarvioitu tutkimus',
    login_summary_heading_summary: 'Tiivistelmä',
    login_summary_heading_context: 'Laajempi konteksti',
    login_summary_heading_results: 'Keskeiset tulokset'
  },
  Italian: {
    login_hero_badge: 'Panoramica della ricerca in 30 secondi',
    login_hero_headline: 'La ricerca mondiale. Comprensibile ogni mattina.',
    login_hero_title1: 'La ricerca mondiale.',
    login_hero_title2: 'Comprensibile ogni mattina.',
    login_hero_desc: 'Analizziamo gli archivi scientifici aperti e sintetizziamo le nuove scoperte in un italiano chiaro, adattato al tuo livello e ai tuoi interessi.',
    login_hero_cta: 'Ricevi sintesi come questa ogni mattina',
    login_trust_free_trial: 'Prova gratuita',
    login_trust_no_card: 'Nessuna carta richiesta',
    login_trust_14_days: '14 giorni di prova gratuita',
    login_card_ai_summary: 'Sintesi IA',
    login_card_read_original: 'Leggi lo studio originale su Nature',
    login_card_peer_reviewed: 'Ricerca sottoposta a revisione paritaria',
    login_summary_heading_summary: 'Sintesi',
    login_summary_heading_context: 'Contesto più ampio',
    login_summary_heading_results: 'Risultati chiave'
  },
  French: {
    login_hero_badge: 'Aperçu de la recherche en 30 secondes',
    login_hero_headline: 'La recherche mondiale. Accessible chaque matin.',
    login_hero_title1: 'La recherche mondiale.',
    login_hero_title2: 'Accessible chaque matin.',
    login_hero_desc: 'Nous analysons les archives scientifiques ouvertes et résumons les nouvelles découvertes dans un français clair – adapté à votre niveau et à vos centres d’intérêt.',
    login_hero_cta: 'Recevez des résumés comme celui-ci chaque matin',
    login_trust_free_trial: 'Essai gratuit',
    login_trust_no_card: 'Aucune carte bancaire requise',
    login_trust_14_days: 'Essai gratuit de 14 jours',
    login_card_ai_summary: 'Résumé IA',
    login_card_read_original: 'Lire l’étude originale sur Nature',
    login_card_peer_reviewed: 'Recherche évaluée par les pairs',
    login_summary_heading_summary: 'Résumé',
    login_summary_heading_context: 'Contexte général',
    login_summary_heading_results: 'Résultats clés'
  },
  German: {
    login_hero_badge: 'Forschungsüberblick in 30 Sekunden',
    login_hero_headline: 'Die Forschung der Welt. Jeden Morgen verständlich.',
    login_hero_title1: 'Die Forschung der Welt.',
    login_hero_title2: 'Jeden Morgen verständlich.',
    login_hero_desc: 'Wir durchsuchen offene wissenschaftliche Archive und fassen neue Erkenntnisse in klarem Deutsch zusammen – angepasst an dein Niveau und deine Interessen.',
    login_hero_cta: 'Erhalte jeden Morgen Zusammenfassungen wie diese',
    login_trust_free_trial: 'Kostenlos testen',
    login_trust_no_card: 'Keine Zahlungskarte erforderlich',
    login_trust_14_days: '14 Tage kostenlos testen',
    login_card_ai_summary: 'KI-Zusammenfassung',
    login_card_read_original: 'Originalstudie auf Nature lesen',
    login_card_peer_reviewed: 'Begutachtete Forschung',
    login_summary_heading_summary: 'Zusammenfassung',
    login_summary_heading_context: 'Größerer Zusammenhang',
    login_summary_heading_results: 'Wichtigste Ergebnisse'
  },
  Spanish: {
    login_hero_badge: 'Resumen de investigación en 30 segundos',
    login_hero_headline: 'La investigación mundial. Comprensible cada mañana.',
    login_hero_title1: 'La investigación mundial.',
    login_hero_title2: 'Comprensible cada mañana.',
    login_hero_desc: 'Exploramos archivos científicos abiertos y resumimos los nuevos hallazgos en un español claro, adaptado a tu nivel y a tus intereses.',
    login_hero_cta: 'Recibe resúmenes como este cada mañana',
    login_trust_free_trial: 'Prueba gratuita',
    login_trust_no_card: 'No se requiere tarjeta',
    login_trust_14_days: '14 días de prueba gratuita',
    login_card_ai_summary: 'Resumen IA',
    login_card_read_original: 'Leer el estudio original en Nature',
    login_card_peer_reviewed: 'Investigación revisada por pares',
    login_summary_heading_summary: 'Resumen',
    login_summary_heading_context: 'Contexto general',
    login_summary_heading_results: 'Resultados clave'
  },
  Portuguese: {
    login_hero_badge: 'Resumo de investigação em 30 segundos',
    login_hero_headline: 'A investigação mundial. Compreensível todas as manhãs.',
    login_hero_title1: 'A investigação mundial.',
    login_hero_title2: 'Compreensível todas as manhãs.',
    login_hero_desc: 'Analisamos arquivos científicos abertos e resumimos novas descobertas em português claro – adaptado ao seu nível e aos seus interesses.',
    login_hero_cta: 'Receba resumos como este todas as manhãs',
    login_trust_free_trial: 'Grátis para experimentar',
    login_trust_no_card: 'Não requer cartão de pagamento',
    login_trust_14_days: '14 dias de avaliação gratuita',
    login_card_ai_summary: 'Resumo de IA',
    login_card_read_original: 'Ler o estudo original na Nature',
    login_card_peer_reviewed: 'Investigação revista por pares',
    login_summary_heading_summary: 'Resumo',
    login_summary_heading_context: 'Contexto mais amplo',
    login_summary_heading_results: 'Principais resultados'
  },
  Hindi: {
    login_hero_badge: '30 सेकंड में शोध अवलोकन',
    login_hero_headline: 'दुनिया का शोध। हर सुबह आसान भाषा में।',
    login_hero_title1: 'दुनिया का शोध।',
    login_hero_title2: 'हर सुबह आसान भाषा में।',
    login_hero_desc: 'हम खुले वैज्ञानिक अभिलेखागारों को स्कैन करते हैं और नई खोजों को सरल हिंदी में प्रस्तुत करते हैं – आपके स्तर और आपकी रुचियों के अनुरूप।',
    login_hero_cta: 'हर सुबह ऐसे सारांश प्राप्त करें',
    login_trust_free_trial: 'मुफ़्त में आज़माएँ',
    login_trust_no_card: 'भुगतान कार्ड की आवश्यकता नहीं',
    login_trust_14_days: '14 दिनों का मुफ़्त ट्रायल',
    login_card_ai_summary: 'AI सारांश',
    login_card_read_original: 'Nature पर मूल अध्ययन पढ़ें',
    login_card_peer_reviewed: 'सहकर्मी-समीक्षित शोध',
    login_summary_heading_summary: 'सारांश',
    login_summary_heading_context: 'व्यापक संदर्भ',
    login_summary_heading_results: 'मुख्य परिणाम'
  },
  Mandarin: {
    login_hero_badge: '30 秒了解前沿研究',
    login_hero_headline: '全球科研成果。每天清晨轻松读懂。',
    login_hero_title1: '全球科研成果。',
    login_hero_title2: '每天清晨轻松读懂。',
    login_hero_desc: '我们扫描开放的科学文献库，用清晰易懂的中文总结最新发现——根据您的专业程度与兴趣量身定制。',
    login_hero_cta: '每天清晨获取这样的研究摘要',
    login_trust_free_trial: '免费试用',
    login_trust_no_card: '无需绑定银行卡',
    login_trust_14_days: '14 天免费试用期',
    login_card_ai_summary: 'AI 摘要',
    login_card_read_original: '在 Nature 阅读原始研究',
    login_card_peer_reviewed: '同行评审研究',
    login_summary_heading_summary: '研究摘要',
    login_summary_heading_context: '研究背景与意义',
    login_summary_heading_results: '关键结果'
  }
};

for (const [language, messages] of Object.entries(landingPageTranslations)) {
  if (translations[language]) {
    Object.assign(translations[language], messages);
  }
}

const sharedArticleTranslations = {
  Swedish: {
    shared_cta_try_free: 'Prova gratis',
    shared_loading: 'Laddar sammanfattning...',
    shared_not_found_title: 'Artikeln kunde inte hittas',
    shared_not_found_desc: 'Länken kan vara felaktig eller så är artikeln inte längre tillgänglig.',
    shared_back_home: 'Till startsidan',
    shared_banner_title: 'Få fackgranskad forskning sammanfattad varje morgon',
    shared_banner_desc: 'Bevaka dina favoritämnen, forskare och tidskrifter på ren svenska. Prova gratis i 14 dagar – inget betalkort krävs.',
    shared_banner_cta: 'Prova gratis i 14 dagar'
  },
  English: {
    shared_cta_try_free: 'Try for free',
    shared_loading: 'Loading summary...',
    shared_not_found_title: 'Article not found',
    shared_not_found_desc: 'The link may be invalid or the article is no longer available.',
    shared_back_home: 'Go to homepage',
    shared_banner_title: 'Get peer-reviewed research summarized every morning',
    shared_banner_desc: 'Monitor your favorite topics, authors, and journals in plain English. Try free for 14 days – no credit card required.',
    shared_banner_cta: 'Start 14-day free trial'
  },
  Norwegian: {
    shared_cta_try_free: 'Prøv gratis',
    shared_loading: 'Laster sammendrag...',
    shared_not_found_title: 'Artikkelen ble ikke funnet',
    shared_not_found_desc: 'Lenken kan være ugyldig eller artikkelen er ikke lenger tilgjengelig.',
    shared_back_home: 'Til forsiden',
    shared_banner_title: 'Få fagfellevurdert forskning oppsummert hver morgen',
    shared_banner_desc: 'Overvåk dine favorittemner, forskere og tidsskrifter på klart norsk. Prøv gratis i 14 dager – ingen betalingskort kreves.',
    shared_banner_cta: 'Prøv gratis i 14 dager'
  },
  Danish: {
    shared_cta_try_free: 'Prøv gratis',
    shared_loading: 'Indlæser resumé...',
    shared_not_found_title: 'Artiklen blev ikke fundet',
    shared_not_found_desc: 'Linket kan være ugyldigt, eller artiklen er ikke længere tilgængelig.',
    shared_back_home: 'Til forsiden',
    shared_banner_title: 'Få fagfællebedømt forskning opsummeret hver morgen',
    shared_banner_desc: 'Overvåg dine yndlingsemner, forskere og tidsskrifter på klart dansk. Prøv gratis i 14 dage – intet betalingskort påkrævet.',
    shared_banner_cta: 'Prøv gratis i 14 dage'
  },
  Finnish: {
    shared_cta_try_free: 'Kokeile ilmaiseksi',
    shared_loading: 'Ladataan tiivistelmää...',
    shared_not_found_title: 'Artikkelia ei löytynyt',
    shared_not_found_desc: 'Linkki voi olla virheellinen tai artikkeli ei ole enää saatavilla.',
    shared_back_home: 'Etusivulle',
    shared_banner_title: 'Saat vertaisarvioidun tutkimuksen tiivistettynä joka aamu',
    shared_banner_desc: 'Seuraa suosikkiaiheitasi, tutkijoita ja julkaisuja selkeällä suomella. Kokeile ilmaiseksi 14 päivää – maksukorttia ei tarvita.',
    shared_banner_cta: 'Kokeile ilmaiseksi 14 päivää'
  },
  Italian: {
    shared_cta_try_free: 'Prova gratis',
    shared_loading: 'Caricamento della sintesi...',
    shared_not_found_title: 'Articolo non trovato',
    shared_not_found_desc: 'Il link potrebbe non essere valido o l’articolo non è più disponibile.',
    shared_back_home: 'Vai alla pagina iniziale',
    shared_banner_title: 'Ricevi la ricerca scientifica sintetizzata ogni mattina',
    shared_banner_desc: 'Monitora i tuoi argomenti, autori e riviste preferiti in un italiano chiaro. Prova gratis per 14 giorni – nessuna carta richiesta.',
    shared_banner_cta: 'Inizia la prova gratuita di 14 giorni'
  },
  French: {
    shared_cta_try_free: 'Essayer gratuitement',
    shared_loading: 'Chargement du résumé...',
    shared_not_found_title: 'Article introuvable',
    shared_not_found_desc: 'Le lien est peut-être invalide ou l’article n’est plus disponible.',
    shared_back_home: 'Retour à l’accueil',
    shared_banner_title: 'Recevez la recherche évaluée par les pairs résumée chaque matin',
    shared_banner_desc: 'Suivez vos sujets, auteurs et revues préférés dans un français clair. Essai gratuit de 14 jours – sans carte bancaire.',
    shared_banner_cta: 'Essayer gratuitement pendant 14 jours'
  },
  German: {
    shared_cta_try_free: 'Kostenlos testen',
    shared_loading: 'Zusammenfassung wird geladen...',
    shared_not_found_title: 'Artikel nicht gefunden',
    shared_not_found_desc: 'Der Link ist möglicherweise ungültig oder der Artikel ist nicht mehr verfügbar.',
    shared_back_home: 'Zur Startseite',
    shared_banner_title: 'Erhalte begutachtete Forschung jeden Morgen zusammengefasst',
    shared_banner_desc: 'Verfolge deine Lieblingsthemen, Forschenden und Fachzeitschriften in klarem Deutsch. 14 Tage kostenlos testen – keine Zahlungskarte erforderlich.',
    shared_banner_cta: '14 Tage kostenlos testen'
  },
  Spanish: {
    shared_cta_try_free: 'Prueba gratis',
    shared_loading: 'Cargando resumen...',
    shared_not_found_title: 'Artículo no encontrado',
    shared_not_found_desc: 'El enlace puede no ser válido o el artículo ya no está disponible.',
    shared_back_home: 'Ir al inicio',
    shared_banner_title: 'Recibe investigación revisada por pares resumida cada mañana',
    shared_banner_desc: 'Sigue tus temas, autores y revistas favoritos en un español claro. Prueba gratis durante 14 días, sin tarjeta de crédito.',
    shared_banner_cta: 'Empezar prueba gratuita de 14 días'
  },
  Portuguese: {
    shared_cta_try_free: 'Experimentar grátis',
    shared_loading: 'A carregar resumo...',
    shared_not_found_title: 'Artigo não encontrado',
    shared_not_found_desc: 'A ligação pode ser inválida ou o artigo já não está disponível.',
    shared_back_home: 'Ir para a página inicial',
    shared_banner_title: 'Receba investigação revista por pares resumida todas as manhãs',
    shared_banner_desc: 'Acompanhe os seus temas, autores e revistas favoritos em português claro. Experimente grátis durante 14 dias – sem cartão de pagamento.',
    shared_banner_cta: 'Experimentar grátis durante 14 dias'
  },
  Hindi: {
    shared_cta_try_free: 'मुफ़्त में आज़माएँ',
    shared_loading: 'सारांश लोड हो रहा है...',
    shared_not_found_title: 'लेख नहीं मिला',
    shared_not_found_desc: 'हो सकता है कि लिंक अमान्य हो या लेख अब उपलब्ध न हो।',
    shared_back_home: 'मुखपृष्ठ पर जाएँ',
    shared_banner_title: 'हर सुबह सहकर्मी-समीक्षित शोध का सारांश प्राप्त करें',
    shared_banner_desc: 'सरल हिंदी में अपने पसंदीदा विषयों, शोधकर्ताओं और पत्रिकाओं पर नज़र रखें। 14 दिनों के लिए मुफ़्त आज़माएँ – किसी कार्ड की आवश्यकता नहीं।',
    shared_banner_cta: '14 दिनों का मुफ़्त ट्रायल शुरू करें'
  },
  Mandarin: {
    shared_cta_try_free: '免费试用',
    shared_loading: '正在加载摘要...',
    shared_not_found_title: '未找到文章',
    shared_not_found_desc: '链接可能无效，或者该文章已不再可用。',
    shared_back_home: '返回首页',
    shared_banner_title: '每天清晨获取同行评审研究的精炼摘要',
    shared_banner_desc: '用清晰易懂的中文追踪您喜爱的科研主题、学者和期刊。免费试用 14 天——无需绑定银行卡。',
    shared_banner_cta: '开启 14 天免费试用'
  }
};

for (const [language, messages] of Object.entries(sharedArticleTranslations)) {
  if (translations[language]) {
    Object.assign(translations[language], messages);
  }
}

export const t = (language, key, params = {}) => {
  const translation =
    translations[language]?.[key] ??
    translations.English?.[key] ??
    translations.Swedish?.[key] ??
    key;

  return typeof translation === 'string'
    ? translation.replace(/\{(\w+)\}/g, (placeholder, name) => (
      Object.prototype.hasOwnProperty.call(params, name)
        ? String(params[name])
        : placeholder
    ))
    : translation;
};